(function() {
    'use strict';

    angular
        .module('papp', [
            'ngStorage',
            'ngResource',
            'ngCookies',
            'ngAria',
            'ngCacheBuster',
            'ngFileUpload',
            'ui.bootstrap',
            'ui.toggle',
            'ui.bootstrap.datetimepicker',
            'ui.router',
            'infinite-scroll',
            'angular-loading-bar'
        ])
        .run(run);

    run.$inject = ['stateHandler'];

    function run(stateHandler) {
        stateHandler.initialize();
    }
})();

(function () {
    "use strict";

    angular.module("papp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider.state("transaction", {
            parent: "app",
            url: "/transaction?page?status?date",
            data: {
                authorities: ["bilioslo-admin", "bilioslo-admin-lese"],
            },
            views: {
                "content@": {
                    templateUrl: "app/transaction/transaction.html",
                    controller: "TransactionController",
                    controllerAs: "vm",
                },
            },
        });
    }
})();

(function () {
    "use strict";

    angular
        .module("papp")
        .controller("TransactionController", TransactionController);

    TransactionController.$inject = [
        "PspJob",
        "$state",
        "$stateParams",
        "DateUtils",
    ];

    function TransactionController(PspJob, $state, $stateParams, DateUtils) {
        var vm = this;
        var page = 1;
        var status = null;
        var date = null;

        vm.numberOfPages = 1;

        vm.jobs = [];

        vm.prevPage = prevPage;
        vm.nextPage = nextPage;
        vm.firstPage = firstPage;
        vm.lastPage = lastPage;
        vm.search = search;
        vm.clearSearch = clearSearch;
        vm.showTransaction = showTransaction;
        vm.openDateDatePicker = openDateDatePicker;

        vm.statuses = [
            {
                value: "failed",
                label: "Feilet",
            },
            {
                value: "failed_card",
                label: "Feilet kort",
            },
            {
                value: "failing",
                label: "Feilende",
            },
            {
                value: "pending",
                label: "Venter",
            },
            {
                value: "attempt_in_progress_cit",
                label: "Forsøkes av kunde",
            },
            {
                value: "attempt_in_progress_mit",
                label: "Forsøkes av service",
            },
            {
                value: "not_available",
                label: "Utilgjengelig",
            },
            {
                value: "terminal_sent",
                label: "Sendt til terminal",
            },
            {
                value: "processed",
                label: "OK",
            },
        ];

        function prevPage() {
            toState(page - 1);
        }

        function nextPage() {
            toState(page + 1);
        }

        function firstPage() {
            toState(0);
        }

        function lastPage() {
            toState(vm.numberOfPages);
        }

        function toState(toPage) {
            $state.go("transaction", {
                page: toPage,
                status: status ? status.value : null,
                date: date ? DateUtils.convertLocalDateToServer(date) : null,
            });
        }

        function search() {
            $state.go("transaction", {
                page: 1,
                status: vm.statusInput ? vm.statusInput.value : null,
                date: vm.dateInput
                    ? DateUtils.convertLocalDateToServer(vm.dateInput)
                    : null,
            });
        }

        function clearSearch() {
            vm.statusInput = null;
            vm.dateInput = null;
            vm.toDateInput = null;

            $state.go("transaction", {
                page: 1,
                status: null,
                date: null,
            });
        }

        vm.dateOptions = {
            formatYear: "yy",
            startingDay: 1,
        };

        vm.datePopupDatePicker = {
            opened: false,
        };

        function openDateDatePicker() {
            vm.datePopupDatePicker.opened = true;
        }

        function showTransaction(transaction) {
            $state.go("transactionDetails", {
                id: transaction.id,
            });
        }

        page = parseInt($stateParams.page, 10);
        if (!page) {
            page = 1;
        }

        if ($stateParams.status) {
            angular.forEach(vm.statuses, function (value, key) {
                if (value.value == $stateParams.status) {
                    status = value;
                }
            });
        }
        if ($stateParams.date) date = new Date($stateParams.date);

        vm.dateInput = date;
        vm.statusInput = status;

        PspJob.query(
            {
                page: page,
                type: "SALE",
                status: status ? status.value : null,
                date: date ? DateUtils.convertLocalDateToServer(date) : null,
            },
            function (result) {
                vm.jobs = result.pspJobs;

                vm.pagination = {
                    page: page,
                    total: result.total,
                    itemsPerPage: result.itemsPerPage,
                };

                vm.numberOfPages =
                    result.itemsPerPage != 0
                        ? Math.ceil(result.total / result.itemsPerPage)
                        : 0;
            }
        );
    }
})(window.angular);

(function () {
    "use strict";

    angular.module("papp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider.state("transactionDetails", {
            parent: "app",
            url: "/transaction/details/:id",
            data: {
                authorities: ["bilioslo-admin", "bilioslo-admin-lese"],
            },
            views: {
                "content@": {
                    templateUrl:
                        "app/transaction/details/transaction.details.html",
                    controller: "TransactionDetailsController",
                    controllerAs: "vm",
                },
            },
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('papp')
        .controller('TransactionDetailsController', TransactionDetailsController);

    TransactionDetailsController.$inject = ['PspJob', 'Transaction', '$stateParams'];

    function TransactionDetailsController(PspJob, Transaction, $stateParams) {
        var vm = this;
        var transactionPage = 1;

        vm.isFirstTransactionPage = true;
        vm.isLastTransactionPage = true;

        vm.load = load;
        vm.prevTransactionPage = prevTransactionPage;
        vm.nextTransactionPage = nextTransactionPage;

        vm.load($stateParams.id);

        function prevTransactionPage() {
            transactionPage = transactionPage - 1;
            queryTransactions();
        }

        function nextTransactionPage() {
            transactionPage = transactionPage + 1;
            queryTransactions();
        }

        function queryTransactions() {
            Transaction.query({
                jobId: $stateParams.id,
                page: transactionPage
            }, function (result) {
                vm.transactions = result.transactions;
                vm.isFirstTransactionPage = transactionPage <= 1;
                vm.isLastTransactionPage = result.page * result.itemsPerPage >= result.total;
            });
        }

        function load(id) {
            PspJob.get({id: id}, function(result) {
                vm.job = result;
            });

            queryTransactions();
        }
    }
})();

(function () {
    "use strict";

    angular.module("papp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider.state("studdedTire", {
            parent: "app",
            url: "/studded-tire?page&plateNumber&email&dateStart",
            data: {
                authorities: ["bilioslo-admin", "bilioslo-admin-lese"],
            },
            views: {
                "content@": {
                    templateUrl: "app/studded-tire/studded-tire.html",
                    controller: "StuddedTireController",
                    controllerAs: "vm",
                },
            },
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('papp')
        .controller('StuddedTireController', StuddedTireController);

    StuddedTireController.$inject = ['StuddedTire', '$state', '$stateParams', 'DateUtils'];

    function StuddedTireController(StuddedTire, $state, $stateParams, DateUtils) {
        var vm = this;
        var page = 1;
        var plateNumber = null;
        var dateStart = null;
        var email = null;
        
        vm.numberOfPages = 1;
        
        vm.studdedTires = [];

        vm.plateNumberInput = null;
        vm.emailInput = null;
        vm.dateStartInput = null;

        vm.prevPage = prevPage;
        vm.nextPage = nextPage;
        vm.firstPage = firstPage;
        vm.lastPage = lastPage;
        vm.search = search;
        vm.clearSearch = clearSearch;
        vm.showStuddedTire = showStuddedTire;
        vm.openDatePicker = openDatePicker;

        function prevPage() {
            toState(page - 1);
        }

        function nextPage() {
            toState(page + 1);
        }

        function firstPage() {
            toState(0);
        }

        function lastPage() {
            toState(vm.numberOfPages);
        }

        function toState(toPage){
            $state.go('studdedTire', {
                page: toPage,
                plateNumber: plateNumber,
                email: email,
                dateStart: (dateStart ? DateUtils.convertLocalDateToServer(dateStart) : null)
            });
        } 

        function search() {
            $state.go('studdedTire', {
                page: 1,
                plateNumber: (vm.plateNumberInput ? vm.plateNumberInput.toUpperCase() : null),
                email: (vm.emailInput ? vm.emailInput.toLowerCase() : null),
                dateStart: (vm.dateStartInput ? DateUtils.convertLocalDateToServer(vm.dateStartInput) : null)
            });
        }

        function clearSearch() {
            vm.plateNumberInput = null;
            vm.emailInput = null;
            vm.dateStartInput = null;

            $state.go('studdedTire', {
                page: 1,
                plateNumber: null,
                email: null,
                dateStart: null
            });
        }

        function showStuddedTire(studdedTire) {
            $state.go('studdedTireDetails', {
                id: studdedTire.id
            });
        }

        page = parseInt($stateParams.page, 10);
        if (!page) {
            page = 1;
        }

        plateNumber = $stateParams.plateNumber;
        email = $stateParams.email;
        if ($stateParams.dateStart)
            dateStart = new Date($stateParams.dateStart);

        vm.plateNumberInput = plateNumber;
        vm.emailInput = email;
        vm.dateStartInput = dateStart;

        vm.dateOptions = {
            formatYear: 'yy',
            startingDay: 1
        };

        vm.popupDatePicker = {
            opened: false
        };

        function openDatePicker() {
            vm.popupDatePicker.opened = true;
        }

        StuddedTire.query({
            page: page,
            plateNumber: plateNumber,
            email: email,
            dateStart: (dateStart ? DateUtils.convertLocalDateToServer(dateStart) : null)
        }, function (result) {
            vm.studdedTires = result.studdedTires;
            plateNumber = result.plateNumber;
            email = result.email;
            
            vm.pagination = {
                page: page,
                total: result.total,
                itemsPerPage: result.itemsPerPage
            };

            vm.numberOfPages = result.itemsPerPage != 0 ? Math.ceil(result.total / result.itemsPerPage) : 0;
        });
    }
})(window.angular);

(function () {
    "use strict";

    angular.module("papp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider.state("studdedTireDetails", {
            parent: "app",
            url: "/studded-tire/details/:id",
            data: {
                authorities: ["bilioslo-admin", "bilioslo-admin-lese"],
            },
            views: {
                "content@": {
                    templateUrl:
                        "app/studded-tire/details/studded-tire.details.html",
                    controller: "StuddedTireDetailsController",
                    controllerAs: "vm",
                },
            },
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('papp')
        .controller('StuddedTireDetailsController', StuddedTireDetailsController);

    StuddedTireDetailsController.$inject = ['StuddedTire', '$stateParams'];

    function StuddedTireDetailsController(StuddedTire, $stateParams) {
        var vm = this;

        vm.load = load;
        vm.studdedTireDetail = {};

        vm.load($stateParams.id);

        function load (id) {
            StuddedTire.get({id: id}, function(result) {
                vm.studdedTireDetail = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('papp')
        .factory('Transaction', Transaction);

    Transaction.$inject = ['$resource', 'URL_BIL_I_OSLO_SERVICE'];

    function Transaction ($resource, URL_BIL_I_OSLO_SERVICE) {
        return $resource(URL_BIL_I_OSLO_SERVICE + 'api/Admin/Transaction', {}, {
            'query': {method: 'GET', isArray: false}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('papp')
        .factory('StuddedTire', StuddedTire);

    StuddedTire.$inject = ['$resource', 'URL_BIL_I_OSLO_SERVICE'];

    function StuddedTire ($resource, URL_BIL_I_OSLO_SERVICE) {
        return $resource(URL_BIL_I_OSLO_SERVICE + 'api/Admin/StuddedTire/:id', {}, {
            'query': {method: 'GET', isArray: false},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('papp')
        .factory('PspJob', PspJob);

    PspJob.$inject = ['$resource', 'URL_BIL_I_OSLO_SERVICE'];

    function PspJob($resource, URL_BIL_I_OSLO_SERVICE) {
        return $resource(URL_BIL_I_OSLO_SERVICE + 'api/Admin/PspJob/:id', {}, {
            'query': {method: 'GET', isArray: false},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('papp')
        .factory('Price', Price);

    Price.$inject = ['$resource', 'DateUtils', 'URL_BIL_I_OSLO_SERVICE'];

    function Price($resource, DateUtils, URL_BIL_I_OSLO_SERVICE) {
        var service = {};

        service.parking = $resource(URL_BIL_I_OSLO_SERVICE + 'api/Admin/ParkingPriceGroup/:id', {}, {
            'getPrices': {
                method: 'GET', isArray: false
            }
        });

        service.studdedTire = $resource(URL_BIL_I_OSLO_SERVICE + 'api/Admin/StuddedTirePrice', {}, {
            'query': {method: 'GET', isArray: true},
            'getStuddedTirePrices': {
                method: 'GET', isArray: true,
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    angular.forEach(data, function (value) {
                        value.buyFrom = DateUtils.convertLocalDateFromServer(value.buyFrom);
                        value.buyTo = DateUtils.convertLocalDateFromServer(value.buyTo);
                    });
                    return data;
                }
            },
            'save': {method: 'POST'},
            'update': {method: 'PUT'},
            'delete': {method: 'DELETE'}
        });

        service.season = $resource(URL_BIL_I_OSLO_SERVICE + 'api/Admin/StuddedTirePrice/Season', {}, {
            'query': {method: 'GET', isArray: true},
            'getSeason': {
                method: 'GET', isArray: false,
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'save': {method: 'POST'},
            'update': {method: 'PUT'},
            'delete': {method: 'DELETE'}
        });

        function post(data) {
            return $http.post(URL_BIL_I_OSLO_SERVICE + 'api/Admin/ParkingPriceGroup', data, {}).success(function (response) {
                console.log('success from prices post');
                return response;
            });
        }

        return service;
    }
})();

(function () {
    "use strict";

    angular.module("papp").factory("Parking", Parking);

    Parking.$inject = ["$resource", "URL_BIL_I_OSLO_SERVICE"];

    function Parking($resource, URL_BIL_I_OSLO_SERVICE) {
        return $resource(
            URL_BIL_I_OSLO_SERVICE + "api/Admin/Parking/:id",
            {},
            {
                query: { method: "GET", isArray: false },
                get: {
                    method: "GET",
                    transformResponse: function (data) {
                        data = angular.fromJson(data);
                        return data;
                    },
                },
            }
        );
    }
})();

(function () {
    'use strict';

    angular
        .module('papp')
        .factory('NotificationMessage', NotificationMessage);

    NotificationMessage.$inject = ['$resource', '$filter', 'DateUtils'];

    function NotificationMessage($resource, $filter, DateUtils) {
        var service = {};

        var weekdays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
        var dieselStartTimeNo = "kl 06.00";
        var dieselEndTimeNo = "kl 22.00";
        var dieselStartTimeEn = "6.00 am";
        var dieselEndTimeEn = "10.00 pm";

        var ifEndDateTextNo = "til";
        var ifEndDateTextEn = "to";
        var ifNoEndDateTextNo = "inntil videre";
        var ifNoEndDateTextEn = "until further notice";

        var afterMessageTextNo = "Les mer";
        var afterMessageTextEn = "More";

        var dateTimeFormatNo = "EEEE dd.MM 'kl' HH.mm";
        var dateTimeFormatEn = "dd.MM h.mm";

        var defaultStartHour = "6";
        var defaultStopHour = "22";
        var defaultMin = "00"
        var defaultDayNo = "xxxdag";
        var defaultDayEn = "Xxxday";


        service.createEndOfMessageStartNo = createEndOfMessageStartNo;
        service.createEndOfMessageStartEn = createEndOfMessageStartEn;
        service.createEndOfMessageStopNo = createEndOfMessageStopNo;
        service.createEndOfMessageStopEn = createEndOfMessageStopEn;

        service.createEndOfBoardFirstMessageStartNo = createEndOfBoardFirstMessageStartNo;
        service.createEndOfBoardFirstMessageStartEn = createEndOfBoardFirstMessageStartEn;
        service.createEndOfBoardFirstMessageStopNo = createEndOfBoardFirstMessageStopNo;
        service.createEndOfBoardFirstMessageStopEn = createEndOfBoardFirstMessageStopEn;

        service.createEndOfComposedMessageStartNo = createEndOfComposedMessageStartNo;
        service.createEndOfComposedMessageStartEn = createEndOfComposedMessageStartEn;
        service.createEndOfComposedMessageStopNo = createEndOfComposedMessageStopNo;
        service.createEndOfComposedMessageStopEn = createEndOfComposedMessageStopEn;


        function createEndOfMessageStartNo(fromDate, fromHour, fromMin) {
            fromHour = (fromHour == null ? defaultStartHour : fromHour)
            fromMin = (fromMin == null ? defaultMin : fromMin)
            return formatDateTimeNo(fromDate, fromHour, fromMin) + ". " + afterMessageTextNo;
        }
        function createEndOfMessageStartEn(fromDate, fromHour, fromMin) {
            fromHour = (fromHour == null ? defaultStartHour : fromHour)
            fromMin = (fromMin == null ? defaultMin : fromMin)
            return formatDateTimeEn(fromDate, fromHour, fromMin) + ". " + afterMessageTextEn;
        }
        function createEndOfMessageStopNo(fromDate, fromHour, fromMin) {
            fromHour = (fromHour == null ? defaultStopHour : fromHour)
            fromMin = (fromMin == null ? defaultMin : fromMin)
            return formatDateTimeNo(fromDate, fromHour, fromMin) + ". " + afterMessageTextNo;
        }
        function createEndOfMessageStopEn(fromDate, fromHour, fromMin) {
            fromHour = (fromHour == null ? defaultStopHour : fromHour)
            fromMin = (fromMin == null ? defaultMin : fromMin)
            return formatDateTimeEn(fromDate, fromHour, fromMin) + ". " + afterMessageTextEn;
        }

        function createEndOfBoardFirstMessageStartNo(fromDate, fromHour, fromMin) {
            fromHour = (fromHour == null ? defaultStartHour : fromHour)
            fromMin = (fromMin == null ? defaultMin : fromMin)
            return "Fra: " + formatDateTimeNo(fromDate, fromHour, fromMin) + " og inntil videre.\n";
        }
        function createEndOfBoardFirstMessageStartEn(fromDate, fromHour, fromMin) {
            fromHour = (fromHour == null ? defaultStartHour : fromHour)
            fromMin = (fromMin == null ? defaultMin : fromMin)
            return "Start: " + formatDateTimeEn(fromDate, fromHour, fromMin) + " until further notice.\n";
        }
        function createEndOfBoardFirstMessageStopNo(fromDate, fromHour, fromMin) {
            fromHour = (fromHour == null ? defaultStopHour : fromHour)
            fromMin = (fromMin == null ? defaultMin : fromMin)
            return formatDateTimeNo(fromDate, fromHour, fromMin) + ".";
        }
        function createEndOfBoardFirstMessageStopEn(fromDate, fromHour, fromMin) {
            fromHour = (fromHour == null ? defaultStopHour : fromHour)
            fromMin = (fromMin == null ? defaultMin : fromMin)
            return formatDateTimeEn(fromDate, fromHour, fromMin) + ".";
        }


        function createEndOfComposedMessageStartNo() {
            return formatDateTimeNo(null, defaultStartHour, defaultMin) + ". " + afterMessageTextNo;
        }
        function createEndOfComposedMessageStartEn() {
            return formatDateTimeEn(null, defaultStartHour, defaultMin) + ". " + afterMessageTextEn;
        }
        function createEndOfComposedMessageStopNo() {
            return formatDateTimeNo(null, defaultStopHour, defaultMin) + ". " + afterMessageTextNo;
        }
        function createEndOfComposedMessageStopEn() {
            return formatDateTimeEn(null, defaultStopHour, defaultMin) + ". " + afterMessageTextEn;
        }

        function formatDateTimeNo(date, hour, min, defaultHour) {
            if (date == null) {
                var tempDate = new Date(2017, 1, 1, hour, min, 0);
                return "xxxdag dd.mm kl " + $filter('date')(tempDate, 'HH:mm');
            }
            date.setHours(hour);
            date.setMinutes(min);
            return $filter('date')(date, dateTimeFormatNo);
        }

        function formatDateTimeEn(date, hour, min, defaultHour) {
            if (date == null) {
                var tempDate = new Date(2017, 1, 1, hour, min, 0);
                return "Xxxday dd.mm " + $filter('date')(tempDate, 'h:mm') + " " + $filter('date')(tempDate, 'a').replace('.','').replace('.','');
            }
            date.setHours(hour);
            date.setMinutes(min);
            return weekdays[date.getDay()] + " " + $filter('date')(date, dateTimeFormatEn) + " " + $filter('date')(date, 'a').replace('.','').replace('.','');
        }

        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('papp')
        .factory('Notification', Notification);

    Notification.$inject = ['$resource', 'URL_BIL_I_OSLO_SERVICE'];

    function Notification($resource, URL_BIL_I_OSLO_SERVICE) {
        var service = {};

        service.dieselMessages = $resource(URL_BIL_I_OSLO_SERVICE + 'api/Admin/SimpleNotificationService/Diesel/DefaultMessage', {}, {
            'query': {method: 'GET', isArray: true},
            'getDieselMessages': {
                method: 'GET', isArray: true,
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'save': {method: 'POST'},
            'update': {method: 'PUT'},
            'delete': {method: 'DELETE'}
        });

        service.notifications = $resource(URL_BIL_I_OSLO_SERVICE + 'api/Admin/SimpleNotificationService/History', {}, {
            'query': {method: 'GET', isArray: true},
            'getNotifications': {
                method: 'GET', isArray: true,
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'save': {method: 'POST'},
            'update': {method: 'PUT'},
            'delete': {method: 'DELETE'}
        });

        service.notification = $resource('api/admin/notification/history/:id', {}, {
            'query': {method: 'GET', isArray: false},
            'getSingle': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            }
        });

        service.dieselNotificationLast = $resource(URL_BIL_I_OSLO_SERVICE + 'api/Admin/SimpleNotificationService/History/Last', {
                topic:'DIESEL'
            }, {
            'query': {method: 'GET', isArray: false},
            'getLast': {
                method: 'GET', isArray: false,
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'save': {method: 'POST'},
            'update': {method: 'PUT'},
            'delete': {method: 'DELETE'}
        });

        service.activeDieselBan = $resource(URL_BIL_I_OSLO_SERVICE + 'api/Admin/SimpleNotificationService/Diesel', {}, {
            'query': {method: 'GET', isArray: false},
            'getActiveDieselBan': {
                method: 'GET', isArray: false,
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'save': {method: 'POST'},
            'update': {method: 'PUT'},
            'delete': {method: 'DELETE'}
        });

        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('papp')
        .factory('Message', Message);

    Message.$inject = ['$resource', 'URL_BIL_I_OSLO_SERVICE'];

    function Message($resource, URL_BIL_I_OSLO_SERVICE) {
        var service = {};

        service.messages = $resource(URL_BIL_I_OSLO_SERVICE + 'api/Admin/InformationMessage?page=:page', {}, {
            'query': {method: 'GET', isArray: true},
            'getMessages': {
                method: 'GET', isArray: false,
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            }            
        });

        return service;
    }
})();

(function () {
    "use strict";

    angular.module("papp").factory("Logs", Logs);

    Logs.$inject = ["$resource", "URL_BIL_I_OSLO_SERVICE"];

    function Logs($resource, URL_BIL_I_OSLO_SERVICE) {
        return $resource(
            URL_BIL_I_OSLO_SERVICE +
                "api/Admin/Logs?CustomerId=:CustomerId&FromDate=:FromDate&ToDate=:ToDate",
            { CustomerId: "@id", FromDate: "@FromDate", ToDate: "@ToDate" },
            { getLogs: { method: "GET", isArray: true } }
        );
    }
})();

(function() {
    'use strict';

    angular
        .module('papp')
        .factory('Customer', Customer);

    Customer.$inject = ['$resource', 'URL_BIL_I_OSLO_SERVICE'];

    function Customer ($resource, URL_BIL_I_OSLO_SERVICE) {
        var service = {};

        service.getById = $resource(URL_BIL_I_OSLO_SERVICE + 'api/Admin/Customer/:id', {}, {
            'query': {method: 'GET', isArray: false},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'delete':{ method:'DELETE'}
        });
        
        service.getByIdAccessRequest = $resource(URL_BIL_I_OSLO_SERVICE + 'api/Admin/Customer/:id/AccessRequest', {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            }
        });

        service.updateToAnonomizedRequest = $resource(URL_BIL_I_OSLO_SERVICE + 'api/Admin/Customer/:id/Anonymize',  {id:'@id'}, {
            'update': { method: 'PUT' }
        });


        return service;
    }

})();

(function() {
    'use strict';

    angular
        .module('papp')
        .factory('Config', Config);

    Config.$inject = ['$resource', 'URL_BIL_I_OSLO_SERVICE'];

    function Config ($resource, URL_BIL_I_OSLO_SERVICE) {
        return $resource(URL_BIL_I_OSLO_SERVICE + 'api/Admin/Config', {}, 
        {
            'update': { method: 'PUT' }
        });
    }
})();

// const { merge } = require("lodash");

(function () {
    "use strict";

    angular.module("papp").factory("Principal", Principal);

    Principal.$inject = ["$q", "AuthServerProvider"];

    function Principal($q, AuthServerProvider) {
        var _identity,
            _authenticated = false;

        var service = {
            authenticate: authenticate,
            hasAnyAuthority: hasAnyAuthority,
            hasAuthority: hasAuthority,
            identity: identity,
            isAuthenticated: isAuthenticated,
            isIdentityResolved: isIdentityResolved,
        };

        return service;

        function authenticate(identity) {
            console.debug("autentiserer");
            _identity = identity;
            _authenticated = identity !== null; //  && identity.expires_at > Date.now();
            AuthServerProvider.storeToken(identity);
            // $sessionStorage.identity = identity;
        }

        function hasAnyAuthority(authorities) {
            console.debug("kontrollerer mot flere tilganger");
            if (!_authenticated || !_identity || !_identity.profile.groups) {
                return false;
            }

            if (
                _identity.profile.groups.indexOf("bilioslo-admin-super") !== -1
            ) {
                return true;
            }

            for (var i = 0; i < authorities.length; i++) {
                if (_identity.profile.groups.indexOf(authorities[i]) !== -1) {
                    return true;
                }
            }

            return false;
        }

        function hasAuthority(authority) {
            console.debug("kontrollerer mot enkel tilgang");
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(
                function (_id) {
                    if (!_id.profile.groups) {
                        return false;
                    }

                    if (
                        _id.profile.groups.indexOf("bilioslo-admin-super") !==
                            -1 &&
                        authority.indexOf("varsel") == -1
                    ) {
                        return true;
                    }

                    return _id.profile.groups.indexOf(authority) !== -1;
                },
                function () {
                    return false;
                }
            );
        }
        function identity(force) {
            console.debug("henter identitet: ");
            var deferred = $q.defer();

            if (force === true) {
                _identity = undefined;
                //$sessionStorage.identity = undefined;
            }

            // check and see if we have retrieved the identity data from the server.
            // if we have, reuse it by immediately resolving
            if (angular.isDefined(_identity) && _identity != null) {
                deferred.resolve(_identity);
                //AuthServerProvider.storeToken(_identity);
                //                $sessionStorage.identity = _identity;
                return deferred.promise;
            }

            if (AuthServerProvider.getToken() != null) {
                getAccountThen(AuthServerProvider.getToken());
            } else {
                getAccountCatch();
            }

            // retrieve the identity data from the server, update the identity object, and then resolve.
            //Account.get().$promise.then(getAccountThen).catch(getAccountCatch);

            return deferred.promise;

            function getAccountThen(account) {
                console.debug("setter identitet");
                _identity = account;
                _authenticated = true;
                AuthServerProvider.storeToken(_identity);
                deferred.resolve(_identity);
            }

            function getAccountCatch() {
                console.debug("setter null identitet");
                _identity = null;
                _authenticated = false;
                deferred.resolve(_identity);
            }
        }

        function isAuthenticated() {
            return _authenticated;
        }

        function isIdentityResolved() {
            console.debug("har vi en identitet");
            return angular.isDefined(_identity);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('papp')
        .factory('Password', Password);

    Password.$inject = ['$resource', 'URL_BIL_I_OSLO_SERVICE'];

    function Password($resource, URL_BIL_I_OSLO_SERVICE) {
        return $resource(URL_BIL_I_OSLO_SERVICE + 'api/Admin/Account/Me/Password', {}, {
            'update': {method: 'PATCH'},
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('papp')
        .directive('hasAuthority', hasAuthority);

    hasAuthority.$inject = ['Principal'];

    function hasAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authority = attrs.hasAuthority.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasAuthority(authority)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (authority.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('papp')
        .directive('hasAnyAuthority', hasAnyAuthority);

    hasAnyAuthority.$inject = ['Principal'];

    function hasAnyAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authorities = attrs.hasAnyAuthority.replace(/\s+/g, '').split(',');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {
                    var result;
                    if (reset) {
                        setVisible();
                    }

                    result = Principal.hasAnyAuthority(authorities);
                    if (result) {
                        setVisible();
                    } else {
                        setHidden();
                    }
                };

            if (authorities.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function () {
    "use strict";

    angular.module("papp").factory("Auth", Auth);

    Auth.$inject = [
        "$http",
        "$rootScope",
        "$state",
        "$sessionStorage",
        "$q",
        "Principal",
        "AuthServerProvider",
        "ONELOGIN_SUBDOMAIN",
        "ONELOGIN_REFRESH_WHEN_REMAINING",
        "ONELOGIN_VERIFY_TOKEN_INTERVAL_SECONDS",
    ];

    function Auth(
        $http,
        $rootScope,
        $state,
        $sessionStorage,
        $q,
        Principal,
        AuthServerProvider,
        ONELOGIN_SUBDOMAIN,
        ONELOGIN_REFRESH_WHEN_REMAINING,
        ONELOGIN_VERIFY_TOKEN_INTERVAL_SECONDS
    ) {
        var mgr = AuthServerProvider.getUserManager();
        if (intervalId) {
            console.debug("Fant ett intervall med id : " + intervalId);
            clearInterval(intervalId);
            intervalId = undefined;
        }
        var intervalId = setInterval(function () {
            console.debug("Sjekk token etter bruker");
            mgr.getUser().then(function (val) {
                if (val) {
                    console.debug("bruker funnet(" + val + "), sjekk token");
                    refreshTokenIfExpired(val);
                }
            });
        }, ONELOGIN_VERIFY_TOKEN_INTERVAL_SECONDS * 1000);
        console.log("setter intervall for tokensjekk: " + intervalId);

        return {
            authorize: authorize,
            login: login,
            logout: logout,
            loginWithToken: loginWithToken,
            mgr: mgr,
            refreshTokenIfExpired: refreshTokenIfExpired,
        };

        function authorize(force) {
            console.debug("Autoriserer (" + force + ")");
            return Principal.identity(force).then(authThen);

            function authThen(user) {
                var isAuthenticated = Principal.isAuthenticated();

                refreshTokenIfExpired(user);

                if (!isAuthenticated) {
                    mgr.signinRedirectCallback()
                        .then(function (user, bb) {
                            Principal.authenticate(user);
                            window.location.href =
                                window.location.origin + window.location.hash;
                        })
                        .catch(function (err) {
                            if (!err.message.startsWith("No matching state")) {
                                console.log(
                                    "Error completing auth code + pkce flow",
                                    err
                                );
                            }
                            $rootScope.$broadcast(
                                "authenticationComplete",
                                null
                            );
                        });
                }

                whenAuth();
            }

            function whenAuth() {
                var isAuthenticated = Principal.isAuthenticated();

                // an authenticated user can't access to login and register pages
                if (
                    isAuthenticated &&
                    $rootScope.toState.parent === "account" &&
                    $rootScope.toState.name === "login"
                ) {
                    $state.go("home");
                }

                // recover and clear previousState after external login redirect (e.g. oauth2)
                if (
                    isAuthenticated &&
                    !$rootScope.fromState.name &&
                    getPreviousState()
                ) {
                    var previousState = getPreviousState();
                    resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }

                if (
                    $rootScope.toState.data.authorities &&
                    $rootScope.toState.data.authorities.length > 0 &&
                    !Principal.hasAnyAuthority(
                        $rootScope.toState.data.authorities
                    )
                ) {
                    if (isAuthenticated) {
                        // user is signed in but not authorized for desired state
                        $state.go("accessdenied");
                    } else {
                        // user is not authenticated. stow the state they wanted before you
                        // send them to the login service, so you can return them when you're done
                        storePreviousState(
                            $rootScope.toState.name,
                            $rootScope.toStateParams
                        );

                        // now, send them to the signin state so they can log in
                        $state.go("login");
                    }
                }
            }
        }

        function refreshTokenIfExpired(user) {
            if (user)
                console.debug(
                    "Expires: " +
                        user.expires_at +
                        " Time: " +
                        Math.round(Date.now() / 1000) +
                        " Diff: " +
                        (user.expires_at - Math.round(Date.now() / 1000))
                );
            if (
                user &&
                user.expires_at - ONELOGIN_REFRESH_WHEN_REMAINING <
                    Math.round(Date.now() / 1000)
            ) {
                var url = AuthServerProvider.getAuthority() + "/token";

                var serializedData = $.param({
                    grant_type: "refresh_token",
                    client_id: AuthServerProvider.getClientId(),
                    refresh_token: user.refresh_token,
                });
                $http({
                    method: "POST",
                    url: url,
                    data: serializedData,
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                    },
                }).then(
                    function (response) {
                        AuthServerProvider.updateToken(response.data);
                    },
                    function (error) {
                        console.log("Refresh unsuccessful", error);
                        logout();
                        clearInterval(intervalId);
                    }
                );
            }
        }

        function startLogin() {
            delete $sessionStorage.identity;
            mgr.signinRedirect()
                .then(function () {
                    console.log("startLogin success");
                })
                .catch(function (err) {
                    console.log("startLogin unsuccessful");
                    window.location.href = window.location.origin + "/#login";
                });
        }

        function login(credentials, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            AuthServerProvider.login(credentials)
                .then(loginThen)
                .catch(
                    function (err) {
                        this.logout();
                        deferred.reject(err);
                        return cb(err);
                    }.bind(this)
                );

            function loginThen(data) {
                Principal.identity(true).then(function (account) {
                    deferred.resolve(data);
                });
                return cb();
            }

            return deferred.promise;
        }

        function loginWithToken(jwt) {
            return AuthServerProvider.loginWithToken(jwt);
        }

        function logout() {
            console.debug("logger ut i service");
            Principal.identity().then(function (user) {
                AuthServerProvider.logout();
                if (user)
                    window.location.href =
                        "https://" +
                        ONELOGIN_SUBDOMAIN +
                        ".onelogin.com/oidc/2/logout?post_logout_redirect_uri=" +
                        window.location.origin +
                        "&id_token_hint=" +
                        user.id_token;
                else
                    window.location.href =
                        "https://" +
                        ONELOGIN_SUBDOMAIN +
                        ".onelogin.com/oidc/2/logout";
            });
        }

        function getPreviousState() {
            var previousState = $sessionStorage.previousState;
            return previousState;
        }

        function resetPreviousState() {
            delete $sessionStorage.previousState;
        }

        function storePreviousState(previousStateName, previousStateParams) {
            var previousState = {
                name: previousStateName,
                params: previousStateParams,
            };
            $sessionStorage.previousState = previousState;
        }
    }
})();

(function () {
    "use strict";

    angular.module("papp").factory("AuthServerProvider", AuthServerProvider);

    AuthServerProvider.$inject = [
        "$sessionStorage",
        "ONELOGIN_CLIENT_ID",
        "ONELOGIN_SUBDOMAIN",
        "ONELOGIN_RESOURCE",
        "ONELOGIN_REFRESH_WHEN_REMAINING",
    ];

    function AuthServerProvider(
        $sessionStorage,
        ONELOGIN_CLIENT_ID,
        ONELOGIN_SUBDOMAIN,
        ONELOGIN_RESOURCE
    ) {
        var service = {
            hasValidToken: hasValidToken,
            storeToken: storeToken,
            updateToken: updateToken,
            getToken: getToken,
            logout: logout,
            getUserManager: getUserManager,
            getAuthority: getAuthority,
            getClientId: getClientId,
        };
        var settings = {
            authority: "https://" + ONELOGIN_SUBDOMAIN + ".onelogin.com/oidc/2",
            client_id: ONELOGIN_CLIENT_ID,
            redirect_uri: window.location.origin,
            response_type: "code",
            scope: "openid profile groups",
            resource: ONELOGIN_RESOURCE,
            filterProtocolClaims: true,
            loadUserInfo: true,
        };
        var mgr = new Oidc.UserManager(settings);

        return service;

        function getUserManager() {
            return mgr;
        }
        function getAuthority() {
            return settings.authority;
        }
        function getClientId() {
            return settings.client_id;
        }

        function getToken() {
            console.debug("Henter token");
            return $sessionStorage.identity;
        }

        function hasValidToken() {
            console.debug("Sjekker om Token er gyldig");
            var token = this.getToken();
            return (
                token &&
                token.expires &&
                token.expires > Math.round(Date.now() / 1000)
            );
        }

        function storeToken(jwt) {
            console.debug("Lagrer token");
            $sessionStorage.identity = jwt;
        }

        function updateToken(tokenData) {
            console.debug("oppdaterer token");
            mgr.getUser().then(function (user) {
                if (user) {
                    user.access_token = tokenData.access_token;
                    user.refresh_token = tokenData.refresh_token;
                    user.expires_at =
                        Math.round(Date.now() / 1000) + tokenData.expires_in;
                    user.id_token = tokenData.id_token;
                    $sessionStorage.identity = user;
                    mgr.storeUser(user);
                    console.log("Updated tokens successfully");
                    return true;
                }
                console.error("Error invalid user");
                return false;
            });
        }

        function logout() {
            console.debug("logger ut");
            delete $sessionStorage.identity;
            delete $sessionStorage.authenticationToken;
            mgr.removeUser().then(function (a) {
                console.debug("Fjernet bruker i Oidc UserManager " + a);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('papp')
        .factory('Appversion', Appversion);

    Appversion.$inject = ['$resource', 'DateUtils', 'URL_BIL_I_OSLO_SERVICE'];

    function Appversion ($resource, DateUtils, URL_BIL_I_OSLO_SERVICE) {
        return $resource(URL_BIL_I_OSLO_SERVICE + 'api/Admin/AppVersion', {}, {
            'get': {
                method: 'GET', isArray: true,
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    angular.forEach(data, function (value) {
                        value.releaseDate = DateUtils.convertLocalDateFromServer(value.releaseDate);
                        value.createdAt = DateUtils.convertLocalDateFromServer(value.createdAt);
                    });
                    return data;
                }
            }});
    }
})();

(function () {
    'use strict';

    angular
        .module('papp')
        .factory('AdminUser', AdminUser);

    AdminUser.$inject = ['$resource', 'URL_BIL_I_OSLO_SERVICE'];

    function AdminUser($resource, URL_BIL_I_OSLO_SERVICE) {
        return $resource(URL_BIL_I_OSLO_SERVICE + 'api/Admin/Account/:id', {id: '@id'}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'save': {method: 'POST'},
            'update': {method: 'PUT'},
            'delete': {method: 'DELETE'}
        });
    }
})();

(function () {
    "use strict";

    angular.module("papp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider.state("refund", {
            parent: "app",
            url: "/refund?page?status?date",
            data: {
                authorities: ["bilioslo-admin", "bilioslo-admin-lese"],
            },
            views: {
                "content@": {
                    templateUrl: "app/refund/refund.html",
                    controller: "RefundController",
                    controllerAs: "vm",
                },
            },
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('papp')
        .controller('RefundController', RefundController);

    RefundController.$inject = ['PspJob', '$state', '$stateParams', 'DateUtils'];

    function RefundController(PspJob, $state, $stateParams, DateUtils) {
        var vm = this;
        var page = 1;
        var status = null;
        var date = null;
        
        vm.numberOfPages = 1;

        vm.jobs = [];

        vm.prevPage = prevPage;
        vm.nextPage = nextPage;
        vm.firstPage = firstPage;
        vm.lastPage = lastPage;
        vm.search = search;
        vm.clearSearch = clearSearch;
        vm.showRefund = showRefund;
        vm.openDateDatePicker = openDateDatePicker;

        vm.statuses = [
            {
                value: 'failed', label: 'Feilet'
            },
            {
                value: 'failing', label: 'Feilende'
            },
            {
                value: 'pending', label: 'Venter'
            },
            {
                value: 'attempt_in_progress', label: 'Forsøkes'
            },
            {
                value: 'processed', label: 'OK'
            }
        ];

        function prevPage() {
            toState(page - 1);
        }

        function nextPage() {
            toState(page + 1);
        }

        function firstPage() {
            toState(0);
        }

        function lastPage() {
            toState(vm.numberOfPages);
        }

        function toState(toPage){
            $state.go('refund', {
                page: toPage,
                status: (status ? status.value : null),
                date: (date ? DateUtils.convertLocalDateToServer(date) : null)
            });
        } 

        function search() {
            $state.go('refund', {
                page: 1,
                status: (vm.statusInput ? vm.statusInput.value : null),
                date: (vm.dateInput ? DateUtils.convertLocalDateToServer(vm.dateInput) : null)
            });
        }

        function clearSearch() {
            vm.statusInput = null;
            vm.dateInput = null;
            vm.toDateInput = null;

            $state.go('refund', {
                page: 1,
                status: null,
                date: null
            });
        }

        vm.dateOptions = {
            formatYear: 'yy',
            startingDay: 1
        };

        vm.datePopupDatePicker = {
            opened: false
        };

        function openDateDatePicker() {
            vm.datePopupDatePicker.opened = true;
        }

        function showRefund(refund) {
            $state.go('refundDetails', {
                id: refund.id
            });
        }

        page = parseInt($stateParams.page, 10);
        if (!page) {
            page = 1;
        }

        if ($stateParams.status) {
            angular.forEach(vm.statuses, function (value, key) {
                if (value.value == $stateParams.status) {
                    status = value;
                }
            });
        }
        if ($stateParams.date)
            date = new Date($stateParams.date);

        vm.dateInput = date;
        vm.statusInput = status;

        PspJob.query({
            page: page,
            type: 'REFUND',
            status: (status ? status.value : null),
            date: (date ? DateUtils.convertLocalDateToServer(date) : null)
        }, function (result) {
            vm.jobs = result.pspJobs;
            
            vm.pagination = {
                page: page,
                total: result.total,
                itemsPerPage: result.itemsPerPage
            };

            vm.numberOfPages = result.itemsPerPage != 0 ? Math.ceil(result.total / result.itemsPerPage) : 0;
        });
    }
})(window.angular);

(function () {
    "use strict";

    angular.module("papp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider.state("refundDetails", {
            parent: "app",
            url: "/refund/details/:id",
            data: {
                authorities: ["bilioslo-admin", "bilioslo-admin-lese"],
            },
            views: {
                "content@": {
                    templateUrl: "app/refund/details/refund.details.html",
                    controller: "RefundDetailsController",
                    controllerAs: "vm",
                },
            },
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('papp')
        .controller('RefundDetailsController', RefundDetailsController);

    RefundDetailsController.$inject = ['PspJob', 'Transaction', '$stateParams'];

    function RefundDetailsController(PspJob, Transaction, $stateParams) {
        var vm = this;
        var transactionPage = 1;

        vm.isFirstTransactionPage = true;
        vm.isLastTransactionPage = true;

        vm.load = load;
        vm.prevTransactionPage = prevTransactionPage;
        vm.nextTransactionPage = nextTransactionPage;

        vm.load($stateParams.id);

        function prevTransactionPage() {
            transactionPage = transactionPage - 1;
            queryTransactions();
        }

        function nextTransactionPage() {
            transactionPage = transactionPage + 1;
            queryTransactions();
        }

        function queryTransactions() {
            Transaction.query({
                jobId: $stateParams.id,
                page: transactionPage
            }, function (result) {
                vm.transactions = result.transactions;
                vm.isFirstTransactionPage = transactionPage <= 1;
                vm.isLastTransactionPage = result.page * result.itemsPerPage >= result.total;
            });
        }

        function load(id) {
            PspJob.get({id: id}, function(result) {
                vm.job = result;
            });

            queryTransactions();
        }
    }
})();

(function () {
    "use strict";

    angular.module("papp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider.state("studdedTirePrice", {
            parent: "price",
            url: "/price/studded-tire",
            data: {
                authorities: ["bilioslo-admin", "bilioslo-admin-lese"],
            },
            views: {
                "content@": {
                    templateUrl:
                        "app/price/studded-tire/studded-tire-price.html",
                    controller: "StuddedTirePriceController",
                    controllerAs: "vm",
                },
            },
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('papp')
        .controller('StuddedTirePriceController', StuddedTirePriceController);

    StuddedTirePriceController.$inject = ['Price'];

    function StuddedTirePriceController(Price) {
        var vm = this;

        vm.error = null;
        vm.success = null;

        vm.studdedTirePrices = Price.studdedTire.getStuddedTirePrices();
        vm.season = Price.season.getSeason();
    }
})();

(function() {
    'use strict';

    angular
        .module('papp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('price', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function () {
    "use strict";

    angular.module("papp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider.state("parkingPrice", {
            parent: "price",
            url: "/price/parking",
            data: {
                authorities: ["bilioslo-admin", "bilioslo-admin-lese"],
            },
            views: {
                "content@": {
                    templateUrl: "app/price/parking/parking-price.html",
                    controller: "ParkingPriceController",
                    controllerAs: "vm",
                },
            },
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('papp')
        .controller('ParkingPriceController', ParkingPriceController);

    ParkingPriceController.$inject = ['$state', 'Price'];

    function ParkingPriceController($state, Price) {
        var vm = this;

        Price.parking.getPrices(function (result) {
            if (result.prices.length === 1) {
                $state.go('parkingPriceDetails', {
                    prices: result.prices[0]
                });
            } else {
                vm.prices = result.prices;
            }
        });
    }
})();

(function () {
    "use strict";

    angular.module("papp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider.state("parkingPriceDetails", {
            parent: "parkingPrice",
            url: "/price/parking/details",
            params: {
                prices: null,
            },
            data: {
                authorities: ["bilioslo-admin", "bilioslo-admin-lese"],
            },
            views: {
                "content@": {
                    templateUrl:
                        "app/price/parking/details/parking-price.details.html",
                    controller: "ParkingPriceDetailsController",
                    controllerAs: "vm",
                },
            },
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('papp')
        .controller('ParkingPriceDetailsController', ParkingPriceDetailsController);

    ParkingPriceDetailsController.$inject = ['$state', '$stateParams'];

    function ParkingPriceDetailsController($state, $stateParams) {
        var vm = this;

        if (!$stateParams.prices) {
            $state.go('parkingPrice');
        }

        vm.prices = $stateParams.prices;
    }
})();

(function () {
    "use strict";

    angular.module("papp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider.state("import-studded-tire", {
            parent: "price",
            url: "/import-studded-tire",
            data: {
                authorities: ["bilioslo-admin"],
            },
            views: {
                "content@": {
                    templateUrl:
                        "app/price/import-studded-tire/import-studded-tire.html",
                    controller: "ImportStuddedTireController",
                    controllerAs: "vm",
                },
            },
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('papp')
        .directive('customOnChange', function() {
           return {
             restrict: 'A',
             link: function (scope, element, attrs) {
               var onChangeHandler = scope.$eval(attrs.customOnChange);
               element.bind('change', onChangeHandler);
             }
           };
         });
})();

(function () {
    'use strict';

    angular
        .module('papp')
        .controller('ImportStuddedTireController', ImportStuddedTireController);

    ImportStuddedTireController.$inject = ['$http', 'Price', 'DateUtils', 'URL_BIL_I_OSLO_SERVICE'];

    function ImportStuddedTireController($http, Price, DateUtils, URL_BIL_I_OSLO_SERVICE) {
        var vm = this;
        vm.error = null;
        vm.success = null;
        console.log('ImportStuddedTireController');

        vm.openDatePickerNotHeavy = openDatePickerNotHeavy;
        vm.openDatePickerHeavy = openDatePickerHeavy;

        function openDatePickerNotHeavy(priceId) {
            vm.studdedTirePrices[priceId - 1].isNotHeavyOpen = true;
        }

        function openDatePickerHeavy(priceId) {
            vm.studdedTirePrices[priceId - 1].isHeavyOpen = true;
        }

        vm.loadAll = function () {
            vm.studdedTirePrices = Price.studdedTire.getStuddedTirePrices();
            vm.defaultStuddedTirePrices = Price.studdedTire.getStuddedTirePrices();
        };
        vm.loadAll();

        vm.updatePrices = function (event) {
            console.log('start updating prices...');

            var json = angular.copy(vm.studdedTirePrices);
            var isPositivePrices = null;
            angular.forEach(json, function (value) {
                value.buyFrom = DateUtils.convertLocalDateToServer(value.buyFrom);
                value.buyTo = DateUtils.convertLocalDateToServer(value.buyTo);
                if (value.heavyPrice <= 0 || value.price <= 0) {
                                console.log(value.heavyPrice)
                                console.log(value.price)
                    vm.studdedTireResult = "Noen priser er negative, null eller ikke satt!";
                    console.log('Prices are negative');
                    isPositivePrices = false;
                    return
                }
                if (isPositivePrices == null)
                    isPositivePrices = true;
            });

            if (!isPositivePrices)
                return;

            $http.post(URL_BIL_I_OSLO_SERVICE + 'api/Admin/StuddedTirePrice', json, {})
                .success(function (response) {
                    console.log('success from update studded tire prices');
                    vm.studdedTireResult = "Oppdatering vellykket!";
                    return response;
                }).error(function (e) {
                vm.studdedTireResult = "Oppdatering feilet!";
                console.log('update of studded tire prices failed');
            });
        };
    }
})();

(function () {
    "use strict";

    angular.module("papp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider.state("import-parking", {
            parent: "price",
            url: "/import-parking",
            data: {
                authorities: ["bilioslo-admin"],
            },
            views: {
                "content@": {
                    templateUrl: "app/price/import-parking/import-parking.html",
                    controller: "ImportParkingController",
                    controllerAs: "vm",
                },
            },
        });
    }
})();

'use strict';

angular.module('papp')
    .directive('fileread', function () {
        return {
            scope: {
                fileread: '='
            },
            link: function (scope, element) {
                element.bind('change', function (changeEvent) {
                    var reader = new FileReader();
                    reader.onload = function (loadEvent) {
                        scope.$apply(function () {
                            scope.fileread = loadEvent.target.result;
                        });
                    };
                    reader.readAsBinaryString(changeEvent.target.files[0]);
                });
            }
        };
    });

(function () {
    "use strict";

    angular
        .module("papp")
        .controller("ImportParkingController", ImportParkingController);

    ImportParkingController.$inject = [
        "$scope",
        "$http",
        "DateUtils",
        "ParkingUtils",
        "URL_BIL_I_OSLO_SERVICE",
    ];

    function ImportParkingController(
        $scope,
        $http,
        DateUtils,
        ParkingUtils,
        URL_BIL_I_OSLO_SERVICE
    ) {
        var vm = this;

        vm.error = null;
        vm.success = null;
        vm.parkingTariffs = null;
        vm.dateFrom = new Date(new Date().getFullYear() + 1, 0, 1);
        vm.dateTo = new Date(new Date().getFullYear() + 2, 0, 1);
        vm.openDatePicker = openDatePicker;
        vm.save = save;

        vm.dateOptions = {
            formatYear: "yy",
            startingDay: 1,
        };

        vm.popupDatePicker = {
            opened: false,
        };

        function openDatePicker() {
            vm.popupDatePicker.opened = true;
        }

        function save() {
            return $http
                .post(URL_BIL_I_OSLO_SERVICE + "api/Admin/ParkingPriceGroup", {
                    groups: vm.parkingTariffs,
                    validFrom: DateUtils.convertLocalDateToServer(vm.dateFrom),
                    validTo: DateUtils.convertLocalDateToServer(vm.dateTo),
                })
                .success(function (response) {
                    console.log("success from prices post");
                    vm.result = "Import suksess!";
                    return response;
                })
                .error(function (e) {
                    vm.result = "Import feilet!";
                    console.log("feil import");
                });
        }

        $scope.$watch("uploadFile", function (data) {
            vm.parkingTariffs = null;

            if (!data) return;

            var workbook = XLSX.read(data, { type: "binary" });

            vm.parkingTariffs = [];

            var worksheet = workbook.Sheets["Parkeringbetingelser"];
            var jsonWorksheet = XLSX.utils.sheet_to_json(worksheet);

            angular.forEach(jsonWorksheet, function (value, key) {
                vm.parkingTariffs.push({
                    priceGroup: value["Takstgruppe"],
                    maxParkingTime: ParkingUtils.convertPMaksTid(
                        value["Maks p-tid"]
                    ),
                    maxPrice: value["Maks takst"],
                    mondayStart: value["Avgiftstid start hverdag"],
                    mondayStop: value["Avgiftstid stopp hverdag"],
                    saturdayStart: value["Avgiftstid start lordag"],
                    saturdayStop: value["Avgiftstid stopp lordag"],
                    sundayStart: value["Avgiftstid start sondag"],
                    sundayStop: value["Avgiftstid stopp sondag"],
                    priceThirtyMinutes: value["Takst per 30 min"],
                    priceHour: value["Takst per time"],
                    priceHourSecondary: value["Takst per time sekundær"],
                    priceNinetyMinutes: value["Takst per 1,5 time"],
                    priceTwoHours: value["Takst per 2 timer"],
                    priceThreeHours: value["Takst per 3 timer"],
                    priceFourHours: value["Takst per 4 timer"],
                    priceAdditionalThirtyMinutes:
                        value["Takst per ekstra 30 minutter"],
                    priceDay: value["Takst per døgn"],
                    priceWeek: value["Takst per uke"],
                    priceFourWeeks: value["Takst per 4 uker"],
                    isElectric: value["Elektrisk"],
                    vehiclePriceGroup: 0,
                });
                vm.parkingTariffs.push({
                    priceGroup: value["Takstgruppe"],
                    maxParkingTime: ParkingUtils.convertPMaksTid(
                        value["Maks p-tid"]
                    ),
                    maxPrice: value["Maks takst"],
                    mondayStart: value["Avgiftstid start hverdag"],
                    mondayStop: value["Avgiftstid stopp hverdag"],
                    saturdayStart: value["Avgiftstid start lordag"],
                    saturdayStop: value["Avgiftstid stopp lordag"],
                    sundayStart: value["Avgiftstid start sondag"],
                    sundayStop: value["Avgiftstid stopp sondag"],
                    priceThirtyMinutes: value["Takst per 30 min EL"],
                    priceHour: value["Takst per time EL"],
                    priceHourSecondary: value["Takst per time sekundær EL"],
                    priceNinetyMinutes: value["Takst per 1,5 time EL"],
                    priceTwoHours: value["Takst per 2 timer EL"],
                    priceThreeHours: value["Takst per 3 timer EL"],
                    priceFourHours: value["Takst per 4 timer EL"],
                    priceAdditionalThirtyMinutes:
                        value["Takst per ekstra 30 minutter EL"],
                    priceDay: value["Takst per døgn EL"],
                    priceWeek: value["Takst per uke EL"],
                    priceFourWeeks: value["Takst per 4 uker EL"],
                    isElectric: value["Elektrisk"],
                    vehiclePriceGroup: 1,
                });
                vm.parkingTariffs.push({
                    priceGroup: value["Takstgruppe"],
                    maxParkingTime: ParkingUtils.convertPMaksTid(
                        value["Maks p-tid"]
                    ),
                    maxPrice: value["Maks takst"],
                    mondayStart: value["Avgiftstid start hverdag"],
                    mondayStop: value["Avgiftstid stopp hverdag"],
                    saturdayStart: value["Avgiftstid start lordag"],
                    saturdayStop: value["Avgiftstid stopp lordag"],
                    sundayStart: value["Avgiftstid start sondag"],
                    sundayStop: value["Avgiftstid stopp sondag"],
                    priceThirtyMinutes: value["Takst per 30 min EV"],
                    priceHour: value["Takst per time EV"],
                    priceHourSecondary: value["Takst per time sekundær EV"],
                    priceNinetyMinutes: value["Takst per 1,5 time EV"],
                    priceTwoHours: value["Takst per 2 timer EV"],
                    priceThreeHours: value["Takst per 3 timer EV"],
                    priceFourHours: value["Takst per 4 timer EV"],
                    priceAdditionalThirtyMinutes:
                        value["Takst per ekstra 30 minutter EV"],
                    priceDay: value["Takst per døgn EV"],
                    priceWeek: value["Takst per uke EV"],
                    priceFourWeeks: value["Takst per 4 uker EV"],
                    isElectric: value["Elektrisk"],
                    vehiclePriceGroup: 2,
                });
            });
        });
    }
})();

(function () {
    "use strict";

    angular.module("papp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider.state("parking", {
            parent: "app",
            url: "/parking?page&plateNumber&email&dateStart&isElectric",
            data: {
                authorities: ["bilioslo-admin", "bilioslo-admin-lese"],
            },
            views: {
                "content@": {
                    templateUrl: "app/parking/parking.html",
                    controller: "ParkingController",
                    controllerAs: "vm",
                },
            },
        });
    }
})();

(function () {
    "use strict";

    angular.module("papp").controller("ParkingController", ParkingController);

    ParkingController.$inject = [
        "Parking",
        "$state",
        "$stateParams",
        "DateUtils",
    ];

    function ParkingController(Parking, $state, $stateParams, DateUtils) {
        var vm = this;
        var page = 1;
        var plateNumber = null;
        var dateStart = null;
        var email = null;
        var isElectricParking = null;
        var isNormalParking = null;

        vm.numberOfPages = 1;

        vm.parkings = [];

        vm.plateNumberInput = null;
        vm.emailInput = null;
        vm.dateStartInput = null;

        vm.prevPage = prevPage;
        vm.nextPage = nextPage;
        vm.firstPage = firstPage;
        vm.lastPage = lastPage;
        vm.search = search;
        vm.clearSearch = clearSearch;
        vm.showParking = showParking;
        vm.openDatePicker = openDatePicker;

        function prevPage() {
            toState(page - 1);
        }

        function nextPage() {
            toState(page + 1);
        }

        function firstPage() {
            toState(0);
        }

        function lastPage() {
            toState(vm.numberOfPages);
        }

        function toState(toPage) {
            $state.go("parking", {
                page: toPage,
                plateNumber: plateNumber,
                email: email,
                dateStart: dateStart
                    ? DateUtils.convertLocalDateToServer(dateStart)
                    : null,
                isElectricInput: vm.isElectricInput,
                isNormalInput: vm.isNormalInput,
            });
        }

        function search() {
            var isEl = isElectricSearch();
            if (isEl === null) {
                vm.isElectricInput = true;
                vm.isNormalInput = true;
            }

            $state.go("parking", {
                page: 1,
                plateNumber: vm.plateNumberInput
                    ? vm.plateNumberInput.toUpperCase()
                    : null,
                email: vm.emailInput ? vm.emailInput.toLowerCase() : null,
                dateStart: vm.dateStartInput
                    ? DateUtils.convertLocalDateToServer(vm.dateStartInput)
                    : null,
                isElectric: isElectricSearch(),
            });
        }

        function clearSearch() {
            vm.plateNumberInput = null;
            vm.emailInput = null;
            vm.dateStartInput = null;
            vm.isElectricInput = true;
            vm.isNormalInput = true;

            $state.go("parking", {
                page: 1,
                plateNumber: null,
                email: null,
                dateStart: null,
                isElectricInput: true,
                isNormalInput: true,
                isElectric: null,
            });
        }

        function showParking(parking) {
            $state.go("parkingDetails", {
                id: parking.id,
            });
        }

        page = parseInt($stateParams.page, 10);
        if (!page) {
            page = 1;
        }

        plateNumber = $stateParams.plateNumber;
        email = $stateParams.email;
        if ($stateParams.dateStart)
            dateStart = new Date($stateParams.dateStart);

        vm.plateNumberInput = plateNumber;
        vm.emailInput = email;
        vm.dateStartInput = dateStart;

        if ($stateParams.isElectric === undefined) {
            isNormalParking = true;
            isElectricParking = true;
        } else if ($stateParams.isElectric === "false") {
            isElectricParking = false;
            isNormalParking = true;
        } else {
            isElectricParking = true;
            isNormalParking = false;
        }

        vm.isNormalInput = isNormalParking;
        vm.isElectricInput = isElectricParking;

        vm.dateOptions = {
            formatYear: "yy",
            startingDay: 1,
        };

        vm.popupDatePicker = {
            opened: false,
        };

        function openDatePicker() {
            vm.popupDatePicker.opened = true;
        }

        function isElectricSearch() {
            if (
                (vm.isElectricInput && vm.isNormalInput) ||
                (!vm.isElectricInput && !vm.isNormalInput)
            ) {
                return null;
            } else if (vm.isElectricInput) {
                return true;
            } else {
                return false;
            }
        }

        Parking.query(
            {
                page: page,
                plateNumber: plateNumber,
                email: email,
                dateStart: dateStart
                    ? DateUtils.convertLocalDateToServer(dateStart)
                    : null,
                isElectric: isElectricSearch(),
            },
            function (result) {
                vm.parkings = result.parkings;
                plateNumber = result.plateNumber;
                email = result.email;

                vm.pagination = {
                    page: page,
                    total: result.total,
                    itemsPerPage: result.itemsPerPage,
                };

                vm.numberOfPages =
                    result.itemsPerPage != 0
                        ? Math.ceil(result.total / result.itemsPerPage)
                        : 0;
            }
        );
    }
})(window.angular);

(function () {
    "use strict";

    angular.module("papp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider.state("parkingDetails", {
            parent: "app",
            url: "/parking/details/:id",
            data: {
                authorities: ["bilioslo-admin", "bilioslo-admin-lese"],
            },
            views: {
                "content@": {
                    templateUrl: "app/parking/details/parking.details.html",
                    controller: "ParkingDetailsController",
                    controllerAs: "vm",
                },
            },
        });
    }
})();

(function () {
    "use strict";

    angular
        .module("papp")
        .controller("ParkingDetailsController", ParkingDetailsController);

    ParkingDetailsController.$inject = [
        "Parking",
        "Logs",
        "DateUtils",
        "$stateParams",
        "$scope",
        "Principal",
    ];

    function ParkingDetailsController(
        Parking,
        Logs,
        DateUtils,
        $stateParams,
        $scope,
        Principal
    ) {
        var vm = this;

        vm.load = load;
        vm.parkingDetail = {};

        vm.logs = [];
        vm.showLogButton = true;
        vm.searchLog = loadLogs;

        vm.preTimes = [];
        vm.postTimes = [];

        vm.load($stateParams.id);

        Principal.hasAuthority("bilioslo-admin").then(function (result) {
            vm.showLogSection = result;
        });

        function load(id) {
            Parking.get({ id: id }, function (result) {
                vm.parkingDetail = result;
                fillPreAndPostTimes();
                $scope.logFromDate = vm.preTimes[0].date;
                $scope.logToDate = vm.postTimes[0].date;
            });
        }

        function fillPreAndPostTimes() {
            // fill preTimes
            var startTime = vm.parkingDetail.parking.startTime;
            var intervallMinutes = [15, 60, 120, 180, 240, 300, 480, 1440];
            for (var i = 0; i < intervallMinutes.length; i++) {
                var intervall = intervallMinutes[i];
                var preTime = {
                    date: new Date(
                        DateUtils.convertLocalDateTimeFromServer(
                            startTime
                        ).getTime() -
                            intervall * 60 * 1000
                    ).toISOString(),
                    text:
                        intervall < 60
                            ? "-" + intervall + " min"
                            : "-" + intervall / 60 + " timer",
                };
                var postTime = {
                    date: new Date(
                        DateUtils.convertLocalDateTimeFromServer(
                            startTime
                        ).getTime() +
                            intervall * 60 * 1000
                    ).toISOString(),
                    text:
                        intervall < 60
                            ? "+" + intervall + " min"
                            : "+" + intervall / 60 + " timer",
                };
                vm.preTimes.push(preTime);
                vm.postTimes.push(postTime);
            }
        }

        function loadLogs(unModified) {
            vm.showLogButton = false;
            vm.logs = [{ time: "", message: "Laster...." }];

            console.log(
                "Henter logger for kunde: " +
                    vm.parkingDetail.customer.id +
                    " fra: " +
                    $scope.logFromDate +
                    " til: " +
                    $scope.logToDate
            );
            Logs.getLogs(
                {
                    CustomerId: vm.parkingDetail.customer.id,
                    FromDate: $scope.logFromDate,
                    ToDate: $scope.logToDate,
                    UnModified: unModified,
                },
                function (result) {
                    var loglines = [];

                    for (var i = 0; i < result.length; i++) {
                        var sp = result[i].split(" | ");
                        var logline = {
                            time: sp[0],
                            message: sp[1],
                        };
                        loglines.push(logline);
                    }
                    vm.logs = loglines;
                }
            );
        }
    }
})();

(function (angular) {
    'use strict';

    function PaginationController() {
        var ctrl = this;

        ctrl.prevPage = function () {
            ctrl.toPrevPage();
        }

        ctrl.nextPage = function () {
            ctrl.toNextPage();
        }

        ctrl.firstPage = function () {
            ctrl.toFirstPage();
        }

        ctrl.lastPage = function () {
            ctrl.toLastPage();
        }

        ctrl.isFirstPage = ctrl.pagination.page <= 1;

        ctrl.numberOfResults = ctrl.pagination.total;
        ctrl.pageEnd = ctrl.pagination.itemsPerPage * ctrl.pagination.page;
        ctrl.pageStart = ctrl.pageEnd - ctrl.pagination.itemsPerPage + 1;

        if ((ctrl.pagination.page * ctrl.pagination.itemsPerPage) < ctrl.pagination.total) {
            ctrl.isLastPage = false;
        } else {
            ctrl.isLastPage = true;
            ctrl.pageEnd = ctrl.pagination.total;
        }
    }

    angular.module('papp').component('paginationComponent', {
        templateUrl: 'app/pagination/pagination.html',
        controller: PaginationController,
        bindings: {
            pagination: "<",
            toPrevPage: "&",
            toNextPage: "&",
            toFirstPage: "&",
            toLastPage: "&"
        }
    });
})(window.angular);

(function () {
    "use strict";

    angular.module("papp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider.state("roadMaintenanceNotification", {
            parent: "Notification",
            url: "/notification/road-maintenance",
            data: {
                authorities: ["bilioslo-admin-veivarsel"],
            },
            views: {
                "content@": {
                    templateUrl:
                        "app/notification/road-maintenance/road-maintenance.html",
                    controller: "RoadMaintenanceNotificationController",
                    controllerAs: "vm",
                },
            },
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('papp')
        .controller('RoadMaintenanceNotificationController', RoadMaintenanceNotificationController);

    RoadMaintenanceNotificationController.$inject = ['$http', '$state', 'Notification', 'DateUtils', 'TimeUtils', '$uibModal'];

    function RoadMaintenanceNotificationController($http, $state, Notification, DateUtils, TimeUtils, $uibModal) {
        var vm = this;

        vm.loadAll = function () {
            getNotifications()
        };
        vm.loadAll();

        vm.changeDate = changeDate;
        vm.openDatePickerTo = openDatePickerTo;
        vm.sendRoadMaintenance = sendRoadMaintenance;
        vm.showHistoryDetails = showHistoryDetails;
        vm.submit = submit;
        vm.errorMessage = null;


        function openDatePickerTo() {
            vm.isToPickerOpen = true;
        }

        function changeDate() {
            clearErrorMessages();
            vm.errorMessage = TimeUtils.isTimeFormatTooHigh(vm.toHour, vm.toMin)
        }

        function submit() {
            if (!isCorrectInput())
                return;
            var modalInstance = $uibModal.open({
                  animation: true,
                  ariaLabelledBy: 'modal-title',
                  ariaDescribedBy: 'modal-body',
                  templateUrl: 'app/notification/road-maintenance/modal/road-maintenance-modal.html',
                  controller: 'RoadMaintenanceModalController',
                  controllerAs: 'vm',
                  resolve: {
                    message: function () {
                      var message = {}
                      message.validTo = vm.toDate;
                      message.validTo.setHours(vm.toHour);
                      message.validTo.setMinutes(vm.toMin);
                      message.messageNo = vm.messageNo;
                      message.messageEn = vm.messageEn;
                      return message;
                    }
                  }
            });

            modalInstance.result.then(function () {
                    console.log("Confirmed sending notification")
                    sendRoadMaintenance()
                }, function () {
                    console.log("Canceled sending")
                });

        }

        function sendRoadMaintenance() {
            clearErrorMessages();
            vm.errorMessage = "Sender...";
            return $http.post('/api/admin/notification/send', {
                topic: "ROAD_MAINTENANCE",
                topicTypeId: 3,
                validTo: DateUtils.convertLocalDateTimeToServer (vm.toDate, vm.toHour, vm.toMin),
                messageNo: vm.messageNo,
                messageEn: vm.messageEn,
            }).success(function (response) {
                console.log('successfully sent notification!');
                vm.errorMessage = "Varsel sendt!";
                return response;
            }).error(function (e, status) {
                if (status == 403) {
                    vm.errorMessage = "Mangler rettigheter...";
                } else {
                    vm.errorMessage = "Sending feilet!";
                }
                console.log('Sending of notification failed');
            }).finally(function() {
                getNotifications()
            });
        }

        function isCorrectInput() {
            clearErrorMessages()
            vm.errorMessage = TimeUtils.isTimeFormatTooHigh(vm.toHour, vm.toMin)
            if (vm.errorMessage != null)
                return
            vm.errorMessage = TimeUtils.isTimeFormatTooLow(vm.toHour, vm.toMin)
            validateCorrectToDate()
            validateInputNotNull()
            return (vm.errorMessage == null)
        }

        function isCorrectFromDate() {

            var tomorrow = new Date()
            tomorrow.setDate(tomorrow.getDate()+1)
            tomorrow.setSeconds(tomorrow.getSeconds()-10)
            if (fromDate < tomorrow ) {
                vm.errorMessage = "Dieselforbud må settes minst 24 timer før";
                return false
            }
            var inAMonth = new Date()
            inAMonth.setMonth(inAMonth.getMonth()+1)
            if (fromDate > inAMonth ) {
                vm.errorMessage = "Dieselforbud må settes innen en måned";
                return false
            }
            return true;
        }

        function validateCorrectToDate() {
            var now = new Date()
            if (vm.toDate < now ) {
                vm.errorMessage = "Dato må være fram i tid";
            }
        }

        function validateInputNotNull() {
            if (vm.toMin == null || vm.toMin == "") {
                vm.errorMessage = "Mangler tid i minutter";
            }
            if (vm.toHour == null || vm.toHour == "") {
                vm.errorMessage = "Mangler tid i timer";
            }
            if (vm.toDate == null) {
                vm.errorMessage = "Mangler dato";
            }
            if (isTextNotSet(vm.messageNo)) {
                vm.errorMessage = "Mangler tekster på norsk";
                return
            }
            if (isTextNotSet(vm.messageEn)) {
                vm.errorMessage = "Mangler tekster på engelsk";
                return
            }
            if (isTextNotSet(vm.messageNo.pushMessage)) {
                vm.errorMessage = "Mangler pushvarsel-tekst på norsk";
                return
            }
            if (isTextNotSet(vm.messageEn.pushMessage)) {
                vm.errorMessage = "Mangler pushvarsel-tekst på engelsk";
                return
            }
            if (isTextNotSet(vm.messageEn.boardFirstMessage)) {
                vm.errorMessage = "Mangler første avsnitt til varslingssenteret på engelsk";
            }
            if (isTextNotSet(vm.messageNo.boardFirstMessage)) {
                vm.errorMessage = "Mangler første avsnitt til varslingssenteret på norsk";
            }
            if (isTextNotSet(vm.messageEn.boardTitle)) {
                vm.errorMessage = "Mangler tittel til varslingssenteret på engelsk";
            }
            if (isTextNotSet(vm.messageNo.boardTitle)) {
                vm.errorMessage = "Mangler tittel til varslingssenteret på norsk";
            }
            if (isTextNotSet(vm.messageEn.boardUrl)) {
                vm.errorMessage = "Mangler URL til varslingssenteret på engelsk";
            }
            if (isTextNotSet(vm.messageNo.boardUrl)) {
                vm.errorMessage = "Mangler URL til varslingssenteret på norsk";
            }
        }

        function isTextNotSet(text) {
            return (text == null || text == "")
        }

        function clearErrorMessages() {
            vm.errorMessage = null;
        }

        function showHistoryDetails(notification) {
            $state.go('notificationHistoryDetails', {
                id: notification.id
            });
        }

        vm.page = 1

        function getNotifications() {
            Notification.notifications.getNotifications({
                topic: 'ROAD_MAINTENANCE',
                page: vm.page
            }, function (result) {
                vm.notifications = result;
                vm.isFirstPage = vm.page <= 1;

                if (result.page * result.itemsPerPage < result.total) {
                    vm.isLastPage = false;
                }
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('papp')
        .controller('RoadMaintenanceModalController', RoadMaintenanceModalController);

    RoadMaintenanceModalController.$inject = ['$uibModalInstance', 'message', 'Notification'];

    function RoadMaintenanceModalController($uibModalInstance, message, Notification) {
        var vm = this;
        vm.message = message;
        vm.lastNotification = Notification.dieselNotificationLast.getLast();

        vm.ok = ok;
        vm.cancel = cancel;

        function ok() {
            $uibModalInstance.close(message);
        }

        function cancel() {
           $uibModalInstance.dismiss();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('papp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('Notification', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function () {
    "use strict";

    angular.module("papp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider.state("notificationHistoryDetails", {
            parent: "app",
            url: "/notification/history/details/:id",
            data: {
                authorities: [
                    "bilioslo-admin-dieselvarsel",
                    "bilioslo-admin-veivarsel",
                ],
            },
            views: {
                "content@": {
                    templateUrl:
                        "app/notification/history-details/notification.history.details.html",
                    controller: "NotificationHistoryDetailsController",
                    controllerAs: "vm",
                },
            },
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('papp')
        .controller('NotificationHistoryDetailsController', NotificationHistoryDetailsController);

    NotificationHistoryDetailsController.$inject = ['Notification', '$state', '$stateParams', 'DateUtils'];

    function NotificationHistoryDetailsController(Notification, $state, $stateParams, DateUtils) {
        var vm = this;
        vm.dateStart = null;
        vm.notification = {};
        vm.load = load;

        vm.load($stateParams.id);

        vm.dateOptions = {
            formatYear: 'yy',
            startingDay: 1
        };

        function load(id) {
            Notification.notification.getSingle({id: id}, function (result) {
                vm.notification = result;
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('papp')
        .controller('DieselSendModalController', DieselSendModalController);

    DieselSendModalController.$inject = ['$uibModalInstance', 'message', 'Notification'];

    function DieselSendModalController($uibModalInstance, message, Notification) {
        var vm = this;
        vm.message = message;
        vm.lastNotification = Notification.dieselNotificationLast.getLast();

        vm.ok = ok;
        vm.cancel = cancel;

        function ok() {
            $uibModalInstance.close(message);
        }

        function cancel() {
           $uibModalInstance.dismiss();
        }
    }
})();

(function () {
    "use strict";

    angular.module("papp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider.state("dieselSendNotification", {
            parent: "Notification",
            url: "/notification/diesel-send",
            data: {
                authorities: ["bilioslo-admin-dieselvarsel"],
            },
            views: {
                "content@": {
                    templateUrl:
                        "app/notification/diesel-send/diesel-send.html",
                    controller: "DieselSendNotificationController",
                    controllerAs: "vm",
                },
            },
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('papp')
        .controller('DieselSendNotificationController', DieselSendNotificationController);

    DieselSendNotificationController.$inject = ['$http', 'Notification', 'NotificationMessage', 'DateUtils', '$uibModal', 'URL_BIL_I_OSLO_SERVICE'];

    function DieselSendNotificationController($http, Notification, NotificationMessage, DateUtils, $uibModal, URL_BIL_I_OSLO_SERVICE) {
        var vm = this;

        vm.loadAll = function () {
            vm.dieselMessages = Notification.dieselMessages.getDieselMessages();
            vm.activeDieselBan = Notification.activeDieselBan.getActiveDieselBan();

            vm.endOfMessageNo = {};
            vm.endOfMessageEn = {};
            vm.endOfMessageNo.START = NotificationMessage.createEndOfMessageStartNo(null, null, null);
            vm.endOfMessageEn.START = NotificationMessage.createEndOfMessageStartEn(null, null, null);
            vm.endOfMessageNo.STOP = NotificationMessage.createEndOfMessageStopNo(null, null, null);
            vm.endOfMessageEn.STOP = NotificationMessage.createEndOfMessageStopEn(null, null, null);

            vm.endOfBoardFirstMessageNo = {};
            vm.endOfBoardFirstMessageEn = {};
            vm.endOfBoardFirstMessageNo.START = NotificationMessage.createEndOfBoardFirstMessageStartNo(null, null, null);
            vm.endOfBoardFirstMessageEn.START = NotificationMessage.createEndOfBoardFirstMessageStartEn(null, null, null);
            vm.endOfBoardFirstMessageNo.STOP = NotificationMessage.createEndOfBoardFirstMessageStopNo(null, null, null);
            vm.endOfBoardFirstMessageEn.STOP = NotificationMessage.createEndOfBoardFirstMessageStopEn(null, null, null);
        };
        vm.loadAll();

        vm.changeDate = changeDate;
        vm.openDatePickerFrom = openDatePickerFrom;
        vm.openDatePickerTo = openDatePickerTo;
        vm.sendDiesel = sendDiesel;
        vm.submit = submit;

        function openDatePickerFrom(message) {
            message.isFromPickerOpen = true;
        }
        function openDatePickerTo(message) {
            message.isToPickerOpen = true;
        }

        function changeDate(message) {
            clearErrorMessages();
            if (isInputTooHigh(message))
                return;

            switch(message.type) {
                case 'START':
                    changeDateStart(message)
                    break;
                case 'STOP':
                    changeDateStop(message)
                    break;
            }
        }

        function changeDateStart(message) {
            vm.endOfMessageNo.START = NotificationMessage.createEndOfMessageStartNo(message.fromDate, message.fromHour, message.fromMin);
            vm.endOfMessageEn.START = NotificationMessage.createEndOfMessageStartEn(message.fromDate, message.fromHour, message.fromMin);
            vm.endOfBoardFirstMessageNo.START = NotificationMessage.createEndOfBoardFirstMessageStartNo(message.fromDate, message.fromHour, message.fromMin);
            vm.endOfBoardFirstMessageEn.START = NotificationMessage.createEndOfBoardFirstMessageStartEn(message.fromDate, message.fromHour, message.fromMin);

        }
        function changeDateStop(message) {
            vm.endOfMessageNo.STOP = NotificationMessage.createEndOfMessageStopNo(message.fromDate, message.fromHour, message.fromMin);
            vm.endOfMessageEn.STOP = NotificationMessage.createEndOfMessageStopEn(message.fromDate, message.fromHour, message.fromMin);
            vm.endOfBoardFirstMessageNo.STOP = NotificationMessage.createEndOfBoardFirstMessageStopNo(message.fromDate, message.fromHour, message.fromMin);
            vm.endOfBoardFirstMessageEn.STOP = NotificationMessage.createEndOfBoardFirstMessageStopEn(message.fromDate, message.fromHour, message.fromMin);
        }

        function createCompositeBoardFirstMessageNo(message) {
            switch (message.type) {
                case "START":
                    return vm.endOfBoardFirstMessageNo[message.type] + message.messageNo.boardFirstMessage;
                case "STOP":
                    return  message.messageNo.boardFirstMessage + " " + vm.endOfBoardFirstMessageNo[message.type];
            }
        }

        function createCompositeBoardFirstMessageEn(message) {
            switch (message.type) {
                case "START":
                    return vm.endOfBoardFirstMessageEn[message.type] + message.messageEn.boardFirstMessage;
                case "STOP":
                    return  message.messageEn.boardFirstMessage + " " + vm.endOfBoardFirstMessageEn[message.type];
            }
        }

        function submit(message, $index) {
            vm.tempMessage = message;

            if (!isCorrectInput(message))
                return;
            var modalInstance = $uibModal.open({
                  animation: true,
                  ariaLabelledBy: 'modal-title',
                  ariaDescribedBy: 'modal-body',
                  templateUrl: 'app/notification/diesel-send/modal/diesel-send-modal.html',
                  controller: 'DieselSendModalController',
                  controllerAs: 'vm',
                  resolve: {
                    message: function () {
                      message.fromDateTime = message.fromDate;
                      message.fromDateTime.setHours(message.fromHour);
                      message.fromDateTime.setMinutes(message.fromMin);
                      message.messageNo.pushMessageModal = message.messageNo.pushMessage + " " + vm.endOfMessageNo[message.type];
                      message.messageEn.pushMessageModal = message.messageEn.pushMessage + " " + vm.endOfMessageEn[message.type];
                      message.messageNo.boardFirstMessageModal = createCompositeBoardFirstMessageNo(message)
                      message.messageEn.boardFirstMessageModal = createCompositeBoardFirstMessageEn(message)
                      return message;
                    }
                  }
            });

            modalInstance.result.then(function (message) {
                    console.log("Confirmed sending diesel-ban with type " + message.type)
                    sendDiesel(message, $index)
                }, function () {
                    console.log("Canceled sending of diesel-ban")
                });

        }

        function sendDiesel(message, $index) {
            clearErrorMessages();
            message.error = "Sender...";

            var messageNo = {}
            var messageEn = {}
            messageNo.pushMessage = message.messageNo.pushMessage + " " + vm.endOfMessageNo[message.type];
            messageEn.pushMessage = message.messageEn.pushMessage + " " + vm.endOfMessageEn[message.type];
            messageNo.boardTitle = message.messageNo.boardTitle;
            messageEn.boardTitle = message.messageEn.boardTitle;
            messageNo.boardFirstMessage = createCompositeBoardFirstMessageNo(message)
            messageEn.boardFirstMessage = createCompositeBoardFirstMessageEn(message)
            messageNo.boardSecondMessage = message.messageNo.boardSecondMessage;
            messageEn.boardSecondMessage = message.messageEn.boardSecondMessage;
            messageNo.boardUrl = message.messageNo.boardUrl;
            messageEn.boardUrl = message.messageEn.boardUrl;

            return $http.post(URL_BIL_I_OSLO_SERVICE + 'api/Admin/SimpleNotificationService', {
                topic: "DIESEL",
                type: message.type,
                topicTypeId: message.snsTopicTypeId,
                validFrom: DateUtils.convertLocalDateTimeToServer (message.fromDate, message.fromHour, message.fromMin),
                messageNo: messageNo,
                messageEn: messageEn,
            }).success(function (response) {
                console.log('successfully sent notification about diesel');
                message.error = "Dieselforbud sendt!";
                return response;
            }).error(function (e, status) {
                if (status == 403) {
                    message.error = "Mangler rettigheter...";
                } else {
                    message.error = "Sending feilet!";
                }
                console.log('Sending of notification failed');
            }).finally(function() {
                vm.activeDieselBan = Notification.activeDieselBan.getActiveDieselBan();
            });
        }

        function isCorrectInput(message) {
            clearErrorMessages()
            if (isInputNull(message) || isInputTooHigh(message) || isInputToLow(message))
                return false;

            switch(message.type) {
                case 'START':
                    return isCorrectDateStart(message);
                case 'STOP':
                    return isCorrectDateStop(message);
            }
        }

        function isCorrectDateStart(message) {

            var tomorrow = new Date()
            tomorrow.setDate(tomorrow.getDate()+1)
            tomorrow.setSeconds(tomorrow.getSeconds()-10)
            if (message.fromDate < tomorrow ) {
                message.error = "Dieselforbud må settes minst 24 timer før";
                return false
            }
            var inAMonth = new Date()
            inAMonth.setMonth(inAMonth.getMonth()+1)
            if (message.fromDate > inAMonth ) {
                message.error = "Dieselforbud må settes innen en måned";
                return false
            }
            return true;
        }

        function isCorrectDateStop(message) {
            var now = new Date()
            if (message.fromDate < now ) {
                message.error = "Dato må være fram i tid";
                return false
            }
            var inAMonth = new Date()
            inAMonth.setMonth(inAMonth.getMonth()+1)
            if (message.fromDate > inAMonth ) {
                message.error = "Må stoppes innen en måned";
                return false
            }
            return true;
        }

        function isInputNull(message) {
            if (message.fromDate == null) {
                message.error = "Mangler dato...";
                return true;
            }
            if (message.fromHour == null || message.fromHour == "") {
                message.error = "Mangler tid i timer";
                return true;
            }
            if (message.fromMin == null || message.fromMin == "") {
                message.error = "Mangler tid i minutter";
                return true;
            }
            return false;
        }

        function isInputTooHigh(message) {
            if (message.fromHour > 23 || isNotDigit(message.fromHour)) {
                message.error = "Gyldige verdier for timer er: 00-23";
                return true;
            }
            if (message.fromMin > 59 || isNotDigit(message.fromMin)) {
                message.error = "Gyldige verdier for minutter er: 00-59";
                return true;
            }
            if (message.fromHour != null && message.fromHour.length > 2) {
                message.error = "Timer skrives med to tall.";
                return true;
            }
            if (message.fromMin != null && message.fromHour.length > 2) {
                message.error = "Minutter skrives med to tall.";
                return true;
            }
            return false;
        }

        function isInputToLow(message) {
            if (message.fromHour < 0 || isNotDigit(message.fromHour)) {
                message.error = "Gyldige verdier for timer er: 00-23";
                return true;
            }
            if (message.fromMin < 0 || isNotDigit(message.fromMin)) {
                message.error = "Gyldige verdier for minutter er: 00-59";
                return true;
            }
        }

        function isNotDigit(number){
            return (number != null && number != "") && ! /^\d+$/.test(number)
        }

        function clearErrorMessages() {
            vm.dieselMessages[0].error = null;
            vm.dieselMessages[1].error = null;
        }
    }
})();

(function () {
    "use strict";

    angular.module("papp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider.state("dieselHistoryNotification", {
            parent: "Notification",
            url: "/notification/diesel-history",
            data: {
                authorities: ["bilioslo-admin-dieselvarsel"],
            },
            views: {
                "content@": {
                    templateUrl:
                        "app/notification/diesel-history/diesel-history.html",
                    controller: "DieselHistoryNotificationController",
                    controllerAs: "vm",
                },
            },
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('papp')
        .controller('DieselHistoryNotificationController', DieselHistoryNotificationController);

    DieselHistoryNotificationController.$inject = ['$state', '$stateParams', 'DateUtils', 'Notification'];

    function DieselHistoryNotificationController($state, $stateParams, DateUtils, Notification) {
        var vm = this;
        var page = 1;
        var dateCreated = null;
        vm.notifications = [];

        vm.isFirstPage = true;
        vm.isLastPage = true;
        vm.dateCreatedInput = null;

        vm.prevPage = prevPage;
        vm.nextPage = nextPage;
        vm.search = search;
        vm.clearSearch = clearSearch;
        vm.showHistoryDetails = showHistoryDetails;
        vm.openDatePicker = openDatePicker;

        function prevPage() {
            $state.go('dieselHistoryNotification', {
                page: page - 1,
                dateCreated: (dateStart ? DateUtils.convertLocalDateToServer(dateStart) : null)
            });
        }

        function nextPage() {
            $state.go('dieselHistoryNotification', {
                page: page + 1,
                dateCreated: (dateStart ? DateUtils.convertLocalDateToServer(dateStart) : null)
            });
        }

        function search() {
            $state.go('dieselHistoryNotification', {
                page: 1,
                dateCreated: (vm.dateStartInput ? DateUtils.convertLocalDateToServer(vm.dateStartInput) : null)
            });
        }

        function clearSearch() {
            vm.dateCreatedInput = null;

            $state.go('dieselHistoryNotification', {
                page: 1,
                dateCreated: null
            });
        }

//        function showParking(parking) {
//            $state.go('parkingDetails', {
//                id: parking.id
//            });
//        }

        page = parseInt($stateParams.page, 10);
        if (!page) {
            page = 1;
        }

        if ($stateParams.dateCreated)
            dateStart = new Date($stateParams.dateStart);

        vm.dateCreatedInput = dateCreated;

        vm.dateOptions = {
            formatYear: 'yy',
            startingDay: 1
        };

        vm.popupDatePicker = {
            opened: false
        };

        function openDatePicker() {
            vm.popupDatePicker.opened = true;
        }

        function showHistoryDetails(notification) {
            $state.go('notificationHistoryDetails', {
                id: notification.id
            });
        }

        Notification.notifications.getNotifications({
            topic: 'DIESEL',
            page: page,
            dateCreated: (dateCreated ? DateUtils.convertLocalDateToServer(dateCreated) : null)
        }, function (result) {
            vm.notifications = result;
            vm.isFirstPage = page <= 1;

            if (result.page * result.itemsPerPage < result.total) {
                vm.isLastPage = false;
            }
        });
    }
})();

(function () {
    "use strict";

    angular.module("papp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider.state("dieselEditNotification", {
            parent: "Notification",
            url: "/notification/diesel-edit",
            data: {
                authorities: ["bilioslo-admin-dieselvarsel"],
            },
            views: {
                "content@": {
                    templateUrl:
                        "app/notification/diesel-edit/diesel-edit.html",
                    controller: "DieselEditNotificationController",
                    controllerAs: "vm",
                },
            },
        });
    }
})();

(function () {
    "use strict";

    angular
        .module("papp")
        .controller(
            "DieselEditNotificationController",
            DieselEditNotificationController
        );

    DieselEditNotificationController.$inject = [
        "$http",
        "Notification",
        "NotificationMessage",
        "Principal",
        "URL_BIL_I_OSLO_SERVICE",
    ];

    function DieselEditNotificationController(
        $http,
        Notification,
        NotificationMessage,
        Principal,
        URL_BIL_I_OSLO_SERVICE
    ) {
        var vm = this;

        vm.loadAll = function () {
            vm.dieselMessages = Notification.dieselMessages.getDieselMessages();

            vm.endOfMessageStartNo =
                NotificationMessage.createEndOfComposedMessageStartNo();
            vm.endOfMessageStartEn =
                NotificationMessage.createEndOfComposedMessageStartEn();
            vm.endOfMessageStopNo =
                NotificationMessage.createEndOfComposedMessageStopNo();
            vm.endOfMessageStopEn =
                NotificationMessage.createEndOfComposedMessageStopEn();

            vm.endOfBoardFirstMessageNo = {};
            vm.endOfBoardFirstMessageEn = {};
            vm.endOfBoardFirstMessageNo.START =
                NotificationMessage.createEndOfBoardFirstMessageStartNo(
                    null,
                    null,
                    null
                );
            vm.endOfBoardFirstMessageEn.START =
                NotificationMessage.createEndOfBoardFirstMessageStartEn(
                    null,
                    null,
                    null
                );
            vm.endOfBoardFirstMessageNo.STOP =
                NotificationMessage.createEndOfBoardFirstMessageStopNo(
                    null,
                    null,
                    null
                );
            vm.endOfBoardFirstMessageEn.STOP =
                NotificationMessage.createEndOfBoardFirstMessageStopEn(
                    null,
                    null,
                    null
                );
        };
        vm.loadAll();

        vm.makeEditable = makeEditable;
        vm.cancelMessage = cancelMessage;
        vm.saveMessage = saveMessage;
        vm.show = show;

        function show(message) {
            message.show = !message.show;
        }

        function makeEditable(messageLangKey, parameter) {
            clearErrorMessages();
            if (isEditMode()) return;

            Principal.hasAuthority("bilioslo-admin-dieselvarsel").then(
                function (result) {
                    if (result) {
                        switch (parameter) {
                            case "PUSH_MESSAGE":
                                vm.messageTemp = messageLangKey.pushMessage;
                                messageLangKey.isEditable.pushMessage = true;
                                break;
                            case "BOARD_TITLE":
                                vm.messageTemp = messageLangKey.boardTitle;
                                messageLangKey.isEditable.boardTitle = true;
                                break;
                            case "BOARD_FIRST_MESSAGE":
                                vm.messageTemp =
                                    messageLangKey.boardFirstMessage;
                                messageLangKey.isEditable.boardFirstMessage = true;
                                break;
                            case "BOARD_SECOND_MESSAGE":
                                vm.messageTemp =
                                    messageLangKey.boardSecondMessage;
                                messageLangKey.isEditable.boardSecondMessage = true;
                                break;
                            case "BOARD_URL":
                                vm.messageTemp = messageLangKey.boardUrl;
                                messageLangKey.isEditable.boardUrl = true;
                                break;
                        }
                        return;
                    }
                }
            );
        }

        function cancelMessage(messageLangKey, parameter) {
            switch (parameter) {
                case "PUSH_MESSAGE":
                    messageLangKey.pushMessage = vm.messageTemp;
                    break;
                case "BOARD_TITLE":
                    messageLangKey.boardTitle = vm.messageTemp;
                    break;
                case "BOARD_FIRST_MESSAGE":
                    messageLangKey.boardFirstMessage = vm.messageTemp;
                    break;
                case "BOARD_SECOND_MESSAGE":
                    messageLangKey.boardSecondMessage = vm.messageTemp;
                    break;
                case "BOARD_URL":
                    messageLangKey.boardUrl = vm.messageTemp;
                    break;
            }
            turnOffEditMode();
        }

        function saveMessage(messageLangKey, parameter) {
            turnOffEditMode();
            turnOffErrorMessages();
            switch (parameter) {
                case "PUSH_MESSAGE":
                    if (messageLangKey.pushMessage == vm.messageTemp) return;
                    messageLangKey.isError.pushMessage = true;
                    sendMessage(messageLangKey);
                    return;
                case "BOARD_TITLE":
                    if (messageLangKey.boardTitle == vm.messageTemp) return;
                    messageLangKey.isError.boardTitle = true;
                    sendMessage(messageLangKey);
                    return;
                case "BOARD_FIRST_MESSAGE":
                    if (messageLangKey.boardFirstMessage == vm.messageTemp)
                        return;
                    messageLangKey.isError.boardFirstMessage = true;
                    sendMessage(messageLangKey);
                    return;
                case "BOARD_SECOND_MESSAGE":
                    if (messageLangKey.boardSecondMessage == vm.messageTemp)
                        return;
                    messageLangKey.isError.boardSecondMessage = true;
                    sendMessage(messageLangKey);
                    return;
                case "BOARD_URL":
                    if (messageLangKey.boardUrl == vm.messageTemp) return;
                    messageLangKey.isError.boardUrl = true;
                    sendMessage(messageLangKey);
                    return;
            }
        }

        function sendMessage(messageLangKey) {
            clearErrorMessages();
            vm.info = "Sender...";
            return $http
                .patch(
                    URL_BIL_I_OSLO_SERVICE +
                        "api/Admin/SimpleNotificationService/Diesel/DefaultMessage",
                    {
                        id: messageLangKey.id,
                        pushMessage: messageLangKey.pushMessage,
                        boardTitle: messageLangKey.boardTitle,
                        boardFirstMessage: messageLangKey.boardFirstMessage,
                        boardSecondMessage: messageLangKey.boardSecondMessage,
                        boardUrl: messageLangKey.boardUrl,
                    }
                )
                .success(function (response) {
                    console.log("successfully edit message");
                    clearErrorMessages();
                    vm.success = "Teksten er oppdatert";
                    return response;
                })
                .error(function (e, status) {
                    clearErrorMessages();
                    if (status == 403) {
                        vm.error = "Mangler rettigheter...";
                    } else {
                        vm.error = "Oppdatering feilet!";
                    }
                    console.log("Message update failed");
                });
        }

        function isEditMode() {
            var isEditMode = false;

            angular.forEach(vm.dieselMessages, function (message) {
                if (message.messageNo.isEditable == null)
                    message.messageNo.isEditable = {};
                if (message.messageEn.isEditable == null)
                    message.messageEn.isEditable = {};

                if (
                    !angular.equals(message.messageNo.isEditable, {}) ||
                    !angular.equals(message.messageEn.isEditable, {})
                )
                    isEditMode = true;
            });
            return isEditMode;
        }

        function turnOffEditMode() {
            angular.forEach(vm.dieselMessages, function (message) {
                message.messageNo.isEditable = {};
                message.messageEn.isEditable = {};
            });
        }
        function turnOffErrorMessages() {
            angular.forEach(vm.dieselMessages, function (message) {
                message.messageNo.isError = {};
                message.messageEn.isError = {};
            });
        }

        function clearErrorMessages() {
            vm.info = null;
            vm.success = null;
            vm.error = null;
        }
    }
})();

(function () {
    "use strict";

    angular.module("papp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider.state("infoMessage", {
            parent: "app",
            url: "/info-message",
            data: {
                authorities: ["bilioslo-admin", "bilioslo-admin-lese"],
            },
            views: {
                "content@": {
                    templateUrl: "app/messages/info-message.html",
                    controller: "InfoMessageController",
                    controllerAs: "vm",
                },
            },
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('papp')
        .controller('InfoMessageController', InfoMessageController);

    InfoMessageController.$inject = ['$http', '$state', 'Message', 'DateUtils', 'TimeUtils', '$uibModal', '$sce', 'URL_BIL_I_OSLO_SERVICE'];

    function InfoMessageController($http, $state, Message, DateUtils, TimeUtils, $uibModal, $sce, URL_BIL_I_OSLO_SERVICE) {
        var vm = this;

        vm.loadAll = function () {
            getMessages();
            getNextId();
        };    

        vm.fromDate = null;
        vm.toDate = null;
        vm.messageLanguage = "nb";
        vm.messageTitle =null;
        vm.messageText=null;
        vm.messageUrl=null;
        vm.errorMessage = null;

        vm.popupDatePickerFrom = {
            opened: false
        };
        vm.popupDatePickerTo = {
            opened: false
        };
        vm.page = 1
        vm.isOnlyOnePage = 1;

        vm.openDatePickerFrom = openDatePickerFrom;
        vm.openDatePickerTo = openDatePickerTo;
        vm.delete = deleteMessage;
        vm.submit = submit;
        vm.prevPage = prevPage;
        vm.nextPage = nextPage;

        vm.loadAll();

        function getMessages() {
            Message.messages.getMessages({
                page: vm.page
            }, function (result) {
                vm.messages = result.informationMessages;
                vm.isFirstPage = vm.page <= 1;
                vm.isLastPage =  (result.page * result.itemsPerPage >= result.total) 
                vm.isOnlyOnePage = vm.isFirstPage && vm.isLastPage;
            });
        }

        
        function openDatePickerFrom() {
            vm.popupDatePickerFrom.opened = true;
        }

        function openDatePickerTo() {
            vm.popupDatePickerTo.opened = true;
        }

        function submit() {
            if (!validate())
                return false;
            checkIdLanguageInDb(function(id){
                if (id==null) {
                    $http.post(URL_BIL_I_OSLO_SERVICE + 'api/Admin/InformationMessage',{                        
                        messageId: vm.messageId,
                        language: vm.messageLanguage,
                        title: vm.messageTitle,
                        text: vm.messageText,
                        url: vm.messageUrl,
                        validFrom: vm.fromDate,
                        validUntil: vm.toDate 
                    }
                        ).success(function (response) {
                            console.log('successfully added new message to DB');                
                            getNextId();
                            getMessages();
                        }).error(function (e, status) {                
                            if (status == 403) {
                                vm.errorMessage = $sce.trustAsHtml("Mangler rettigheter...");
                            } else {
                                vm.errorMessage = $sce.trustAsHtml("Klarte ikke legge inn meldingen.");
                            }
                            console.log('Error while fetching next available id from database');
                        });
                } else {
                    $http.put(URL_BIL_I_OSLO_SERVICE + 'api/Admin/InformationMessage/'+vm.messageId,{
                        id: id,
                        messageId: vm.messageId,
                        language: vm.messageLanguage,
                        title: vm.messageTitle,
                        text: vm.messageText,
                        url: vm.messageUrl,
                        validFrom: vm.fromDate,
                        validUntil: vm.toDate 
                    }
                        ).success(function (response) {
                            console.log('successfully updated message');                
                            getNextId();
                            getMessages();
                        }).error(function (e, status) {                
                            if (status == 403) {
                                vm.errorMessage = $sce.trustAsHtml("Mangler rettigheter...");
                            } else {
                                vm.errorMessage = $sce.trustAsHtml("Klarte ikke oppdatere meldingen.");
                            }
                            console.log('Error while updating message in database');
                        });
                    getMessages();
                }            
            });        
            return true;
        }
        
        function validate() {
            var errors = [];
            if (isNaN(vm.messageId)) errors.push("Id-feltet har ikke gyldig verdi.");
            if (vm.messageLanguage!="en" && vm.messageLanguage!="nb") errors.push("Språk har ikke gyldig verdi. ");
            if (vm.fromDate == null || typeof vm.fromDate.getMonth !== 'function') errors.push("Fra-dato må spesifiseres med formatet dd.mm.åååå. ");
            if (vm.toDate == null || typeof vm.toDate.getMonth !== 'function') errors.push("Til-dato må spesifiseres med formatet dd.mm.åååå. ");
            if (vm.messageTitle==null || vm.messageTitle.length<1) errors.push("Melding må inneholde en tittel. ");
            if (vm.messageText==null || vm.messageText.length<1) errors.push("Melding må inneholde en tekst. ");

            vm.errorMessage =  $sce.trustAsHtml(errors.join("<br/>"));

            return vm.errorMessage=="";
        }

        function checkIdLanguageInDb(success) {
            $http.get(URL_BIL_I_OSLO_SERVICE + 'api/Admin/InformationMessage/'+vm.messageId+'/'+vm.messageLanguage
            ).success(function (response) {
                console.log('successfully fetched messages');                
                if (response.length>0) {
                    if (response.length>1)
                    {
                        vm.errorMessage = $sce.trustAsHtml("Databasen inneholder duplikate forekomster, vennligst kontakt A-Team");
                    }
                    if (confirm("Kombinasjonen eksisterer allerede, ønsker du å overskrive eksisterende?")) {           
                        success(response[0].id);
                    }
                } else { 
                    success();
                }                
            }).error(function (e, status) {                
                if (status == 403) {
                    vm.errorMessage = $sce.trustAsHtml("Mangler rettigheter...");
                } else {
                    vm.errorMessage = $sce.trustAsHtml("Klarte ikke sjekke om kombinasjon id/spåk allerede er i bruk.");
                }
                console.log('Error while fetching message by id and language from database');
            });
        }

        function getNextId() {
            return $http.get(URL_BIL_I_OSLO_SERVICE + 'api/Admin/InformationMessage/NextId')
            .success(function (response) {
                console.log('successfully fetched next available id');                
                vm.messageId = response;
            })
            .error(function (e, status) {                
                if (status == 403) {
                    vm.errorMessage = "Mangler rettigheter...";
                } else {
                    vm.errorMessage = "Klarte ikke hente neste tilgjengelige ID.";
                }
                console.log('Error while fetching next available id from database');
            });
        }
         
        function prevPage() {
            vm.page--;
            getMessages();
        }

        function nextPage() {
            vm.page++;
            getMessages();
        }

        function deleteMessage(id) {
            if (confirm("Er du sikker på at du ønsker å slette denne raden?")) {
                $http.delete(URL_BIL_I_OSLO_SERVICE + 'api/Admin/InformationMessage/'+id
                    ).success(function (response) {
                        console.log('successfully deleted message');                
                        getNextId();
                        getMessages();
                    }).error(function (e, status) {                
                        if (status == 403) {
                            vm.errorMessage = $sce.trustAsHtml("Mangler rettigheter...");
                        } else {
                            vm.errorMessage = $sce.trustAsHtml("Klarte ikke slette meldingen.");
                        }
                        console.log('Error while deleting message in database');
                    });
            }            
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('papp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('login', {
            parent: 'app',
            url: '/login',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/login/login.html',
                    controller: 'LoginController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function () {
    "use strict";

    angular.module("papp").controller("LoginController", LoginController);

    LoginController.$inject = [
        "$scope",
        "Principal",
        "Auth",
        "ONELOGIN_SUBDOMAIN",
        "$sce",
        "$timeout",
    ];

    function LoginController(
        $scope,
        Principal,
        Auth,
        ONELOGIN_SUBDOMAIN,
        $sce,
        $timeout
    ) {
        var vm = this;
        var mgr = Auth.mgr;
        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = login;
        vm.logout = logout;
        vm.showLogin = true;
        vm.oneloginframe = "";
        vm.isLoggingIn = window.location.search.startsWith("?code");

        if (vm.isLoggingIn) {
            $timeout(function () {
                vm.isLoggingIn = false;
            }, 5000);
        }

        $scope.$on("authenticationComplete", function (evt, data) {
            console.log(
                "Broadcast received: authenticationComplete with " + data
            );
            getAccount(data);
        });

        function login(event) {
            vm.authenticationError = false;
            vm.authenticationErrorMailTo = false;
            event.preventDefault();

            mgr.signinRedirect()
                .then(function () {})
                .catch(function (err) {
                    console.log(err);
                });
        }

        getAccount();

        function logout() {
            vm.oneloginframe = $sce.trustAsResourceUrl(
                "https://" + ONELOGIN_SUBDOMAIN + ".onelogin.com/oidc/2/logout"
            );
            vm.showLogin = true;
            vm.authenticationError = false;
        }

        function getAccount(user) {
            var params = new URLSearchParams(window.location.search);
            vm.authenticationErrorMessage = params.get("error_description");
            if (vm.authenticationErrorMessage) {
                vm.authenticationError = true;
                vm.showLogin = false;
            } else {
                vm.authenticationError = false;
                vm.account = user;
                vm.isAuthenticated = Principal.isAuthenticated;
            }
        }
    }
})();

(function () {
    "use strict";

    angular.module("papp").controller("NavbarController", NavbarController);

    NavbarController.$inject = ["$scope", "$state", "Auth", "Principal"];

    function NavbarController($scope, $state, Auth, Principal) {
        var vm = this;

        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;

        setAccount();

        $scope.$on("authenticationComplete", function (evt, user) {
            setAccount(user);
        });

        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.$state = $state;

        function setAccount(user) {
            if (user) {
                vm.user = user.profile.sub;
                vm.userName = user.profile.name;
            } else {
                Principal.identity().then(function (data) {
                    if (data && data.profile) {
                        vm.user = data.profile.sub;
                        vm.userName = data.profile.name;
                    }
                });
            }
        }

        function logout() {
            collapseNavbar();
            Auth.logout();
            $state.go("login");
        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('papp')
        .directive('activeLink', activeLink);

    function activeLink() {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var clazz = attrs.activeLink;
            var path = attrs.href;
            path = path.substring(1); //hack because path does bot return including hashbang
            scope.location = location;
            scope.$watch('location.path()', function(newPath) {
                if (path === newPath) {
                    element.addClass(clazz);
                } else {
                    element.removeClass(clazz);
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('papp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('error', {
                parent: 'app',
                url: '/error',
                data: {
                    authorities: [],
                    pageTitle: 'Feil!'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/error.html'
                    }
                }
            })
            .state('accessdenied', {
                parent: 'app',
                url: '/accessdenied',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/accessdenied.html'
                    }
                }
            });
    }
})();

(function () {
    "use strict";

    angular.module("papp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider.state("home", {
            parent: "app",
            url: "/",
            data: {
                authorities: [
                    "bilioslo-admin",
                    "bilioslo-admin-lese",
                    "bilioslo-admin-dieselvarsel",
                    "bilioslo-admin-veivarsel",
                ],
            },
            views: {
                "content@": {
                    templateUrl: "app/home/home.html",
                    controller: "HomeController",
                    controllerAs: "vm",
                },
            },
        });
    }
})();

(function () {
    "use strict";

    angular.module("papp").controller("HomeController", HomeController);

    HomeController.$inject = ["$state", "Principal"];

    function HomeController($state, Principal) {
        Principal.hasAuthority("bilioslo-admin-veivarsel").then(function (
            result
        ) {
            if (result) {
                $state.go("roadMaintenanceNotification");
            }
        });
        Principal.hasAuthority("bilioslo-admin-dieselvarsel").then(function (
            result
        ) {
            if (result) {
                $state.go("dieselSendNotification");
            }
        });
        Principal.hasAuthority("bilioslo-admin-lese").then(function (result) {
            if (result) {
                $state.go("parking");
            }
        });
        Principal.hasAuthority("bilioslo-admin").then(function (result) {
            if (result) {
                $state.go("parking");
            }
        });
    }
})();

(function () {
    "use strict";

    angular.module("papp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider.state("customerDetails", {
            parent: "app",
            url: "/customer/details/:id",
            data: {
                authorities: ["bilioslo-admin", "bilioslo-admin-lese"],
            },
            views: {
                "content@": {
                    templateUrl: "app/customer/details/customer.details.html",
                    controller: "CustomerDetailsController",
                    controllerAs: "vm",
                },
            },
        });
    }
})();

(function () {
    "use strict";

    angular
        .module("papp")
        .controller("CustomerDetailsController", CustomerDetailsController);

    CustomerDetailsController.$inject = [
        "Customer",
        "Parking",
        "StuddedTire",
        "$state",
        "$stateParams",
        "DateUtils",
        "$scope",
        "Logs",
        "Principal",
    ];

    function CustomerDetailsController(
        Customer,
        Parking,
        StuddedTire,
        $state,
        $stateParams,
        DateUtils,
        $scope,
        Logs,
        Principal
    ) {
        var vm = this;
        vm.dateStart = null;
        vm.customerDetail = {};
        vm.logs = [];
        vm.load = load;

        vm.fromLogHour = "00";
        vm.fromLogMinute = "00";
        vm.toLogHour = "00";
        vm.toLogMinute = "00";

        vm.accessRequest = accessRequest;
        vm.anonomizeRequest = anonomizeRequest;

        var studdedTirePage = 1;
        vm.isFirstStuddedTirePage = true;
        vm.isLastStuddedTirePage = true;
        vm.prevStuddedTirePage = prevStuddedTirePage;
        vm.nextStuddedTirePage = nextStuddedTirePage;
        vm.showStuddedTire = showStuddedTire;

        var parkingPage = 1;
        vm.logUnmodified = false;
        vm.isFirstParkingPage = true;
        vm.isLastParkingPage = true;
        vm.prevParkingPage = prevParkingPage;
        vm.nextParkingPage = nextParkingPage;
        vm.searchParking = searchParking;
        vm.clearParkingSearch = clearParkingSearch;
        vm.showParking = showParking;
        vm.searchLogs = searchLogs;

        vm.openDatePicker = openDatePicker;
        vm.openLogFromDatePicker = openLogFromDatePicker;
        vm.openLogToDatePicker = openLogToDatePicker;

        vm.deleteCustomer = deleteCustomer;

        Principal.hasAuthority("bilioslo-admin").then(function (result) {
            vm.showLogSection = result;
        });

        vm.hours = [
            "00",
            "01",
            "02",
            "03",
            "04",
            "05",
            "06",
            "07",
            "08",
            "09",
            "10",
            "11",
            "12",
            "13",
            "14",
            "15",
            "16",
            "17",
            "18",
            "19",
            "20",
            "21",
            "22",
            "23",
        ];
        vm.minutes = ["00", "15", "30", "45"];

        vm.load($stateParams.id);

        function accessRequest() {
            queryAccessRequest(vm.customerDetail.customer.id);
        }

        function anonomizeRequest() {
            updateToAnonomizedRequest(vm.customerDetail.customer.id);
        }

        function prevStuddedTirePage() {
            studdedTirePage = studdedTirePage - 1;
            queryStuddedTires();
        }

        function nextStuddedTirePage() {
            studdedTirePage = studdedTirePage + 1;
            queryStuddedTires();
        }

        function showStuddedTire(studdedTire) {
            $state.go("studdedTireDetails", {
                id: studdedTire.id,
            });
        }

        function prevParkingPage() {
            parkingPage = parkingPage - 1;
            queryParkings();
        }

        function nextParkingPage() {
            parkingPage = parkingPage + 1;
            queryParkings();
        }

        function searchParking() {
            parkingPage = 1;
            queryParkings();
        }

        function clearParkingSearch() {
            parkingPage = 1;
            vm.parkingPlateNumber = null;
            vm.dateStart = null;
            queryParkings();
        }

        function showParking(parking) {
            $state.go("parkingDetails", {
                id: parking.id,
            });
        }

        function searchLogs() {
            var fromDate = new Date(vm.logStartDate);
            var toDate = new Date(vm.logEndDate);
            fromDate.setHours(vm.fromLogHour);
            fromDate.setMinutes(vm.fromLogMinute);
            toDate.setHours(vm.toLogHour);
            toDate.setMinutes(vm.toLogMinute);

            console.log(
                "Sjekk logger fra " +
                    fromDate.toISOString() +
                    " til " +
                    toDate.toISOString()
            );

            Logs.getLogs(
                {
                    CustomerId: vm.customerDetail.customer.id,
                    FromDate: fromDate.toISOString(),
                    ToDate: toDate.toISOString(),
                    UnModified: vm.logUnmodified,
                },
                function (result) {
                    var loglines = [];

                    for (var i = 0; i < result.length; i++) {
                        var sp = result[i].split(" | ");
                        var logline = {
                            time: sp[0],
                            message: sp[1],
                        };
                        loglines.push(logline);
                    }
                    vm.logs = loglines;
                }
            );
        }

        vm.dateOptions = {
            formatYear: "yy",
            startingDay: 1,
        };

        vm.popupDatePicker = {
            opened: false,
        };

        vm.popupLogFromDatePicker = {
            opened: false,
        };
        vm.popupLogToDatePicker = {
            opened: false,
        };

        function openDatePicker() {
            vm.popupDatePicker.opened = true;
        }

        function openLogFromDatePicker() {
            vm.popupLogFromDatePicker.opened = true;
        }
        function openLogToDatePicker() {
            vm.popupLogToDatePicker.opened = true;
        }

        function queryAccessRequest(id) {
            Customer.getByIdAccessRequest.get({ id: id }, function (result) {
                var dataStr =
                    "data:text/json;charset=utf-8," +
                    encodeURIComponent(JSON.stringify(result, null, 4));
                var downloadAnchorNode = document.createElement("a");
                downloadAnchorNode.setAttribute("href", dataStr);
                downloadAnchorNode.setAttribute(
                    "download",
                    "customer" + id + ".json"
                );
                document.body.appendChild(downloadAnchorNode); // required for firefox
                downloadAnchorNode.click();
                downloadAnchorNode.remove();
            });
        }

        function updateToAnonomizedRequest(id) {
            var customerId = prompt(
                "Dette er et sikkerhetssteg for anonymisering av bruker. Når bruker anonymiseres vil ikke han eller hun kunne bruke appen mer. Tast inn bruker ID-en til bruker du prøver å anonymisere"
            );
            if (customerId === null) {
                return;
            } else if (customerId == id) {
                Customer.updateToAnonomizedRequest.update(
                    { id: customerId },
                    function (result) {
                        alert(
                            "Bruker med ID " +
                                id +
                                " er anonymisert. Siden lastes på nytt."
                        );
                        location.reload();
                    }
                );
            } else {
                alert(
                    "Du tastet inn " +
                        customerId +
                        ". Det samsvarer ikke med bruker-ID-en til brukeren du prøver å anonymisere."
                );
            }
        }

        function queryStuddedTires() {
            StuddedTire.query(
                {
                    page: studdedTirePage,
                    customerId: $stateParams.id,
                },
                function (result) {
                    vm.studdedTires = result.studdedTires;
                    vm.isFirstStuddedTirePage = studdedTirePage <= 1;
                    vm.isLastStuddedTirePage =
                        result.page * result.itemsPerPage >= result.total;
                }
            );
        }

        function queryParkings() {
            Parking.query(
                {
                    page: parkingPage,
                    plateNumber: vm.parkingPlateNumber,
                    customerId: $stateParams.id,
                    dateStart: vm.dateStart
                        ? DateUtils.convertLocalDateToServer(vm.dateStart)
                        : null,
                },
                function (result) {
                    vm.parkings = result.parkings;
                    vm.isFirstParkingPage = parkingPage <= 1;
                    vm.isLastParkingPage =
                        result.page * result.itemsPerPage >= result.total;
                }
            );
        }

        function load(id) {
            Customer.getById.get({ id: id }, function (result) {
                vm.customerDetail = result;
            });

            $scope.logFromHour = "00";
            $scope.logFromMinute = "00";

            $scope.logToHour = "00";
            $scope.logToMinute = "00";

            queryStuddedTires();
            queryParkings();
        }

        function deleteCustomer() {
            $state.go("customerDelete", {
                id: vm.customerDetail.customer.id,
            });
        }
    }
})();

(function () {
    "use strict";

    angular.module("papp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider.state("customer", {
            parent: "app",
            url: "/customer?page&plateNumber&email",
            data: {
                authorities: ["bilioslo-admin", "bilioslo-admin-lese"],
            },
            views: {
                "content@": {
                    templateUrl: "app/customer/customer.html",
                    controller: "CustomerController",
                    controllerAs: "vm",
                },
            },
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('papp')
        .controller('CustomerController', CustomerController);

    CustomerController.$inject = ['Customer', '$state', '$stateParams'];

    function CustomerController(Customer, $state, $stateParams) {
        var vm = this;
        var page = 1;
        var plateNumber = null;
        var email = null;
        var dateStart = null;

        vm.numberOfPages = 1;
        
        vm.customers = [];
       
        vm.plateNumberInput = null;
        vm.emailInput = null;
        
        vm.prevPage = prevPage;
        vm.nextPage = nextPage;
        vm.firstPage = firstPage;
        vm.lastPage = lastPage;
        vm.search = search;
        vm.clearSearch = clearSearch;
        vm.showCustomer = showCustomer;

        function prevPage() {
            toState(page - 1);
        }

        function nextPage() {
            toState(page + 1);
        }

        function firstPage() {
            toState(0);
        }

        function lastPage() {
            toState(vm.numberOfPages);
        }

        function toState(toPage){
            $state.go('customer', {
                page: toPage,
                plateNumber: plateNumber,
                email: email,
                dateStart: (dateStart ? DateUtils.convertLocalDateToServer(dateStart) : null)
            });
        } 

        function search() {
            $state.go('customer', {
                page: 1,
                plateNumber: (vm.plateNumberInput ? vm.plateNumberInput.toUpperCase() : null),
                email: (vm.emailInput ? vm.emailInput.toLowerCase() : null)
            });
        }

        function clearSearch() {
            $state.go('customer', {
                page: 1,
                plateNumber: null,
                email: null
            });
        }

        function showCustomer(customer) {
            $state.go('customerDetails', {
                id: customer.id
            });
        }

        page = parseInt($stateParams.page, 10);
        if (!page) {
            page = 1;
        }

        plateNumber = $stateParams.plateNumber;
        email = $stateParams.email;

        vm.plateNumberInput = plateNumber;
        vm.emailInput = email;

        Customer.getById.query({
            page: page,
            plateNumber: plateNumber,
            email: email
        }, function (result) {
            vm.customers = result.customers;
            plateNumber = result.plateNumber;
            email = result.email;

            vm.pagination = {
                page: page,
                total: result.total,
                itemsPerPage: result.itemsPerPage
            };

            vm.numberOfPages = result.itemsPerPage != 0 ? Math.ceil(result.total / result.itemsPerPage) : 0;
        });
    }
})(window.angular);

(function () {
    'use strict';

    angular
        .module('papp')
        .filter('vehicleGroup', vehicleGroup);

    function vehicleGroup() {
        return vehicleGroupFilter;

        function vehicleGroupFilter(vehiclePriceGroup) {
            var vehiclePriceGroups = {0:"Vanlig", 1:"El-bil", 2:"El-varebil"};
            return vehiclePriceGroups[vehiclePriceGroup];
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('papp')
        .filter('words', words);

    function words() {
        return wordsFilter;

        function wordsFilter(input, words) {
            if (isNaN(words)) {
                return input;
            }
            if (words <= 0) {
                return '';
            }
            if (input) {
                var inputWords = input.split(/\s+/);
                if (inputWords.length > words) {
                    input = inputWords.slice(0, words).join(' ') + '...';
                }
            }
            
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('papp')
        .filter('characters', characters);
        
    function characters () {
        return charactersFilter;

        function charactersFilter(input, chars, breakOnWord) {
            if (isNaN(chars)) {
                return input;
            }
            if (chars <= 0) {
                return '';
            }
            if (input && input.length > chars) {
                input = input.substring(0, chars);

                if (!breakOnWord) {
                    var lastspace = input.lastIndexOf(' ');
                    // Get last space
                    if (lastspace !== -1) {
                        input = input.substr(0, lastspace);
                    }
                } else {
                    while (input.charAt(input.length-1) === ' ') {
                        input = input.substr(0, input.length - 1);
                    }
                }
                return input + '...';
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('papp')
        .factory('TimeUtils', TimeUtils);

    TimeUtils.$inject = ['$filter'];

    function TimeUtils ($filter) {

        var service = {
            isTimeFormatTooHigh : isTimeFormatTooHigh,
            isTimeFormatTooLow : isTimeFormatTooLow,
        };

        return service;

        function isTimeFormatTooHigh(hour, min) {
            if (hour > 23 || isNotDigit(hour)) {
                return "Gyldige verdier for timer er: 00-23";
            }
            if (min > 59 || isNotDigit(min)) {
                return "Gyldige verdier for minutter er: 00-59";
            }
            if (hour != null && hour.length > 2) {
                return "Timer skrives med to tall.";
            }
            if (min != null && min.length > 2) {
                return "Minutter skrives med to tall.";
            }
            return null;
        }

        function isTimeFormatTooLow(hour, min) {
            if (hour < 0 || isNotDigit(hour)) {
                return "Gyldige verdier for timer er: 00-23";
            }
            if (min < 0 || isNotDigit(min)) {
                return "Gyldige verdier for minutter er: 00-59";
            }
        }

        function isNotDigit(number){
            return (number != null && number != "") && ! /^\d+$/.test(number)
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('papp')
        .filter('studdedTireType', studdedTireType);

    function studdedTireType() {
        return studdedTireTypeFilter;

        function studdedTireTypeFilter (input) {
            if (!input || 0 === input.length) {
                return 'Ukjent';
            }
            if (input === 'SEASON') {
                return "Sesong";
            }
            if (input === 'MONTH') {
                return "Måned";
            }
            if (input === 'DAY') {
                return "Dag";
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('papp')
        .directive('jhSortBy', jhSortBy);

    function jhSortBy() {
        var directive = {
            restrict: 'A',
            scope: false,
            require: '^jhSort',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, parentCtrl) {
            element.bind('click', function () {
                parentCtrl.sort(attrs.jhSortBy);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('papp')
        .directive('jhSort', jhSort);

    function jhSort () {
        var directive = {
            restrict: 'A',
            scope: {
                predicate: '=jhSort',
                ascending: '=',
                callback: '&'
            },
            controller: SortController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;
    }

    SortController.$inject = ['$scope', '$element'];

    function SortController ($scope, $element) {
        var vm = this;

        vm.applyClass = applyClass;
        vm.resetClasses = resetClasses;
        vm.sort = sort;
        vm.triggerApply = triggerApply;

        $scope.$watchGroup(['vm.predicate', 'vm.ascending'], vm.triggerApply);
        vm.triggerApply();

        function applyClass (element) {
            var thisIcon = element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt',
                remove = sortIcon + ' ' + sortDesc,
                add = sortAsc;
            if (!vm.ascending) {
                remove = sortIcon + ' ' + sortAsc;
                add = sortDesc;
            }
            vm.resetClasses();
            thisIcon.removeClass(remove);
            thisIcon.addClass(add);
        }

        function resetClasses () {
            var allThIcons = $element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt';
            allThIcons.removeClass(sortAsc + ' ' + sortDesc);
            allThIcons.addClass(sortIcon);
        }

        function sort (field) {
            if (field !== vm.predicate) {
                vm.ascending = true;
            } else {
                vm.ascending = !vm.ascending;
            }
            vm.predicate = field;
            $scope.$apply();
            vm.callback();
        }

        function triggerApply (values)  {
            vm.resetClasses();
            if (values && values[0] !== '_score') {
                vm.applyClass($element.find('th[jh-sort-by=\'' + values[0] + '\']'));
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('papp')
        .filter('platenumberInfo', platenumberInfo);

    function platenumberInfo() {
        return platenumberInfoFilter;

        function platenumberInfoFilter(platenumber) {
            var vehicleWeight = {false:"Lett kjøretøy", true: "Tungt kjøretøy", null: "Vekt ikke satt" };
            var vehicleChargeable = {false:"Ikke ladbart", true: "Ladbart", null:"Lademulighet ikke satt"};
            var chargeableType = {0:"Vanlig", 1:"Hybrid", 2:"Elbil", 3:"El-varebil", null:"Type ladbar ikke satt"};
         
            var output = [];
            output.push( vehicleWeight[platenumber.isHeavy] );
            output.push( vehicleChargeable[platenumber.isChargeable]);
            if (platenumber.isChargeable)
                output.push( chargeableType[platenumber.vehicleType]);
            

            return output.join(", ");
        }
    }
})();
(function(){
    'use strict';

    angular
        .module('papp')
        .factory('ParseLinks', ParseLinks);

    function ParseLinks () {

        var service = {
            parse : parse
        };

        return service;

        function parse(header) {
            if (header.length === 0) {
                throw new Error('input must not be of zero length');
            }

            // Split parts by comma
            var parts = header.split(',');
            var links = {};
            // Parse each part into a named link
            angular.forEach(parts, function(p) {
                var section = p.split('>;');
                if (section.length !== 2) {
                    throw new Error('section could not be split on ">;"');
                }
                var url = section[0].replace(/<(.*)/, '$1').trim();
                var queryString = {};
                url.replace(
                    new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
                    function($0, $1, $2, $3) { queryString[$1] = $3; }
                );
                var page = queryString.page;
                if (angular.isString(page)) {
                    page = parseInt(page);
                }
                var name = section[1].replace(/rel="(.*)"/, '$1').trim();
                links[name] = page;
            });
            return links;
        }
    }
})();

(function () {
    "use strict";

    angular.module("papp").factory("ParkingUtils", ParkingUtils);

    function ParkingUtils() {
        var service = {
            convertPMaksTid: convertPMaksTid,
        };

        return service;

        function convertPMaksTid(pMaksTidString) {
            switch (pMaksTidString) {
                case "Ubegrenset":
                    return null;
                case "0,25 timer":
                case "15 minutter":
                case "1 kvarter":
                    return 15;
                case "0,5 timer":
                    return 30;
                case "1 time":
                    return 60;
                case "2 timer":
                    return 120;
                case "3 timer":
                    return 180;
                case "4 timer":
                    return 240;
                case "8 timer":
                    return 480;
                case "11 timer":
                    return 660;
                case "24 timer":
                case "1 døgn":
                    return 1440;
                case "48 timer":
                case "2 døgn":
                    return 2880;
                case "1 uke":
                    return 10080;
                case "4 uker":
                    return 40320;
                default:
                    return null;
            }
        }
    }
})();

(function () {
    "use strict";

    angular.module("papp").filter("parkingMaksPTid", parkingMaksPTid);

    function parkingMaksPTid() {
        return parkingMaksPTidFilter;

        function parkingMaksPTidFilter(input) {
            switch (input) {
                case 15:
                    return "15 minutter";
                case 30:
                    return "0,5 timer";
                case 60:
                    return "1 time";
                case 120:
                    return "2 timer";
                case 180:
                    return "3 timer";
                case 240:
                    return "4 timer";
                case 480:
                    return "8 timer";
                case 660:
                    return "11 timer";
                case 1440:
                    return "1 døgn";
                case 2880:
                    return "2 døgn";
                case 10080:
                    return "1 uke";
                case 40320:
                    return "4 uker";
                default:
                    return "Ubegrenset";
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('papp')
        .factory('PaginationUtil', PaginationUtil);

    function PaginationUtil () {

        var service = {
            parseAscending : parseAscending,
            parsePage : parsePage,
            parsePredicate : parsePredicate
        };

        return service;

        function parseAscending (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                return sort.split(',').slice(-1)[0] === 'asc';
            } else {
                // default to true if no sort defined
                return true;
            }
        }

        // query params are strings, and need to be parsed
        function parsePage (page) {
            return parseInt(page);
        }

        // sort can be in the format `id,asc` or `id`
        function parsePredicate (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                sortArray.pop();
            }
            return sortArray.join(',');
        }
    }
})();

(function () {
    "use strict";

    angular.module("papp").filter("maxPTime", maxPTime);

    function maxPTime() {
        return maxPTimeFilter;

        function maxPTimeFilter(maxPTime) {
            var maxPTimeDict = {
                null: "Ubegrenset",
                15: "15 minutter",
                30: "0,5 time",
                60: "1 time",
                120: "2 timer",
                180: "3 timer",
                240: "4 timer",
                480: "8 timer",
                660: "11 timer",
                1440: "1 døgn",
                2880: "2 døgn",
                10080: "1 uke",
                40320: "4 uker",
            };
            return maxPTimeDict[maxPTime];
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('papp')
        .filter('langcodeToText', langcodeToText);

    function langcodeToText() {
        return langcodeToTextFilter;

        function langcodeToTextFilter(langcode) {
            var languages = {"nb":"Norsk", "en":"Engelsk"};
            return languages[langcode];
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('papp')
        .filter('hourToTime', hourToTime);

    function hourToTime() {
        return hourToTimeFilter;

        function hourToTimeFilter(timeString, showSeconds) {
            if (!timeString || 0 === timeString.length) {
                return null;
            }
            var timeStringList = timeString.split(":");
            timeString = "";
            timeStringList.forEach(function (timeElement) {
                if (timeElement !== "00" && timeElement < 10) {
                    timeString += "0" + timeElement + ":";
                } else {
                    timeString += timeElement + ":";
                }
            });
            
            return (showSeconds)?timeString + "00": timeString.substr(0,5);
        }
    }
})();

(function () {
    "use strict";

    angular.module("papp").factory("DateUtils", DateUtils);

    DateUtils.$inject = ["$filter"];

    function DateUtils($filter) {
        var service = {
            convertDateTimeFromServer: convertDateTimeFromServer,
            convertLocalDateFromServer: convertLocalDateFromServer,
            convertLocalDateTimeFromServer: convertLocalDateTimeFromServer,
            convertLocalDateToServer: convertLocalDateToServer,
            convertLocalDateTimeToServer: convertLocalDateTimeToServer,
            dateformat: dateformat,
        };

        return service;

        function convertDateTimeFromServer(date) {
            if (date) {
                return new Date(date);
            } else {
                return null;
            }
        }

        function convertLocalDateFromServer(date) {
            if (date) {
                var dateString = date.split(".");
                return new Date(
                    "20" + dateString[2],
                    dateString[1] - 1,
                    dateString[0]
                );
            }
            return null;
        }

        function convertLocalDateTimeFromServer(date) {
            if (date) {
                var timeDateSplit = date.split(" ");
                var dateString = timeDateSplit[0].split(".");
                var timeString = timeDateSplit[1].split(":");
                return new Date(
                    "20" + dateString[2],
                    dateString[1] - 1,
                    dateString[0],
                    timeString[0],
                    timeString[1]
                );
            }
            return null;
        }

        function convertLocalDateToServer(date) {
            if (date) {
                return $filter("date")(date, "yyyy-MM-dd");
            } else {
                return null;
            }
        }

        function convertLocalDateTimeToServer(date, hour, minute) {
            if (date) {
                date.setHours(hour);
                date.setMinutes(minute);
                return $filter("date")(date, "yyyy-MM-dd'T'HH:mm:ss");
            }
            return null;
        }

        function dateformat() {
            return "dd.MM.YY";
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('papp')
        .factory('DataUtils', DataUtils);

    DataUtils.$inject = ['$window'];

    function DataUtils ($window) {

        var service = {
            abbreviate: abbreviate,
            byteSize: byteSize,
            openFile: openFile,
            toBase64: toBase64
        };

        return service;

        function abbreviate (text) {
            if (!angular.isString(text)) {
                return '';
            }
            if (text.length < 30) {
                return text;
            }
            return text ? (text.substring(0, 15) + '...' + text.slice(-10)) : '';
        }

        function byteSize (base64String) {
            if (!angular.isString(base64String)) {
                return '';
            }

            function endsWith(suffix, str) {
                return str.indexOf(suffix, str.length - suffix.length) !== -1;
            }

            function paddingSize(base64String) {
                if (endsWith('==', base64String)) {
                    return 2;
                }
                if (endsWith('=', base64String)) {
                    return 1;
                }
                return 0;
            }

            function size(base64String) {
                return base64String.length / 4 * 3 - paddingSize(base64String);
            }

            function formatAsBytes(size) {
                return size.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' bytes';
            }

            return formatAsBytes(size(base64String));
        }

        function openFile (type, data) {
            $window.open('data:' + type + ';base64,' + data, '_blank', 'height=300,width=400');
        }

        function toBase64 (file, cb) {
            var fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = function (e) {
                var base64Data = e.target.result.substr(e.target.result.indexOf('base64,') + 'base64,'.length);
                cb(base64Data);
            };
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('papp')
        .filter('cardExpiryDate', cardExpiryDate);

    function cardExpiryDate() {
        return cardExpiryDateFilter;

        function cardExpiryDateFilter (input) {
            input = input.toString()
            return input.substring(2,4) + "/" + input.substring(0,2)
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('papp')
        .filter('capitalize', capitalize);

    function capitalize() {
        return capitalizeFilter;

        function capitalizeFilter (input) {
            if (input !== null) {
                input = input.toLowerCase();
                input = input.substring(0, 1).toUpperCase() + input.substring(1);
            }
            return input;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('papp')
        .filter('boolToNor', boolToNor);

    function boolToNor() {
        return boolToNorFilter;

        function boolToNorFilter(bool) {
            return bool ? "Ja" : "Nei";
        }
    }
})();

(function() {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('papp')
        .factory('Base64', Base64);

    function Base64 () {
        var keyStr = 'ABCDEFGHIJKLMNOP' +
            'QRSTUVWXYZabcdef' +
            'ghijklmnopqrstuv' +
            'wxyz0123456789+/' +
            '=';

        var service = {
            decode : decode,
            encode : encode
        };

        return service;

        function encode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            while (i < input.length) {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }

                output = output +
                    keyStr.charAt(enc1) +
                    keyStr.charAt(enc2) +
                    keyStr.charAt(enc3) +
                    keyStr.charAt(enc4);
            }

            return output;
        }

        function decode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

            while (i < input.length) {
                enc1 = keyStr.indexOf(input.charAt(i++));
                enc2 = keyStr.indexOf(input.charAt(i++));
                enc3 = keyStr.indexOf(input.charAt(i++));
                enc4 = keyStr.indexOf(input.charAt(i++));

                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;

                output = output + String.fromCharCode(chr1);

                if (enc3 !== 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 !== 64) {
                    output = output + String.fromCharCode(chr3);
                }
            }

            return output;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('papp')
        .directive('showValidation', showValidation);

    function showValidation () {
        var directive = {
            restrict: 'A',
            require: 'form',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, formCtrl) {
            element.find('.form-group').each(function() {
                var $formGroup = angular.element(this);
                var $inputs = $formGroup.find('input[ng-model],textarea[ng-model],select[ng-model]');

                if ($inputs.length > 0) {
                    $inputs.each(function() {
                        var $input = angular.element(this);
                        var inputName = $input.attr('name');
                        scope.$watch(function() {
                            return formCtrl[inputName].$invalid && formCtrl[inputName].$dirty;
                        }, function(isInvalid) {
                            $formGroup.toggleClass('has-error', isInvalid);
                        });
                    });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('papp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();

(function() {
    'use strict';

    angular
        .module('papp')
        .directive('minbytes', minbytes);

    function minbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.minbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) >= attrs.minbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('papp')
        .directive('maxbytes', maxbytes);

    function maxbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.maxbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) <= attrs.maxbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('papp')
        .factory('errorHandlerInterceptor', errorHandlerInterceptor);

    errorHandlerInterceptor.$inject = ['$q', '$rootScope'];

    function errorHandlerInterceptor ($q, $rootScope) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError (response) {
            if (!(response.status === 401 && (response.data === '' || (response.data.path && response.data.path.indexOf('/api/admin/account') === 0 )))) {
                $rootScope.$emit('papp.httpError', response);
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('papp')
        .factory('authExpiredInterceptor', authExpiredInterceptor);

    
    authExpiredInterceptor.$inject = ['$rootScope', '$q', '$injector', '$localStorage', '$sessionStorage'];

    function authExpiredInterceptor($rootScope, $q, $injector, $localStorage, $sessionStorage) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError(response) {
            if (response.status === 401) {
                delete $localStorage.authenticationToken;
                delete $sessionStorage.authenticationToken;
                var Principal = $injector.get('Principal');
                if (Principal.isAuthenticated()) {
                    var Auth = $injector.get('Auth');
                    Auth.authorize(true);
                }
            }
            return $q.reject(response);
        }
    }
})();

(function () {
    "use strict";

    angular.module("papp").factory("authInterceptor", authInterceptor);

    authInterceptor.$inject = [
        "$rootScope",
        "$q",
        "$location",
        "$localStorage",
        "$sessionStorage",
    ];

    function authInterceptor(
        $rootScope,
        $q,
        $location,
        $localStorage,
        $sessionStorage
    ) {
        var service = {
            request: request,
        };

        return service;

        function request(config) {
            /*jshint camelcase: false */
            config.headers = config.headers || {};
            var identity = $localStorage.identity || $sessionStorage.identity;

            if (identity && config.url.indexOf("/api/") > -1) {
                config.headers.Authorization =
                    "Bearer " + identity.access_token;
            }

            return config;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('papp')
        .factory('stateHandler', stateHandler);

    stateHandler.$inject = ['$rootScope', '$state', '$sessionStorage', '$window',
        'Auth', 'Principal', 'VERSION'];

    function stateHandler($rootScope, $state, $sessionStorage, $window,
        Auth, Principal, VERSION) {
        return {
            initialize: initialize
        };

        function initialize() {
            $rootScope.VERSION = VERSION;

            var stateChangeStart = $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams, fromState) {
                $rootScope.toState = toState;
                $rootScope.toStateParams = toStateParams;
                $rootScope.fromState = fromState;

                // Redirect to a state with an external URL (http://stackoverflow.com/a/30221248/1098564)
                if (toState.external) {
                    event.preventDefault();
                    $window.open(toState.url, '_self');
                }

                if (Principal.isIdentityResolved()) {
                    Auth.authorize();
                }


            });

            var stateChangeSuccess = $rootScope.$on('$stateChangeSuccess',  function(event, toState, toParams, fromState, fromParams) {
                var titleKey = 'Bil i Oslo' ;

                // Set the page title key to the one configured in state or use default one
                if (toState.data.pageTitle) {
                    titleKey = toState.data.pageTitle;
                }
                $window.document.title = titleKey;
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(stateChangeStart) && stateChangeStart !== null){
                    stateChangeStart();
                }
                if(angular.isDefined(stateChangeSuccess) && stateChangeSuccess !== null){
                    stateChangeSuccess();
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('papp')
        .config(paginationConfig);

    paginationConfig.$inject = ['uibPaginationConfig', 'paginationConstants'];

    function paginationConfig(uibPaginationConfig, paginationConstants) {
        uibPaginationConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPaginationConfig.maxSize = 5;
        uibPaginationConfig.boundaryLinks = true;
        uibPaginationConfig.firstText = '«';
        uibPaginationConfig.previousText = '‹';
        uibPaginationConfig.nextText = '›';
        uibPaginationConfig.lastText = '»';
    }
})();

(function () {
    'use strict';

    angular
        .module('papp')
        .config(pagerConfig);

    pagerConfig.$inject = ['uibPagerConfig', 'paginationConstants'];

    function pagerConfig(uibPagerConfig, paginationConstants) {
        uibPagerConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPagerConfig.previousText = '«';
        uibPagerConfig.nextText = '»';
    }
})();

(function() {
    'use strict';

    angular
        .module('papp')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider'];

    function localStorageConfig($localStorageProvider) {
        $localStorageProvider.setKeyPrefix('papp-');
    }
})();

(function() {
    'use strict';

    angular
        .module('papp')
        .config(httpConfig);

    httpConfig.$inject = ['$urlRouterProvider', '$httpProvider', 'httpRequestInterceptorCacheBusterProvider', '$urlMatcherFactoryProvider'];

    function httpConfig($urlRouterProvider, $httpProvider, httpRequestInterceptorCacheBusterProvider, $urlMatcherFactoryProvider) {
        
        //Cache everything except rest api requests
        httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api.*/, /.*protected.*/], true);

        $urlRouterProvider.otherwise('/');

        $httpProvider.interceptors.push('errorHandlerInterceptor');
        $httpProvider.interceptors.push('authExpiredInterceptor');
        $httpProvider.interceptors.push('authInterceptor');

        $urlMatcherFactoryProvider.type('boolean', {
            name : 'boolean',
            decode: function(val) { return val === true || val === 'true'; },
            encode: function(val) { return val ? 1 : 0; },
            equals: function(a, b) { return this.is(a) && a === b; },
            is: function(val) { return [true,false,0,1].indexOf(val) >= 0; },
            pattern: /bool|true|0|1/
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('papp')
        .config(compileServiceConfig);

    compileServiceConfig.$inject = ['$compileProvider','DEBUG_INFO_ENABLED'];

    function compileServiceConfig($compileProvider,DEBUG_INFO_ENABLED) {
        // disable debug data on prod profile to improve performance
        $compileProvider.debugInfoEnabled(DEBUG_INFO_ENABLED);

        /*
        If you wish to debug an application with this information
        then you should open up a debug console in the browser
        then call this method directly in this console:

		angular.reloadWithDebugInfo();
		*/
    }
})();

(function () {
    "use strict";

    angular.module("papp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider.state("appversion", {
            parent: "app",
            url: "/appversion",
            data: {
                authorities: ["bilioslo-admin"],
            },
            views: {
                "content@": {
                    templateUrl: "app/appversion/appversion.html",
                    controller: "AppversionController",
                    controllerAs: "vm",
                },
            },
        });
    }
})();

(function () {
    "use strict";

    angular
        .module("papp")
        .controller("AppversionController", AppversionController);

    AppversionController.$inject = [
        "Appversion",
        "DateUtils",
        "$http",
        "URL_BIL_I_OSLO_SERVICE",
    ];

    function AppversionController(
        Appversion,
        DateUtils,
        $http,
        URL_BIL_I_OSLO_SERVICE
    ) {
        var vm = this;

        vm.add = {};
        vm.add.isValid = true;
        vm.add.notifyUser = false;

        vm.openDatePicker = openDatePicker;
        vm.setValid = setValid;
        vm.setEditable = setEditable;
        vm.turnOffEditMode = turnOffEditMode;
        vm.update = update;

        vm.popupDatePicker = false;
        vm.isEditable = true;

        function setValid(parameter) {
            if (parameter == null) {
                parameter = true;
                return;
            }
            parameter = !parameter;
        }

        function setNotify(parameter) {
            if (parameter == null) {
                parameter = false;
                return;
            }
            parameter = !parameter;
        }

        function setEditable(appversion) {
            turnOffEditMode();
            appversion.isEditable = true;
        }

        function openDatePicker(appversion) {
            if (appversion.isEditable) {
                appversion.popupDatePicker = true;
                return;
            }
            appversion.popupDatePicker = false;
        }
        get();

        function get() {
            Appversion.get().$promise.then(function (appversions) {
                vm.appversions = appversions;
            });
        }

        vm.platforms = [
            {
                id: "IOS",
                name: "iOS",
            },
            {
                id: "ANDROID",
                name: "Android",
            },
        ];

        function validateInsert() {
            vm.success = null;
            vm.error = null;
            if (vm.add == null) {
                vm.error = "Felter for ny appversjon må være fylt ut";
                return;
            }
            if (vm.add.versionNumber == null || vm.add.versionNumber == "") {
                vm.error = "Versjon for ny appversjon må være fylt ut";
                return;
            }
            if (vm.add.platform == null || vm.add.platform == "") {
                vm.error = "Platform for ny appversjon må være fylt ut";
                return;
            }
            if (vm.add.releaseDate == null || vm.add.releaseDate == "") {
                vm.error = "Release dato for ny appversjon må være fylt ut";
                return;
            }
            if (vm.add.releaseDate > Date.now()) {
                vm.error = "Release dato for ny appversjon må være før i dag";
                return;
            }
            if (vm.add.isValid == null) {
                vm.error = "Gyldighet for ny appversjon må være fylt ut";
                return;
            }
            if (vm.add.notifyUser == null) {
                vm.error = "Varsling for ny appversjon må være fylt ut";
                return;
            }
        }

        function validateUpdate(appversion) {
            vm.success = null;
            vm.error = null;
            if (appversion == null) {
                vm.error = "Felter for appversjon må være fylt ut";
                return;
            }
            if (
                appversion.versionNumber == null ||
                appversion.versionNumber == ""
            ) {
                vm.error = "Versjon for appversjon må være fylt ut";
                return;
            }
            if (appversion.platform == null || appversion.platform == "") {
                vm.error = "Platform for appversjon må være fylt ut";
                return;
            }
            if (
                appversion.releaseDate == null ||
                appversion.releaseDate == ""
            ) {
                vm.error = "Release dato for appversjon må være fylt ut";
                return;
            }
            if (appversion.releaseDate > Date.now()) {
                vm.error = "Release dato for appversjon må være før i dag";
                return;
            }
            if (appversion.notifyUser == null) {
                vm.error = "Vasling for appversjon må være fylt ut";
                return;
            }
            if (appversion.isValid == null) {
                vm.error = "Gyldighet for appversjon må være fylt ut";
                return;
            }
            if (appversion.isValid == false && appversion.isNewest) {
                vm.error = "Nyeste appversjon kan ikke bli satt som ugyldig";
                return;
            }
            if (
                appversion.isValid == false &&
                (appversion.validChangeDescription == null ||
                    appversion.validChangeDescription == "")
            ) {
                vm.error = "Venligst angi hvorfor denne er satt som ugyldig";
                return;
            }
        }

        function turnOffEditMode() {
            angular.forEach(vm.appversions, function (appversion) {
                appversion.isEditable = false;
            });
        }

        vm.insert = function (event) {
            validateInsert();
            if (vm.error != null) return;
            console.log("Inserting appversion...");

            var json = angular.copy(vm.add);
            json.releaseDate = DateUtils.convertLocalDateToServer(
                vm.add.releaseDate
            );

            $http
                .post(URL_BIL_I_OSLO_SERVICE + "api/Admin/AppVersion", json, {})
                .success(function (response) {
                    console.log("Successfully added appversion");
                    vm.success = "Appversjonen er lagt til";
                    get();
                    return response;
                })
                .error(function (e, status) {
                    get();
                    if (status == 422)
                        vm.error =
                            "Dette versjonsnummeret eksisterer allerede for denne platformen";
                    else vm.error = "Feilet!";
                    console.log("Inserting appversion failed");
                });
        };

        function update(appversion) {
            validateUpdate(appversion);
            if (vm.error != null) return;

            console.log("Updating appversion...");

            var json = angular.copy(appversion);
            json.releaseDate = DateUtils.convertLocalDateToServer(
                appversion.releaseDate
            );

            $http
                .put(
                    URL_BIL_I_OSLO_SERVICE +
                        "api/Admin/AppVersion/" +
                        appversion.id,
                    json,
                    {}
                )
                .success(function (response) {
                    console.log("Successfully updated appversion");
                    vm.success = "Oppdatering vellykket!";
                    get();
                    return response;
                })
                .error(function (e, status) {
                    vm.error = "Oppdatering feilet!";
                    get();
                    if (status == 422)
                        vm.error =
                            "Versjonsnummer på denne platformen eksisterer allerede";
                    else vm.error = "Oppdatering feilet!";
                    console.log("Update of appversion failed");
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('papp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('app', {
            abstract: true,
            views: {
                'navbar@': {
                    templateUrl: 'app/layouts/navbar/navbar.html',
                    controller: 'NavbarController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                authorize: ['Auth',
                    function (Auth) {
                        return Auth.authorize();
                    }
                ]
            }
        });
    }
})();

(function () {
    "use strict";
    angular
        .module("papp")
        .constant("VERSION", bioConfig.VERSION)
        .constant("DEBUG_INFO_ENABLED", bioConfig.DEBUG_INFO_ENABLED)
        .constant("URL_BIL_I_OSLO_SERVICE", bioConfig.URL_BIL_I_OSLO_SERVICE)
        .constant("ONELOGIN_CLIENT_ID", bioConfig.ONELOGIN_CLIENT_ID)
        .constant("ONELOGIN_APP_CLIENT_ID", bioConfig.ONELOGIN_APP_CLIENT_ID)
        .constant("ONELOGIN_SUBDOMAIN", bioConfig.ONELOGIN_SUBDOMAIN)
        .constant("ONELOGIN_RESOURCE", bioConfig.ONELOGIN_RESOURCE)
        .constant("ONELOGIN_REFRESH_WHEN_REMAINING", bioConfig.ONELOGIN_REFRESH_WHEN_REMAINING)
        .constant("ONELOGIN_VERIFY_TOKEN_INTERVAL_SECONDS",bioConfig.ONELOGIN_VERIFY_TOKEN_INTERVAL_SECONDS);
})();
(function(){angular.module('papp').run(['$templateCache', function($templateCache) {$templateCache.put('app/appversion/appversion.html','<div class="row">\n    <div class="col-md-10 col-md-offset-1">\n\n        <h2>Appversjoner</h2>\n\n        <h3> Legg til ny</h3>\n        <form class="form-inline row noFocusBorder" ng-submit="vm.insert($event)" ng-click="vm.turnOffEditMode()">\n            <div class="row">\n            <div class="form-group col-md-10 col-md-2">\n                <label for="versionNumber">Versjon</label>\n                <br>\n                <input id="versionNumber" type="text" class="form-control input-sm text-uppercase" style="width: 80px" ng-model="vm.add.versionNumber" autocomplete="off">\n            </div>\n            <div class="form-group col-md-10 col-md-2">\n                <label for="platform">Platform</label>\n                <br>\n                <select id="platform" ng-model="vm.add.platform" class="form-control input-sm" autocomplete="off">\n                    <option ng-repeat="platform in vm.platforms" value="{{platform.id}}">{{platform.name}}\n                    </option>\n                </select>\n            </div>\n            <div class="form-group col-md-10 col-md-2">\n                <label for="releaseDate">Realease dato</label>\n                <br>\n                <input id="releaseDate" type="text" class="form-control input-sm" autocomplete="off" ng-model="vm.add.releaseDate" style="width: 7em" uib-datepicker-popup="dd.MM.yyyy" datepicker-options="vm.dateOptions" is-open="vm.popupDatePicker" ng-click="vm.openDatePicker(vm)" ng-model-options="{timezone:\'Europe/Paris\'}" clear-text="Nullstill" close-text="Lukk" current-text="I dag">\n            </div>\n\n            <div class="form-group col-md-10 col-md-2">\n                <label>Gyldig</label>\n                <br>\n                <toggle id="isValid" ng-model="vm.add.isValid" ng-change="vm.setValid(vm.add.isValid)" on="Gyldig" off="Ugyldig" onstyle="btn-success" offstyle="btn-danger" size="btn-sm"></toggle>\n            </div>\n\n            <div class="form-group col-md-10 col-md-2">\n                <label>Varsle</label>\n                <br>\n                <toggle id="notifyUser" ng-model="vm.add.notifyUser" ng-change="vm.setNotify(vm.add.notifyUser)" on="Varsle" off="Ikke varsle" onstyle="btn-success" offstyle="btn-danger" size="btn-sm"></toggle>\n            </div>\n            \n            <div class="form-group col-md-10 col-md-2">\n                <br>\n                <button type="submit" class="btn btn-primary btn-md">\n                    <span class="glyphicon glyphicon-plus" aria-hidden="true"></span> Legg til\n                </button>\n            </div>\n            </div>\n        </form>\n        <hr>\n        <br>\n\n        <div class="alert alert-success alert-dismissable" ng-show="vm.success">\n            {{vm.success}}\n        </div>\n        <div class="alert alert-danger fade in alert-dismissable" ng-show="vm.error">\n            {{vm.error}}\n        </div>\n\n        <h3>Utgitte appversjoner </h3>\n        <div class="row">\n            <div class="col-md-10 col-md-2">\n                <strong>Versjon</strong>\n            </div>\n            <div class="col-md-10 col-md-2">\n                <strong>Platform</strong>\n            </div>\n            <div class="col-md-10 col-md-2">\n                <strong>Release-dato</strong>\n            </div>\n            <div class="col-md-10 col-md-2">\n                <strong>Gyldig</strong>\n            </div>\n            <div class="col-md-10 col-md-2">\n                <strong>Varsle</strong>\n            </div>\n            <div class="col-md-10 col-md-2">\n                <strong>Nyeste</strong>\n            </div>\n        </div>\n        <br>\n\n        <div ng-repeat="appversion in vm.appversions" ng-mousedown="vm.setEditable(appversion)" ng-blur="vm.turnOffEditMode()" class="secondLine noFocusBorder" style="padding:12px">\n            <div class="row">\n                <div class="col-md-10 col-md-2">\n                    <input class="form-control input-sm text-uppercase" style="width: 80px; margin: 0 auto" ng-model="appversion.versionNumber" autocomplete="off" ng-disabled="!appversion.isEditable">\n                </div>\n                <div class="col-md-10 col-md-2">\n                    <select ng-model="appversion.platform" class="form-control input-sm" autocomplete="off" style="margin: 0 auto; width: 90px" ng-disabled="!appversion.isEditable">\n                        <option ng-repeat="platform in vm.platforms" ng-selected="{{appversion.platform == platform.id}}" value="{{platform.id}}">{{platform.name}}\n                        </option>\n                    </select>\n                </div>\n\n                <div class="col-md-10 col-md-2">\n                    <input class="form-control input-sm" autocomplete="off" ng-model="appversion.releaseDate" style="width: 7em" uib-datepicker-popup="dd.MM.yyyy" datepicker-options="vm.dateOptions" is-open="appversion.popupDatePicker" ng-click="vm.openDatePicker(appversion)" ng-model-options="{timezone:\'Europe/Paris\'}" clear-text="Nullstill" close-text="Lukk" current-text="I dag" ng-readonly="! appversion.isEditable">\n                </div>\n                <div class="col-md-10 col-md-2">\n                    <toggle ng-model="appversion.isValid" ng-change="vm.setValid(appversion)" on="Gyldig" off="Ugyldig" onstyle="btn-success" offstyle="btn-danger" size="btn-sm" ng-readonly="! appversion.isEditable">\n                    </toggle>\n                </div>\n                <div class="col-md-10 col-md-2">\n                    <toggle ng-model="appversion.notifyUser" ng-change="vm.setValid(appversion)" on="Varsle" off="Ikke varsle" onstyle="btn-success" offstyle="btn-danger" size="btn-sm" ng-readonly="! appversion.isEditable">\n                    </toggle>                    \n                </div>\n                <div class="col-md-10 col-md-2">\n                    <span ng-hide="!appversion.isNewest" class="label label-primary" ng-readonly="true">Nyeste</span>\n                    <span ng-hide="appversion.isNewest" class="label label-default" ng-readonly="true">Eldre</span>\n                </div>\n            </div>\n            <div class="row" ng-hide="! appversion.isEditable">\n                <br>\n                <div class="col-md-15 col-md-1">\n                    <br>\n                    Beskrivelse <br>av releasen:\n                </div>\n                <div class="col-md-15 col-md-5">\n                    <textarea class="form-control" rows="4" style="width: 100%; max-width: 100%; min-width: 100%" ng-model="appversion.releaseDescription"></textarea>\n                </div>\n                <div class="col-md-15 col-md-3">\n                    <br>\n                    Forklaring p\xE5 <br>gyldig/ugyldig:\n                </div>\n                <div class="col-md-15 col-md-3">\n                    <textarea class="form-control" rows="4" style="width: 100%; max-width: 100%; min-width: 100%" ng-model="appversion.validChangeDescription"></textarea>\n                </div>\n                <div class="col-md-15 col-md-3" ng-hide="! appversion.isEditable">\n                    <button type="submit" class="btn btn-default btn-md" ng-click="vm.update(appversion)">\n                        <span class="glyphicon glyphicon-check" aria-hidden="true"></span> Oppdater\n                    </button>\n                </div>\n            </div>\n        </div>\n\n    </div>\n</div>\n');
$templateCache.put('app/customer/customer.html','<div ng-cloak>\n    <form class="form-inline" ng-submit="vm.search($event)">\n        <div class="form-group">\n            <label for="email">E-post</label>\n            <input type="text" class="form-control input-sm text-lowercase" id="email" ng-model="vm.emailInput" autocomplete="off">\n        </div>\n        <div class="form-group">\n            <label for="plateNumber">Reg.nr.</label>\n            <input type="text" class="form-control input-sm text-uppercase" id="plateNumber" ng-model="vm.plateNumberInput" autocomplete="off">\n        </div>\n        <button type="submit" class="btn btn-default btn-sm">\n            <span class="glyphicon glyphicon-search" aria-hidden="true"></span> S\xF8k\n        </button>\n        <button type="button" class="btn btn-default btn-sm" ng-click="vm.clearSearch()">\n            <span class="glyphicon glyphicon-remove" aria-hidden="true"></span> Nullstill\n        </button>\n    </form>\n    <div class="table-responsive">\n        <table class="table table-striped table-hover">\n            <thead>\n                <tr>\n                    <th>E-post</th>\n                    <th>Opprettet</th>\n                </tr>\n            </thead>\n            <tbody>\n                <tr ng-repeat="customer in vm.customers" ng-click="vm.showCustomer(customer)">\n                    <td>{{::customer.email}}</td>\n                    <td>{{::customer.createdAt}}</td>\n                </tr>\n            </tbody>\n        </table>\n    </div>\n    <pagination-component ng-if="vm.pagination" pagination="vm.pagination" to-prev-page="vm.prevPage()" to-next-page="vm.nextPage()" to-first-page="vm.firstPage()" to-last-page="vm.lastPage()">\n\n</div>');
$templateCache.put('app/home/home.html','<div ng-cloak>\n    Du har ikke lesetilgang\n</div>\n');
$templateCache.put('app/login/login.html','<div ng-cloak>\n    <div class="row">\n        <div class="col-sm-6 col-sm-offset-3 col-md-4 col-md-offset-4">\n            <div ng-switch="vm.isAuthenticated()">\n                <form class="form">\n                    <div ng-show="!vm.isLoggingIn">\n                        <h2>Vennligst logg inn</h2>\n                        <div class="alert alert-danger" ng-show="vm.authenticationError">\n                        <strong>Feil under innlogging!</strong> {{vm.authenticationErrorMessage}}\n                        <div ng-show="vm.authenticationErrorMailTo">\n                            <a href="mailto:trond.borresen@bym.oslo.kommune.no?subject=Bil i Oslo Admin - Trenger nytt passord">Kontakt</a>\n                        </div>\n                    </div>                    \n                    <button class="btn btn-primary btn-block" ng-click="vm.login($event)" ng-show="vm.showLogin">Logg inn</button>\n                    <button class="btn btn-primary btn-block" ng-click="vm.logout()" ng-show="!vm.showLogin">Logg ut ekisterende bruker</button>\n                    </div>\n                    <div ng-show="vm.isLoggingIn">\n                        <h2>Laster <span class="glyphicon glyphicon-repeat fast-right-spinner"></span></h2>\n                        \n                    </div>\n                    <iframe style="visibility:hidden" ng-src="{{vm.oneloginframe}}" id="iframe_onelogin"></iframe>\n                </form>\n            </div>\n        </div>\n    </div>\n</div>\n');
$templateCache.put('app/messages/info-message.html','<div ng-cloak>\n    <div class="row roadMaintenance boldh4">\n        <h2>Legg inn meldinger som vises ved oppstart av appen</h2>\n\n        <div class="createInfoMessage">\n            <hr>\n            <div class="container">\n                <form>\n                    <div class="row">\n                        <div class="col-md-12">\n                            <h4 class="errormessage" ng-bind-html="vm.errorMessage"></h4>\n                        </div>\n                    </div>\n                    <div class="row">\n                        <div class="col-md-2">\n                            <input class="form-control" type="number" cols="1" placeholder="Id" style="margin-bottom: 4px" ng-model="vm.messageId">                                \n                        </div>\n                        <div class="col-md-2">                    \n                            <select class="form-control" style="margin-bottom: 4px" ng-model="vm.messageLanguage">\n                                <option value="nb">Norsk</option>\n                                <option value="en">Engelsk</option>\n                            </select>\n                        </div>\n                        <div class="col-md-2"> \n                            <input id="fromDate" type="text" class="form-control" autocomplete="off" ng-change="vm.changeDate(vm.fromDate)" uib-datepicker-popup="dd.MM.yyyy" datepicker-options="vm.dateOptions" ng-model="vm.fromDate" ng-click="vm.openDatePickerFrom()" is-open="vm.popupDatePickerFrom.opened" clear-text="Nullstill" close-text="Lukk" current-text="I dag">                            \n                        </div>\n                        <div class="col-md-2">                    \n                            <input id="untilDate" type="text" class="form-control" autocomplete="off" ng-change="vm.changeDate(vm.toDate)" uib-datepicker-popup="dd.MM.yyyy" datepicker-options="vm.dateOptions" ng-model="vm.toDate" ng-click="vm.openDatePickerTo()" is-open="vm.popupDatePickerTo.opened" clear-text="Nullstill" close-text="Lukk" current-text="I dag">\n                        </div>                                  \n                    </div>\n                    <div class="row">                    \n                        <div class="col-md-12">\n                            <p><strong>Meldingstittel:</strong></p>\n                            <input class="form-control" type="text" cols="30" style="margin-bottom: 4px" placeholder="Tittel" ng-model="vm.messageTitle">\n                        </div>\n                        <div class="col-md-12">\n                            <p><strong>Meldingstekst:</strong></p>\n                            <textarea class="form-control" type="text" rows="5" cols="30" style="margin-bottom: 4px" placeholder="Meldingstekst" ng-model="vm.messageText"></textarea>\n                            \n                        </div>\n                        <div class="col-md-12">\n                            <input class="form-control" type="text" cols="30" style="margin-bottom: 4px" placeholder="Url til nettside (https://...)" ng-model="vm.messageUrl">\n                        </div>\n                    </div>                \n                    \n                    <div class="row">\n                        <div class="col-md-8">\n                            <br>\n                            <div class="row">\n                                <div class="col-md-2">\n                                    <button type="submit" ng-click="vm.submit()" class="submitMessage btn btn-primary">\n                                        <span>Legg til melding</span>\n                                        <span class="glyphicon glyphicon-send" aria-hidden="true"></span>\n                                    </button>\n                                </div>\n                            </div>                            \n                        </div>\n                    </div>                                        \n                </form>\n            </div>\n        </div>\n        <br>\n    </div>\n    <br>\n    <div class="row roadMaintenance boldh4">\n        <h2>Historikk</h2>\n        <hr>\n        <div class="table-responsive">\n            <table class="table table-striped table-hover">\n                <thead>\n                <tr>\n                    <th class="col-xs-1">Id</th>\n                    <th class="col-xs-1">Spr\xE5k</th>\n                    <th class="col-xs-3">Tittel</th>\n                    <th class="col-xs-3">Tekst</th>                    \n                    <th class="col-xs-2">Url</th>        \n                    <th class="col-xs-1">Vises fra</th>\n                    <th class="col-xs-1">Vises til</th>\n                    <th class="col-xs-1">Slette</th>\n                </tr>\n                </thead>\n                <tbody>\n                <tr ng-repeat="message in vm.messages">\n                    <td>{{::message.messageId}}</td>\n                    <td>{{::message.language | langcodeToText}}</td>\n                    <td>{{::message.title}}</td>\n                    <td>{{::message.text}}</td>\n                    <td>{{::message.url}}</td>\n                    <td>{{::message.validFrom}}</td>\n                    <td>{{::message.validUntil}}</td>\n                    <td class="text-center"><span class="glyphicon glyphicon-remove" style="color:#d9534f" ng-click="vm.delete(message.id)"></span></td>\n                </tr>\n                </tbody>\n            </table>\n        </div>\n        <div ng-hide="vm.notifications.length != 0">\n            <p>Ingen pushvarsler er registrert om vedlikehold av vei</p>\n        </div>\n        <div class="text-center" ng-hide="vm.isOnlyOnePage">\n            <button type="button" class="btn btn-default" ng-click="vm.prevPage()" ng-disabled="vm.isFirstPage">\n                <span class="glyphicon glyphicon-menu-left" aria-hidden="true"></span> Forrige\n            </button>\n            <button type="button" class="btn btn-default" ng-click="vm.nextPage()" ng-disabled="vm.isLastPage">\n                Neste <span class="glyphicon glyphicon-menu-right" aria-hidden="true"></span>\n            </button>\n        </div>\n    </div>\n</div>\n');
$templateCache.put('app/pagination/pagination.html','<div class="text-center">\n    <button type="button" class="btn btn-default" ng-click="$ctrl.firstPage()" ng-disabled="$ctrl.isFirstPage">\n        <span class="glyphicon glyphicon-menu-left" aria-hidden="true"></span>\n        <span class="glyphicon glyphicon-menu-left" aria-hidden="true"></span>\n        F\xF8rste\n    </button>\n    <button type="button" class="btn btn-default" ng-click="$ctrl.prevPage()" ng-disabled="$ctrl.isFirstPage">\n        <span class="glyphicon glyphicon-menu-left" aria-hidden="true"></span>\n        Forrige\n    </button>\n    <span> {{$ctrl.pageStart}}-{{$ctrl.pageEnd}} av {{$ctrl.numberOfResults}} treff\n    </span>\n    <button type="button" class="btn btn-default" ng-click="$ctrl.nextPage()" ng-disabled="$ctrl.isLastPage">\n        Neste\n        <span class="glyphicon glyphicon-menu-right" aria-hidden="true"></span>\n    </button>\n    <button type="button" class="btn btn-default" ng-click="$ctrl.lastPage()" ng-disabled="$ctrl.isLastPage">\n        Siste\n        <span class="glyphicon glyphicon-menu-right" aria-hidden="true"></span>\n        <span class="glyphicon glyphicon-menu-right" aria-hidden="true"></span>\n    </button>\n</div>');
$templateCache.put('app/parking/parking.html','<div ng-cloak>\n    <form class="form-inline" ng-submit="vm.search($event)">\n        <div class="form-group">\n            <label for="plateNumber">Reg.nr.</label>\n            <input id="plateNumber" type="text" class="form-control input-sm text-uppercase" ng-model="vm.plateNumberInput" autocomplete="off">\n        </div>\n        <div class="form-group">\n            <label for="email">Kundes e-post</label>\n            <input id="email" type="text" class="form-control input-sm text-lowercase" ng-model="vm.emailInput" autocomplete="off">\n        </div>\n        <div class="form-group">\n            <label for="from">Dato start</label>\n            <input id="from" type="text" class="form-control input-sm" autocomplete="off" ng-model="vm.dateStartInput" style="width: 7em" uib-datepicker-popup="dd.MM.yyyy" datepicker-options="vm.dateOptions" is-open="vm.popupDatePicker.opened" ng-click="vm.openDatePicker()" ng-model-options="{timezone:\'+100\'}" clear-text="Nullstill" close-text="Lukk" current-text="I dag">\n        </div>\n        <div class="form-group">\n            <input type="checkbox" ng-model="vm.isNormalInput">Normal<br>\n            <input type="checkbox" ng-model="vm.isElectricInput">Elektrisk<br>\n        </div>\n        <button type="submit" class="btn btn-default btn-sm">\n            <span class="glyphicon glyphicon-search" aria-hidden="true"></span> S\xF8k\n        </button>\n        <button type="button" class="btn btn-default btn-sm" ng-click="vm.clearSearch()">\n            <span class="glyphicon glyphicon-remove" aria-hidden="true"></span> Nullstill\n        </button>\n    </form>\n    <div class="table-responsive">\n        <table class="table table-striped table-hover">\n            <thead>\n                <tr>\n                    <th>Reg.nr.</th>\n                    <th>Fra</th>\n                    <th>Til</th>\n                    <th>Takstgruppe</th>\n                    <th>Ladeplass</th>\n                    <th>Kj\xF8ret\xF8ytakst</th>\n                    <th>Bel\xF8p inkl. mva</th>\n                    <th>Kundes e-post</th>\n                </tr>\n            </thead>\n            <tbody>\n                <tr ng-repeat="parking in vm.parkings" ng-click="vm.showParking(parking)">\n                    <td>{{::parking.plateNumber}}</td>\n                    <td>{{::parking.startTime}}</td>\n                    <td>{{::parking.endTime}}</td>\n                    <td>{{::parking.zone}}</td>\n                    <td>{{::parking.isElectric  | boolToNor}}</td>\n                    <td>{{::parking.vehiclePriceGroup  | vehicleGroup}}</td>\n                    <td>{{::parking.parkingFee || \'aktiv\'}}</td>\n                    <td>{{::parking.customerEmail}}</td>\n                </tr>\n            </tbody>\n        </table>\n    </div>\n    <pagination-component ng-if="vm.pagination" pagination="vm.pagination" to-prev-page="vm.prevPage()" to-next-page="vm.nextPage()" to-first-page="vm.firstPage()" to-last-page="vm.lastPage()">\n</div>');
$templateCache.put('app/refund/refund.html','<div ng-cloak>\n    <form class="form-inline" ng-submit="vm.search($event)">\n        <div class="form-group">\n            <label for="status">Status</label>\n            <select id="status" class="form-control input-sm" ng-options="item as item.label for item in vm.statuses track by item.value" ng-model="vm.statusInput">\n                <option value="">- Velg status -</option>\n            </select>\n        </div>\n        <div class="form-group">\n            <label for="date">Dato</label>\n            <input id="date" type="text" class="form-control input-sm" autocomplete="off" ng-model="vm.dateInput" style="width: 7em" uib-datepicker-popup="dd.MM.yyyy" datepicker-options="vm.dateOptions" is-open="vm.datePopupDatePicker.opened" ng-click="vm.openDateDatePicker()" ng-model-options="{timezone:\'+100\'}" clear-text="Nullstill" close-text="Lukk" current-text="I dag">\n        </div>\n        <button type="submit" class="btn btn-default btn-sm">\n            <span class="glyphicon glyphicon-search" aria-hidden="true"></span> S\xF8k\n        </button>\n        <button type="button" class="btn btn-default btn-sm" ng-click="vm.clearSearch()">\n            <span class="glyphicon glyphicon-remove" aria-hidden="true"></span> Nullstill\n        </button>\n    </form>\n    <div class="table-responsive">\n        <table class="table table-striped table-hover">\n            <thead>\n                <tr>\n                    <th>Type</th>\n                    <th>F\xF8rste fors\xF8k</th>\n                    <th>Sist fors\xF8kt</th>\n                    <th>Antall fors\xF8k</th>\n                    <th>Status</th>\n                </tr>\n            </thead>\n            <tbody>\n                <tr ng-repeat="job in vm.jobs" ng-click="vm.showRefund(job)">\n                    <td>{{::job.type}}</td>\n                    <td>{{::job.firstAttempt}}</td>\n                    <td>{{::job.lastAttempt}}</td>\n                    <td>{{::job.numberOfAttempts}}</td>\n                    <td>{{::job.status}}</td>\n                </tr>\n            </tbody>\n        </table>\n    </div>\n    <pagination-component ng-if="vm.pagination" pagination="vm.pagination" to-prev-page="vm.prevPage()" to-next-page="vm.nextPage()" to-first-page="vm.firstPage()" to-last-page="vm.lastPage()">\n</div>');
$templateCache.put('app/studded-tire/studded-tire.html','<div ng-cloak>\n    <form class="form-inline" ng-submit="vm.search($event)">\n        <div class="form-group">\n            <label for="plateNumber">Reg.nr.</label>\n            <input id="plateNumber" type="text" class="form-control input-sm text-uppercase" ng-model="vm.plateNumberInput" autocomplete="off">\n        </div>\n        <div class="form-group">\n            <label for="email">Kundes e-post</label>\n            <input id="email" type="text" class="form-control input-sm text-lowercase" ng-model="vm.emailInput" autocomplete="off">\n        </div>\n        <div class="form-group">\n            <label for="from">Dato start</label>\n            <input id="from" type="text" class="form-control input-sm" autocomplete="off" ng-model="vm.dateStartInput" style="width: 7em" uib-datepicker-popup="dd.MM.yyyy" datepicker-options="vm.dateOptions" is-open="vm.popupDatePicker.opened" ng-click="vm.openDatePicker()" ng-model-options="{timezone:\'+100\'}" clear-text="Nullstill" close-text="Lukk" current-text="I dag">\n        </div>\n        <button type="submit" class="btn btn-default btn-sm">\n            <span class="glyphicon glyphicon-search" aria-hidden="true"></span> S\xF8k\n        </button>\n        <button type="button" class="btn btn-default btn-sm" ng-click="vm.clearSearch()">\n            <span class="glyphicon glyphicon-remove" aria-hidden="true"></span> Nullstill\n        </button>\n    </form>\n    <div class="table-responsive">\n        <table class="table table-striped table-hover">\n            <thead>\n                <tr>\n                    <th>Reg.nr.</th>\n                    <th>Serienummer</th>\n                    <th>Type</th>\n                    <th>Fra</th>\n                    <th>Til</th>\n                    <th>Bel\xF8p inkl. mva</th>\n                    <th>Kundes e-post</th>\n                    <th>Kansellert</th>\n                    <th>Refundert bel\xF8p</th>\n                </tr>\n            </thead>\n            <tbody>\n                <tr ng-repeat="studdedTire in vm.studdedTires" ng-click="vm.showStuddedTire(studdedTire)">\n                    <td>{{::studdedTire.plateNumber}}</td>\n                    <td>{{::studdedTire.serialNumber}}</td>\n                    <td>{{studdedTire.type | studdedTireType}}, {{studdedTire.isHeavy ? \'tungt\' : \'lett\'}}</td>\n                    <td>{{::studdedTire.startTime}}</td>\n                    <td>{{::studdedTire.endTime}}</td>\n                    <td>{{::studdedTire.studdedTireFee || studdedTire.pspJobStatus }}</td>\n                    <td>{{::studdedTire.customerEmail}}</td>\n                    <td>{{::studdedTire.cancelledAt}}</td>\n                    <td>{{::studdedTire.refundedAmount}}</td>\n                </tr>\n            </tbody>\n        </table>\n    </div>\n    <pagination-component ng-if="vm.pagination" pagination="vm.pagination" to-prev-page="vm.prevPage()" to-next-page="vm.nextPage()" to-first-page="vm.firstPage()" to-last-page="vm.lastPage()">\n\n</div>');
$templateCache.put('app/transaction/transaction.html','<div ng-cloak>\n    <form class="form-inline" ng-submit="vm.search($event)">\n        <div class="form-group">\n            <label for="status">Status</label>\n            <select id="status" class="form-control input-sm" ng-options="item as item.label for item in vm.statuses track by item.value" ng-model="vm.statusInput">\n                <option value="">- Velg status -</option>\n            </select>\n        </div>\n        <div class="form-group">\n            <label for="date">Dato</label>\n            <input id="date" type="text" class="form-control input-sm" autocomplete="off" ng-model="vm.dateInput" style="width: 7em" uib-datepicker-popup="dd.MM.yyyy" datepicker-options="vm.dateOptions" is-open="vm.datePopupDatePicker.opened" ng-click="vm.openDateDatePicker()" ng-model-options="{timezone:\'+100\'}" clear-text="Nullstill" close-text="Lukk" current-text="I dag">\n        </div>\n        <button type="submit" class="btn btn-default btn-sm">\n            <span class="glyphicon glyphicon-search" aria-hidden="true"></span> S\xF8k\n        </button>\n        <button type="button" class="btn btn-default btn-sm" ng-click="vm.clearSearch()">\n            <span class="glyphicon glyphicon-remove" aria-hidden="true"></span> Nullstill\n        </button>\n    </form>\n    <div class="table-responsive">\n        <table class="table table-striped table-hover">\n            <thead>\n                <tr>\n                    <th>Type</th>\n                    <th>F\xF8rste fors\xF8k</th>\n                    <th>Sist fors\xF8kt</th>\n                    <th>Antall fors\xF8k</th>\n                    <th>Status</th>\n                </tr>\n            </thead>\n            <tbody>\n                <tr ng-repeat="job in vm.jobs" ng-click="vm.showTransaction(job)">\n                    <td>{{::job.type}}</td>\n                    <td>{{::job.firstAttempt}}</td>\n                    <td>{{::job.lastAttempt}}</td>\n                    <td>{{::job.numberOfAttempts}}</td>\n                    <td>{{::job.status}}</td>\n                </tr>\n            </tbody>\n        </table>\n    </div>\n    <pagination-component ng-if="vm.pagination" pagination="vm.pagination" to-prev-page="vm.prevPage()" to-next-page="vm.nextPage()" to-first-page="vm.firstPage()" to-last-page="vm.lastPage()">\n</div>');
$templateCache.put('app/customer/details/customer.details.html','<div ng-cloak>\n\n    <div class="row">\n        <div class="col-md-8 col-md-offset-2">\n            <div class="well well-sm">\n                <h4>Kundedetaljer</h4>\n                <dl class="dl-horizontal">\n                    <dt>Id</dt>\n                    <dd>{{::vm.customerDetail.customer.id}}</dd>\n                    <dt>Opprettet</dt>\n                    <dd>{{::vm.customerDetail.customer.createdAt}}</dd>\n                    <dt>E-post</dt>\n                    <dd>{{::vm.customerDetail.customer.email}}</dd>\n                    <dt ng-show="vm.customerDetail.customer.activatedAt">Aktivert</dt>\n                    <dd ng-show="vm.customerDetail.customer.activatedAt">{{::vm.customerDetail.customer.activatedAt}}</dd>\n                    <dt ng-hide="vm.customerDetail.customer.activatedAt">Aktiveringstidsfrist</dt>\n                    <dd ng-hide="vm.customerDetail.customer.activatedAt">{{::vm.customerDetail.customer.activationDeadline}}</dd>\n                    <dt>Passord oppdatert</dt>\n                    <dd>{{::vm.customerDetail.customer.passwordUpdatedAt}}</dd>\n                    <dt>Parkeringsvarsel</dt>\n                    <dd>{{vm.customerDetail.customer.parkingEndNotice ? "Ja" : "Nei"}}</dd>\n                    <dt ng-show="vm.customerDetail.customer.lockedAt">Konto l\xE5st</dt>\n                    <dd ng-show="vm.customerDetail.customer.lockedAt">{{vm.customerDetail.customer.lockedAt}}</dd>\n                </dl>\n                <button type="button" class="btn btn-default" ng-click="vm.accessRequest()">\n                    <span class="glyphicon glyphicon-eye-open" aria-hidden="true"></span> Last ned innsynsbegj\xE6ring\n                </button>\n                <button type="button" class="btn btn-default" ng-click="vm.anonomizeRequest()" has-any-authority="bilioslo-admin-super, bilioslo-admin">\n                    <span class="glyphicon glyphicon glyphicon-ban-circle" aria-hidden="true"></span> Anonymiser bruker\n                </button>\n            </div>\n\n            <div class="well well-sm">\n                <h4>Registreringsnummer</h4>\n                <dl class="dl-horizontal">\n                    <div ng-repeat="pl in vm.customerDetail.vehicles">\n                        <dt>{{pl.plateNumber}}</dt>\n                        <dd>{{pl | platenumberInfo}}</dd>\n                    </div>\n                </dl>\n            </div>\n\n            <div class="well well-sm">\n                <h4>Kort</h4>\n                <dl class="dl-horizontal" ng-repeat="card in vm.customerDetail.paymentCards">\n                    <dt>Id</dt>\n                    <dd>{{card.id}}</dd>\n                    <dt>Type</dt>\n                    <dd>{{card.issuer}}</dd>\n                    <dt>Nummer</dt>\n                    <dd>{{card.maskedPan}}</dd>\n                    <dt>Utl\xF8psdato</dt>\n                    <dd>{{card.expiryDate | cardExpiryDate}}</dd>\n                    <dt>Lagt til</dt>\n                    <dd>{{card.createdAt}}</dd>\n                    <dt ng-show="card.deletedAt">Slettet</dt>\n                    <dd ng-show="card.deletedAt">{{card.deletedAt}}</dd>\n                </dl>\n            </div>\n        </div>\n    </div>\n\n    <div>\n        <h3>Piggdekkoblat</h3>\n        <div class="row">\n            <div class="table-responsive">\n                <table class="table table-striped table-hover">\n                    <thead>\n                    <tr>\n                        <th>Reg.nr.</th>\n                        <th>Serienummer</th>\n                        <th>Type</th>\n                        <th>Fra</th>\n                        <th>Til</th>\n                        <th>Bel\xF8p inkl. mva</th>\n                        <th>Kort</th>\n                    </tr>\n                    </thead>\n                    <tbody>\n                    <tr ng-repeat="studdedTire in vm.studdedTires" ng-click="vm.showStuddedTire(studdedTire)">\n                        <td>{{::studdedTire.plateNumber}}</td>\n                        <td>{{::studdedTire.serialNumber}}</td>\n                        <td>{{studdedTire.type | studdedTireType}}, {{studdedTire.isHeavy ? \'tungt\' : \'lett\'}}</td>\n                        <td>{{::studdedTire.startTime}}</td>\n                        <td>{{::studdedTire.endTime}}</td>\n                        <td>{{::studdedTire.studdedTireFee || studdedTire.pspJobStatus }}</td>\n                        <td>{{::studdedTire.card}}</td>\n                    </tr>\n                    </tbody>\n                </table>\n            </div>\n        </div>\n        <div class="row">\n            <div class="col-md-12 text-center">\n                <button type="button" class="btn btn-default" ng-click="vm.prevStuddedTirePage()" ng-disabled="vm.isFirstStuddedTirePage">\n                    <span class="glyphicon glyphicon-menu-left" aria-hidden="true"></span> Forrige\n                </button>\n                <button type="button" class="btn btn-default" ng-click="vm.nextStuddedTirePage()" ng-disabled="vm.isLastStuddedTirePage">\n                    Neste <span class="glyphicon glyphicon-menu-right" aria-hidden="true"></span>\n                </button>\n            </div>\n        </div>\n    </div>\n\n    <br>\n\n    <div>\n        <h3>Parkering</h3>\n        <div class="row">\n            <form class="form-inline" ng-submit="vm.searchParking($event)">\n                <div class="form-group">\n                    <label for="plateNumber">Reg.nr.</label>\n                    <input id="plateNumber" type="text" class="form-control text-uppercase" ng-model="vm.parkingPlateNumber" autocomplete="off">\n                </div>\n                <div class="form-group">\n                    <label for="from">Dato start</label>\n                    <input id="from" type="text" class="form-control" autocomplete="off" ng-model="vm.dateStart" uib-datepicker-popup="dd.MM.yyyy" datepicker-options="vm.dateOptions" is-open="vm.popupDatePicker.opened" ng-click="vm.openDatePicker()" ng-model-options="{timezone:\'+100\'}" clear-text="Nullstill" close-text="Lukk" current-text="I dag">\n                </div>\n                <button type="submit" class="btn btn-default">\n                    <span class="glyphicon glyphicon-search" aria-hidden="true"></span> S\xF8k\n                </button>\n                <button type="button" class="btn btn-default" ng-click="vm.clearParkingSearch()">\n                    <span class="glyphicon glyphicon-remove" aria-hidden="true"></span> Nullstill\n                </button>\n            </form>\n        </div>\n\n        <div class="row">\n            <div class="table-responsive">\n                <table class="table table-striped table-hover">\n                    <thead>\n                    <tr>\n                        <th>Reg.nr.</th>\n                        <th>Fra</th>\n                        <th>Til</th>\n                        <th>Takstgruppe</th>\n                        <th>Bel\xF8p inkl. mva</th>\n                        <th>Kort</th>\n                    </tr>\n                    </thead>\n                    <tbody>\n                    <tr ng-repeat="parking in vm.parkings" ng-click="vm.showParking(parking)">\n                        <td>{{::parking.plateNumber}}</td>\n                        <td>{{::parking.startTime}}</td>\n                        <td>{{::parking.endTime}}</td>\n                        <td>{{::parking.zone}}</td>\n                        <td>{{::parking.parkingFee || \'aktiv\'}}</td>\n                        <td>{{::parking.card}}</td>\n                    </tr>\n                    </tbody>\n                </table>\n            </div>\n        </div>\n        <div class="row">\n            <div class="col-md-12 text-center">\n                <button type="button" class="btn btn-default" ng-click="vm.prevParkingPage()" ng-disabled="vm.isFirstParkingPage">\n                    <span class="glyphicon glyphicon-menu-left" aria-hidden="true"></span> Forrige\n                </button>\n                <button type="button" class="btn btn-default" ng-click="vm.nextParkingPage()" ng-disabled="vm.isLastParkingPage">\n                    Neste <span class="glyphicon glyphicon-menu-right" aria-hidden="true"></span>\n                </button>\n            </div>\n        </div>\n    </div>\n    <div ng-if="vm.showLogSection">\n        <h3>Logger <div style="position:absolute"><img src="/content/images/betaMerke.png" style="position:relative;left:430px"></div></h3>\n        <div class="row">\n            <form class="form-inline" ng-submit="vm.searchLogs($event)">\n                <div class="form-group">\n                    <label for="from">Dato start</label>\n                    <input id="from" type="text" class="form-control" autocomplete="off" ng-model="vm.logStartDate" uib-datepicker-popup="dd.MM.yyyy" datepicker-options="vm.dateOptions" is-open="vm.popupLogFromDatePicker.opened" ng-click="vm.openLogFromDatePicker()" ng-model-options="{timezone:\'+100\'}" clear-text="Nullstill" close-text="Lukk" current-text="I dag">\n                </div>\n\n                <div class="form-group">\n                    <select ng-model="vm.fromLogHour" ng-options="time for time in vm.hours"></select> :\n                    <select ng-model="vm.fromLogMinute" ng-options="time for time in vm.minutes"></select>\n                    <input type="checkbox" ng-model="vm.logUnmodified"> Ubehandlet\n                </div>\n                <br>  \n                <div class="form-group">\n                    <label for="to">Dato slutt</label>\n                    <input id="to" type="text" class="form-control" autocomplete="off" ng-model="vm.logEndDate" uib-datepicker-popup="dd.MM.yyyy" datepicker-options="vm.dateOptions" is-open="vm.popupLogToDatePicker.opened" ng-click="vm.openLogToDatePicker()" ng-model-options="{timezone:\'+100\'}" clear-text="Nullstill" close-text="Lukk" current-text="I dag">\n                </div>\n\n                <div class="form-group">\n                    <select ng-model="vm.toLogHour" ng-options="time for time in vm.hours"></select> :\n                    <select ng-model="vm.toLogMinute" ng-options="time for time in vm.minutes"></select>\n                </div>\n                <button type="submit" class="btn btn-default">\n                    <span class="glyphicon glyphicon-search" aria-hidden="true"></span> S\xF8k\n                </button>    \n            </form>\n        </div>\n        <div class="row">\n            <div class="table-responsive">\n                <table class="table table-striped table-hover">\n                    <thead>\n                    <tr>\n                        <th>Tid</th>\n                        <th>Melding</th>\n                    </tr>\n                    </thead>\n                    <tbody>\n                    <tr ng-repeat="log in vm.logs track by $index">\n                        <td>{{log.time}}</td>\n                        <td>{{log.message}}</td>\n                    </tr>\n                    </tbody>\n                </table>\n            </div>\n        </div>\n    </div>\n\n</div>\n');
$templateCache.put('app/layouts/error/accessdenied.html','<div ng-cloak>\n    <div class="row">\n        <div class="col-md-4">\n            <span class="hipster img-responsive img-rounded"></span>\n        </div>\n        <div class="col-md-8">\n            <h1>Feil!</h1>\n\n            <div class="alert alert-danger">Du har ikke tilgang til denne siden.\n            </div>\n        </div>\n    </div>\n</div>\n');
$templateCache.put('app/layouts/error/error.html','<div ng-cloak>\n    <div class="row">\n        <div class="col-md-4">\n            <span class="hipster img-responsive img-rounded"></span>\n        </div>\n        <div class="col-md-8">\n            <h1>Feil!!</h1>\n\n            <div ng-show="errorMessage">\n                <div class="alert alert-danger">{{errorMessage}}\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n');
$templateCache.put('app/layouts/navbar/navbar.html','<nav class="navbar navbar-default" role="navigation">\n    <div class="navbar-header">\n        <button type="button" class="navbar-toggle" ng-click="vm.toggleNavbar()">\n            <span class="sr-only">Toggle navigation</span>\n            <span class="icon-bar"></span>\n            <span class="icon-bar"></span>\n            <span class="icon-bar"></span>\n        </button>\n        <a class="navbar-brand" href="#/" ng-click="vm.collapseNavbar()"><span>Bil i Oslo</span> <span class="navbar-version">v{{VERSION}}</span></a>\n    </div>\n    <div class="container">\n        <div class="navbar-collapse" uib-collapse="vm.isNavbarCollapsed" ng-switch="vm.isAuthenticated()">\n            <ul class="nav navbar-nav navbar-right">\n                <li ng-class="{active: vm.$state.includes(\'parking\')}" ng-switch-when="true" has-any-authority="bilioslo-admin,bilioslo-admin-lese">\n                    <a ui-sref="parking">\n                        <span class="glyphicon glyphicon-search"></span>\n                        <span class="hidden-sm">\n                            Parkering\n                        </span>\n                    </a>\n                </li>\n                <li ng-class="{active: vm.$state.includes(\'studdedTire\')}" ng-switch-when="true" has-any-authority="bilioslo-admin,bilioslo-admin-lese">\n                    <a ui-sref="studdedTire">\n                        <span class="glyphicon glyphicon-search"></span>\n                        <span class="hidden-sm">\n                            Piggdekkoblat\n                        </span>\n                    </a>\n                </li>\n                <li ng-class="{active: vm.$state.includes(\'customer\')}" ng-switch-when="true" has-any-authority="bilioslo-admin,bilioslo-admin-lese">\n                    <a ui-sref="customer">\n                        <span class="glyphicon glyphicon-user"></span>\n                        <span class="hidden-sm">\n                            Kunder\n                        </span>\n                    </a>\n                </li>\n                <li ng-class="{active: vm.$state.includes(\'infoMessage\')}" ng-switch-when="true" has-any-authority="bilioslo-admin,bilioslo-admin-lese">\n                    <a ui-sref="infoMessage">\n                        <span class="glyphicon glyphicon-comment"></span>\n                        <span class="hidden-sm">\n                            Meldinger\n                        </span>\n                    </a>\n                </li>\n                <li ng-class="{active: vm.$state.includes(\'transaction\') ||  vm.$state.includes(\'refund\')}" uib-dropdown class="dropdown pointer" ng-switch-when="true" has-any-authority="bilioslo-admin-lese,bilioslo-admin">\n                    <a class="dropdown-toggle" uib-dropdown-toggle href="" id="transaction-menu">\n                        <span class="glyphicon glyphicon-briefcase"></span>\n                        <span class="hidden-sm">\n                            Transaksjoner\n                        </span>\n                        <b class="caret"></b>\n                    </a>\n                    <ul class="dropdown-menu" uib-dropdown-menu>\n                        <li ui-sref-active="active">\n                            <a ui-sref="transaction" ng-click="vm.collapseNavbar()">\n                                <span>Kj\xF8p</span>\n                            </a>\n                        </li>\n                        <li ui-sref-active="active">\n                            <a ui-sref="refund" ng-click="vm.collapseNavbar()">\n                                <span>Refundering</span>\n                            </a>\n                        </li>\n                    </ul>\n                </li>\n                <li ng-class="{active: vm.$state.includes(\'price\')}" uib-dropdown class="dropdown pointer" ng-switch-when="true" has-any-authority="bilioslo-admin,bilioslo-admin-lese">\n                    <a class="dropdown-toggle" uib-dropdown-toggle href="" id="tariff-menu">\n                        <span>\n                            <span class="glyphicon glyphicon-road"></span>\n                            <span class="hidden-sm">\n                                Betingelser\n                            </span>\n                            <b class="caret"></b>\n                        </span>\n                    </a>\n                    <ul class="dropdown-menu" uib-dropdown-menu>\n                        <li ui-sref-active="active" has-any-authority="bilioslo-admin-lese,bilioslo-admin">\n                            <a ui-sref="parkingPrice" ng-click="vm.collapseNavbar()">\n                                <span class="glyphicon glyphicon-list"></span>&nbsp;\n                                <span>Parkeringsbetingelser</span>\n                            </a>\n                        </li>\n                        <li ui-sref-active="active" has-any-authority="bilioslo-admin-lese,bilioslo-admin">\n                            <a ui-sref="studdedTirePrice" ng-click="vm.collapseNavbar()">\n                                <span class="glyphicon glyphicon-list"></span>&nbsp;\n                                <span>Piggdekkbetingelser</span>\n                            </a>\n                        </li>\n                        <li ui-sref-active="active" has-authority="bilioslo-admin">\n                            <a ui-sref="import-parking" ng-click="vm.collapseNavbar()" id="import-parking">\n                                <span class="glyphicon glyphicon-plus"></span>\n                                <span>Endre parkeringsbetingelser</span>\n                            </a>\n                        </li>\n                        <li ui-sref-active="active" has-authority="bilioslo-admin">\n                            <a ui-sref="import-studded-tire" ng-click="vm.collapseNavbar()" id="import-studded-tire">\n                                <span class="glyphicon glyphicon-plus"></span>\n                                <span>Endre piggdekkbetingelser</span>\n                            </a>\n                        </li>\n                    </ul>\n                </li>\n                <li ng-class="{active: vm.$state.includes(\'dieselSendNotification\') || vm.$state.includes(\'dieselEditNotification\') || vm.$state.includes(\'dieselHistoryNotification\') || vm.$state.includes(\'roadMaintenanceNotification\')}" uib-dropdown class="dropdown pointer" ng-switch-when="true" has-any-authority="bilioslo-admin-dieselvarsel,bilioslo-admin-veivarsel">\n                    <a class="dropdown-toggle" uib-dropdown-toggle href="" id="notification-menu">\n                        <span>\n                            <span class="glyphicon glyphicon-phone"></span>\n                            <span class="hidden-sm">\n                                Pushvarsel\n                            </span>\n                            <b class="caret"></b>\n                        </span>\n                    </a>\n                    <ul class="dropdown-menu" uib-dropdown-menu>\n                        <li ui-sref-active="active" has-any-authority="bilioslo-admin-dieselvarsel">\n                            <a ui-sref="dieselSendNotification" ng-click="vm.collapseNavbar()">\n                                <span class="glyphicon glyphicon-send"></span>&nbsp;\n                                <span>Mobilvarsel om dieselforbud</span>\n                            </a>\n                        </li>\n                        <li ui-sref-active="active" has-any-authority="bilioslo-admin-dieselvarsel">\n                            <a ui-sref="dieselEditNotification" ng-click="vm.collapseNavbar()">\n                                <span class="glyphicon glyphicon-pencil"></span>&nbsp;\n                                <span>Endre tekster dieselforbud</span>\n                            </a>\n                        </li>\n                        <li ui-sref-active="active" has-any-authority="bilioslo-admin-dieselvarsel">\n                            <a ui-sref="dieselHistoryNotification" ng-click="vm.collapseNavbar()">\n                                <span class="glyphicon glyphicon-list"></span>&nbsp;\n                                <span>Historikk dieselforbud</span>\n                            </a>\n                        </li>\n                        <li ui-sref-active="active" has-any-authority="bilioslo-admin-veivarsel">\n                            <a ui-sref="roadMaintenanceNotification">\n                                <span class="glyphicon glyphicon-send"></span>&nbsp;\n                                <span>Vedlikehold av vei</span>\n                            </a>                            \n                        </li>\n                    </ul>\n                </li>\n                <li ng-class="{active: vm.$state.includes(\'adminUser\') || vm.$state.includes(\'config\') || vm.$state.includes(\'appversion\')}" ng-switch-when="true" has-any-authority="bilioslo-admin" uib-dropdown class="dropdown pointer">\n                    <a class="dropdown-toggle" uib-dropdown-toggle href="" id="adminUser-menu">\n                        <span>\n                            <span class="glyphicon glyphicon-tower"></span>\n                            <span class="hidden-sm">Administrasjon</span>\n                            <b class="caret"></b>\n                        </span>\n                    </a>\n                    <ul class="dropdown-menu" uib-dropdown-menu>                       \n                        <li ui-sref-active="active" has-authority="bilioslo-admin">\n                            <a ui-sref="appversion" ng-click="vm.collapseNavbar()">\n                                <span class="glyphicon glyphicon-phone"></span>&nbsp;\n                                <span>Appversjoner</span>\n                            </a>\n                        </li>\n                    </ul>\n                </li>\n                <li ng-switch-when="true" uib-dropdown class="dropdown pointer">\n                    <a class="dropdown-toggle" uib-dropdown-toggle href="" id="logout-menu">\n                        <span>\n                            <span class="glyphicon glyphicon-user"></span>\n                            <span class="hidden-sm">{{vm.userName}}</span>\n                            <b class="caret"></b>\n                        </span>\n                    </a>\n                    <ul class="dropdown-menu" uib-dropdown-menu>                       \n                        <li ui-sref-active="active">\n                            <a href="" ng-click="vm.logout()" id="logout">\n                                <span class="glyphicon glyphicon-log-out"></span>&nbsp;\n                                <span>Logg ut</span>\n                            </a>\n                        </li>\n                    </ul>                    \n                </li>\n            </ul>\n        </div>\n    </div>\n</nav>');
$templateCache.put('app/notification/diesel-edit/diesel-edit.html','<div ng-cloak>\n    <div class="container dieselBan boldh4">\n        <h2>Endre tekster i mobilvarsel for dieselforbud</h2>\n        <br>\n        <br>\n        <div class="list-group" ng-repeat="message in vm.dieselMessages">\n            <div class="list-group-item" style="border: 1px solid #aaa">\n                <a ng-click="vm.show(message)" class="list-group-item" style="border:0; margin:-10px -15px -8px -15px">\n                    <h4 ng-if="message.type==\'START\'">Start dieselforbud</h4>\n                    <h4 ng-if="message.type==\'STOP\'">Stopp dieselforbud</h4>\n                </a>\n\n                <div class="editText" ng-show="message.show">\n                    <div class="row">\n                        <br>\n\n                        <!-- Pushvarsel-norsk -->\n                        <div class="col-md-6">\n                            <div class="row">\n                                <div class="col-md-10 col-md-offset-1">\n\n                                    <p><strong>Pushvarsel - norsk:</strong></p>\n                                    <div class="form-group readOnlyBoxAroundInput" class="holder" style="margin:5px 0 5px 0">\n\n                        <textarea class="form-control fixedWidth" ng-model="message.messageNo.pushMessage" ng-readonly="! message.messageNo.isEditable.pushMessage" ng-click="vm.makeEditable(message.messageNo, \'PUSH_MESSAGE\')" rows="2">\n                        </textarea>\n                                        <div ng-if="message.type==\'START\'" style="padding: 2px 1px 2px 12px; color: #888">\n                                            {{vm.endOfMessageStartNo}}\n                                        </div>\n                                        <div ng-if="message.type==\'STOP\'" style="padding: 2px 1px 2px 12px; color: #888">\n                                            {{vm.endOfMessageStopNo}}\n                                        </div>\n                                    </div>\n                                    <div class="row">\n                                        <div class="col-md-3 col-md-offset-9 btn-group">\n                                            <button type="button" class="btn btn-danger" ng-click="vm.cancelMessage(message.messageNo, \'PUSH_MESSAGE\')" ng-hide="!message.messageNo.isEditable.pushMessage">\n                                                <span class="glyphicon glyphicon-remove" aria-hidden="true"></span>\n                                            </button>\n                                            <button type="button" class="btn btn-success pull-right" ng-click="vm.saveMessage(message.messageNo, \'PUSH_MESSAGE\')" ng-hide="!message.messageNo.isEditable.pushMessage">\n                                                <span class="glyphicon glyphicon-ok" aria-hidden="true"></span>\n                                            </button>\n                                        </div>\n                                    </div>\n                                    <div class="row" ng-hide="!message.messageNo.isError.pushMessage">\n                                        <div class="col-md-12">\n                                            <div class="alert alert-info" ng-hide="vm.info==null">\n                                                {{vm.info}}\n                                            </div>\n                                            <div class="alert alert-success" ng-hide="vm.success==null">\n                                                {{vm.success}}\n                                            </div>\n                                            <div class="alert alert-danger" ng-hide="vm.error==null">\n                                                {{vm.error}}\n                                            </div>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n\n\n                        <!-- Pushvarsel-engelsk -->\n                        <div class="col-md-6">\n                            <div class="row">\n                                <div class="col-md-10 col-md-offset-1">\n                                    <p><strong>Pushvarsel - engelsk:</strong></p>\n                                    <div class="form-group readOnlyBoxAroundInput" class="holder" style="margin:0">\n\n                        <textarea class="form-control fixedWidth" ng-model="message.messageEn.pushMessage" ng-readonly="! message.messageEn.isEditable.pushMessage" ng-click="vm.makeEditable(message.messageEn, \'PUSH_MESSAGE\')" rows="2">\n                        </textarea>\n                                        <div ng-if="message.type==\'START\'" style="padding: 2px 1px 2px 12px; color: #888">\n                                            {{vm.endOfMessageStartEn}}\n                                        </div>\n                                        <div ng-if="message.type==\'STOP\'" style="padding: 2px 1px 2px 12px; color: #888">\n                                            {{vm.endOfMessageStopEn}}\n                                        </div>\n                                    </div>\n                                    <div class="row">\n                                        <div class="col-md-3 col-md-offset-9 btn-group" style="margin-top: 5px">\n                                            <button type="button" class="btn btn-danger" ng-click="vm.cancelMessage(message.messageEn, \'PUSH_MESSAGE\')" ng-hide="!message.messageEn.isEditable.pushMessage">\n                                                <span class="glyphicon glyphicon-remove" aria-hidden="true"></span>\n                                            </button>\n                                            <button type="button" class="btn btn-success pull-right" ng-click="vm.saveMessage(message.messageEn, \'PUSH_MESSAGE\')" ng-hide="!message.messageEn.isEditable.pushMessage">\n                                                <span class="glyphicon glyphicon-ok" aria-hidden="true"></span>\n                                            </button>\n                                        </div>\n                                    </div>\n                                    <div class="row" ng-hide="!message.messageEn.isError.pushMessage">\n                                        <div class="col-md-12">\n                                            <div class="alert alert-info" ng-hide="vm.info==null">\n                                                {{vm.info}}\n                                            </div>\n                                            <div class="alert alert-success" ng-hide="vm.success==null">\n                                                {{vm.success}}\n                                            </div>\n                                            <div class="alert alert-danger" ng-hide="vm.error==null">\n                                                {{vm.error}}\n                                            </div>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                    <br>\n\n                    <div class="row">\n                        <!-- Varslingsenter-norsk -->\n                        <div class="col-md-6">\n                            <div class="row">\n                                <div class="col-md-10 col-md-offset-1">\n                                    <p><strong>Varslingsenter - norsk:</strong></p>\n                                    <!-- Title -->\n                                    <div class="form-group" class="holder" style="margin:5px 0 5px 0">\n                                        <small class="labelInside" for="editBoardTitleNo">Tittel</small>\n                                        <input class="form-control" type="text" id="editBoardTitleNo" style="font-weight: bold" placeholder="Tittel" ng-readonly="!message.messageNo.isEditable.boardTitle" ng-click="vm.makeEditable(message.messageNo, \'BOARD_TITLE\')" cols="30" ng-model="message.messageNo.boardTitle">\n                                    </div>\n                                    <div class="row">\n                                        <div class="col-md-3 col-md-offset-9 btn-group">\n                                            <button type="button" class="btn btn-danger" ng-click="vm.cancelMessage(message.messageNo, \'BOARD_TITLE\')" ng-hide="!message.messageNo.isEditable.boardTitle">\n                                                <span class="glyphicon glyphicon-remove" aria-hidden="true"></span>\n                                            </button>\n                                            <button type="button" class="btn btn-success pull-right" ng-click="vm.saveMessage(message.messageNo, \'BOARD_TITLE\')" ng-hide="!message.messageNo.isEditable.boardTitle">\n                                                <span class="glyphicon glyphicon-ok" aria-hidden="true"></span>\n                                            </button>\n                                        </div>\n                                    </div>\n                                    <div class="row" ng-hide="!message.messageNo.isError.boardTitle">\n                                        <div class="col-md-12">\n                                            <div class="alert alert-info" ng-hide="vm.info==null">\n                                                {{vm.info}}\n                                            </div>\n                                            <div class="alert alert-success" ng-hide="vm.success==null">\n                                                {{vm.success}}\n                                            </div>\n                                            <div class="alert alert-danger" ng-hide="vm.error==null">\n                                                {{vm.error}}\n                                            </div>\n                                        </div>\n                                    </div>\n                                    <!-- F\xF8rste avsnitt -->\n                                    <small class="labelInside" for="editBoardSecondMessageNo">F\xF8rste avsnitt</small>\n                                    <div class="form-group readOnlyBoxAroundInput" class="holder" style="margin:0px 0 5px 0">\n                                        <div ng-if="message.type==\'START\'" style="padding: 2px 1px 2px 12px; color: #888">\n                                            {{vm.endOfBoardFirstMessageNo[message.type]}}\n                                        </div>\n                                        <textarea class="form-control fixedWidth" ng-model="message.messageNo.boardFirstMessage" ng-readonly="!message.messageNo.isEditable.boardFirstMessage" ng-click="vm.makeEditable(message.messageNo, \'BOARD_FIRST_MESSAGE\')" rows="2">\n                        </textarea>\n                                        <div ng-if="message.type==\'STOP\'" style="padding-left: 12px; color: #888">\n                                            {{vm.endOfBoardFirstMessageNo[message.type]}}\n                                        </div>\n                                    </div>\n                                    <div class="row">\n                                        <div class="col-md-3 col-md-offset-9 btn-group">\n                                            <button type="button" class="btn btn-danger" ng-click="vm.cancelMessage(message.messageNo, \'BOARD_FIRST_MESSAGE\')" ng-hide="!message.messageNo.isEditable.boardFirstMessage">\n                                                <span class="glyphicon glyphicon-remove" aria-hidden="true"></span>\n                                            </button>\n                                            <button type="button" class="btn btn-success pull-right" ng-click="vm.saveMessage(message.messageNo, \'BOARD_FIRST_MESSAGE\')" ng-hide="!message.messageNo.isEditable.boardFirstMessage">\n                                                <span class="glyphicon glyphicon-ok" aria-hidden="true"></span>\n                                            </button>\n                                        </div>\n                                    </div>\n                                    <div class="row" ng-hide="!message.messageNo.isError.boardFirstMessage">\n                                        <div class="col-md-12">\n                                            <div class="alert alert-info" ng-hide="vm.info==null">\n                                                {{vm.info}}\n                                            </div>\n                                            <div class="alert alert-success" ng-hide="vm.success==null">\n                                                {{vm.success}}\n                                            </div>\n                                            <div class="alert alert-danger" ng-hide="vm.error==null">\n                                                {{vm.error}}\n                                            </div>\n                                        </div>\n                                    </div>\n                                    <!-- Andre avsnitt -->\n                                    <div class="form-group" class="holder" style="margin:5px 0 5px 0">\n                                        <small class="labelInside" for="editTitleNo">Andre avsnitt (kreves ikke)</small>\n                                        <textarea class="form-control fixedWidth" rows="7" cols="30" type="text" ng-readonly="!message.messageNo.isEditable.boardSecondMessage" ng-click="vm.makeEditable(message.messageNo, \'BOARD_SECOND_MESSAGE\')" ng-model="message.messageNo.boardSecondMessage"></textarea>\n                                    </div>\n                                    <div class="row">\n                                        <div class="col-md-3 col-md-offset-9 btn-group">\n                                            <button type="button" class="btn btn-danger" ng-click="vm.cancelMessage(message.messageNo, \'BOARD_SECOND_MESSAGE\')" ng-hide="!message.messageNo.isEditable.boardSecondMessage">\n                                                <span class="glyphicon glyphicon-remove" aria-hidden="true"></span>\n                                            </button>\n                                            <button type="button" class="btn btn-success pull-right" ng-click="vm.saveMessage(message.messageNo, \'BOARD_SECOND_MESSAGE\')" ng-hide="!message.messageNo.isEditable.boardSecondMessage">\n                                                <span class="glyphicon glyphicon-ok" aria-hidden="true"></span>\n                                            </button>\n                                        </div>\n                                    </div>\n                                    <div class="row" ng-hide="!message.messageNo.isError.boardSecondMessage">\n                                        <div class="col-md-12">\n                                            <div class="alert alert-info" ng-hide="vm.info==null">\n                                                {{vm.info}}\n                                            </div>\n                                            <div class="alert alert-success" ng-hide="vm.success==null">\n                                                {{vm.success}}\n                                            </div>\n                                            <div class="alert alert-danger" ng-hide="vm.error==null">\n                                                {{vm.error}}\n                                            </div>\n                                        </div>\n                                    </div>\n                                    <!-- URL -->\n                                    <div class="form-group" class="holder" style="margin:5px 0 5px 0">\n                                        <small class="labelInside" for="editUrlNo">Url</small>\n                                        <textarea class="form-control fixedWidth" id="editUrlNo" type="text" rows="2" cols="30" ng-readonly="!message.messageNo.isEditable.boardUrl" ng-click="vm.makeEditable(message.messageNo, \'BOARD_URL\')" ng-model="message.messageNo.boardUrl"></textarea>\n                                    </div>\n                                    <div class="row">\n                                        <div class="col-md-3 col-md-offset-9 btn-group">\n                                            <button type="button" class="btn btn-danger" ng-click="vm.cancelMessage(message.messageNo, \'BOARD_URL\')" ng-hide="!message.messageNo.isEditable.boardUrl">\n                                                <span class="glyphicon glyphicon-remove" aria-hidden="true"></span>\n                                            </button>\n                                            <button type="button" class="btn btn-success pull-right" ng-click="vm.saveMessage(message.messageNo, \'BOARD_URL\')" ng-hide="!message.messageNo.isEditable.boardUrl">\n                                                <span class="glyphicon glyphicon-ok" aria-hidden="true"></span>\n                                            </button>\n                                        </div>\n                                    </div>\n                                    <div class="row" ng-hide="!message.messageNo.isError.boardUrl">\n                                        <div class="col-md-12">\n                                            <div class="alert alert-info" ng-hide="vm.info==null">\n                                                {{vm.info}}\n                                            </div>\n                                            <div class="alert alert-success" ng-hide="vm.success==null">\n                                                {{vm.success}}\n                                            </div>\n                                            <div class="alert alert-danger" ng-hide="vm.error==null">\n                                                {{vm.error}}\n                                            </div>\n                                        </div>\n                                    </div>\n                                </div>\n\n                            </div>\n                        </div>\n\n                        <!-- Varslingsenter-engelsk -->\n                        <div class="col-md-6">\n                            <div class="row">\n                                <div class="col-md-10 col-md-offset-1">\n                                    <p><strong>Varslingsenter - engelsk:</strong></p>\n                                    <!-- Title -->\n                                    <div class="form-group" class="holder" style="margin:5px 0 5px 0">\n                                        <small class="labelInside" for="editBoardTitleEn">Tittel</small>\n                                        <input class="form-control" type="text" id="editBoardTitleEn" style="font-weight: bold" placeholder="Tittel" ng-readonly="!message.messageEn.isEditable.boardTitle" ng-click="vm.makeEditable(message.messageEn, \'BOARD_TITLE\')" cols="30" ng-model="message.messageEn.boardTitle">\n                                    </div>\n                                    <div class="row">\n                                        <div class="col-md-3 col-md-offset-9 btn-group">\n                                            <button type="button" class="btn btn-danger" ng-click="vm.cancelMessage(message.messageEn, \'BOARD_TITLE\')" ng-hide="!message.messageEn.isEditable.boardTitle">\n                                                <span class="glyphicon glyphicon-remove" aria-hidden="true"></span>\n                                            </button>\n                                            <button type="button" class="btn btn-success pull-right" ng-click="vm.saveMessage(message.messageEn, \'BOARD_TITLE\')" ng-hide="!message.messageEn.isEditable.boardTitle">\n                                                <span class="glyphicon glyphicon-ok" aria-hidden="true"></span>\n                                            </button>\n                                        </div>\n                                    </div>\n                                    <div class="row" ng-hide="!message.messageEn.isError.boardTitle">\n                                        <div class="col-md-12">\n                                            <div class="alert alert-info" ng-hide="vm.info==null">\n                                                {{vm.info}}\n                                            </div>\n                                            <div class="alert alert-success" ng-hide="vm.success==null">\n                                                {{vm.success}}\n                                            </div>\n                                            <div class="alert alert-danger" ng-hide="vm.error==null">\n                                                {{vm.error}}\n                                            </div>\n                                        </div>\n                                    </div>\n                                    <!-- F\xF8rste avsnitt -->\n                                    <small class="labelInside" for="editBoardSecondMessageEn">F\xF8rste avsnitt</small>\n                                    <div class="form-group readOnlyBoxAroundInput" class="holder" style="margin:0 0 5px 0">\n                                        <div ng-if="message.type==\'START\'" style="padding: 2px 1px 2px 12px; color: #888">\n                                            {{vm.endOfBoardFirstMessageEn[message.type]}}\n                                        </div>\n                                        <textarea class="form-control fixedWidth" ng-model="message.messageEn.boardFirstMessage" ng-readonly="!message.messageEn.isEditable.boardFirstMessage" ng-click="vm.makeEditable(message.messageEn, \'BOARD_FIRST_MESSAGE\')" rows="2">\n                        </textarea>\n                                        <div ng-if="message.type==\'STOP\'" style="padding-left: 12px; color: #888">\n                                            {{vm.endOfBoardFirstMessageEn[message.type]}}\n                                        </div>\n                                    </div>\n                                    <div class="row">\n                                        <div class="col-md-3 col-md-offset-9 btn-group">\n                                            <button type="button" class="btn btn-danger" ng-click="vm.cancelMessage(message.messageEn, \'BOARD_FIRST_MESSAGE\')" ng-hide="!message.messageEn.isEditable.boardFirstMessage">\n                                                <span class="glyphicon glyphicon-remove" aria-hidden="true"></span>\n                                            </button>\n                                            <button type="button" class="btn btn-success pull-right" ng-click="vm.saveMessage(message.messageEn, \'BOARD_FIRST_MESSAGE\')" ng-hide="!message.messageEn.isEditable.boardFirstMessage">\n                                                <span class="glyphicon glyphicon-ok" aria-hidden="true"></span>\n                                            </button>\n                                        </div>\n                                    </div>\n                                    <div class="row" ng-hide="!message.messageEn.isError.boardFirstMessage">\n                                        <div class="col-md-12">\n                                            <div class="alert alert-info" ng-hide="vm.info==null">\n                                                {{vm.info}}\n                                            </div>\n                                            <div class="alert alert-success" ng-hide="vm.success==null">\n                                                {{vm.success}}\n                                            </div>\n                                            <div class="alert alert-danger" ng-hide="vm.error==null">\n                                                {{vm.error}}\n                                            </div>\n                                        </div>\n                                    </div>\n                                    <!-- Andre avsnitt -->\n                                    <div class="form-group" class="holder" style="margin:5px 0 5px 0">\n                                        <small class="labelInside" for="editTitleEn">Andre avsnitt (kreves ikke)</small>\n                                        <textarea class="form-control fixedWidth" rows="7" cols="30" type="text" ng-readonly="!message.messageEn.isEditable.boardSecondMessage" ng-click="vm.makeEditable(message.messageEn, \'BOARD_SECOND_MESSAGE\')" ng-model="message.messageEn.boardSecondMessage"></textarea>\n                                    </div>\n                                    <div class="row">\n                                        <div class="col-md-3 col-md-offset-9 btn-group">\n                                            <button type="button" class="btn btn-danger" ng-click="vm.cancelMessage(message.messageEn, \'BOARD_SECOND_MESSAGE\')" ng-hide="!message.messageEn.isEditable.boardSecondMessage">\n                                                <span class="glyphicon glyphicon-remove" aria-hidden="true"></span>\n                                            </button>\n                                            <button type="button" class="btn btn-success pull-right" ng-click="vm.saveMessage(message.messageEn, \'BOARD_SECOND_MESSAGE\')" ng-hide="!message.messageEn.isEditable.boardSecondMessage">\n                                                <span class="glyphicon glyphicon-ok" aria-hidden="true"></span>\n                                            </button>\n                                        </div>\n                                    </div>\n                                    <div class="row" ng-hide="!message.messageEn.isError.boardSecondMessage">\n                                        <div class="col-md-12">\n                                            <div class="alert alert-info" ng-hide="vm.info==null">\n                                                {{vm.info}}\n                                            </div>\n                                            <div class="alert alert-success" ng-hide="vm.success==null">\n                                                {{vm.success}}\n                                            </div>\n                                            <div class="alert alert-danger" ng-hide="vm.error==null">\n                                                {{vm.error}}\n                                            </div>\n                                        </div>\n                                    </div>\n                                    <!-- URL -->\n                                    <div class="form-group" class="holder" style="margin:5px 0 5px 0">\n                                        <small class="labelInside" for="editUrlEn">Url</small>\n                                        <textarea class="form-control fixedWidth" id="editUrlEn" type="text" rows="2" cols="30" ng-readonly="!message.messageEn.isEditable.boardUrl" ng-click="vm.makeEditable(message.messageEn, \'BOARD_URL\')" ng-model="message.messageEn.boardUrl"></textarea>\n                                    </div>\n                                    <div class="row">\n                                        <div class="col-md-3 col-md-offset-9 btn-group">\n                                            <button type="button" class="btn btn-danger" ng-click="vm.cancelMessage(message.messageEn, \'BOARD_URL\')" ng-hide="!message.messageEn.isEditable.boardUrl">\n                                                <span class="glyphicon glyphicon-remove" aria-hidden="true"></span>\n                                            </button>\n                                            <button type="button" class="btn btn-success pull-right" ng-click="vm.saveMessage(message.messageEn, \'BOARD_URL\')" ng-hide="!message.messageEn.isEditable.boardUrl">\n                                                <span class="glyphicon glyphicon-ok" aria-hidden="true"></span>\n                                            </button>\n                                        </div>\n                                    </div>\n                                    <div class="row" ng-hide="!message.messageEn.isError.boardUrl">\n                                        <div class="col-md-12">\n                                            <div class="alert alert-info" ng-hide="vm.info==null">\n                                                {{vm.info}}\n                                            </div>\n                                            <div class="alert alert-success" ng-hide="vm.success==null">\n                                                {{vm.success}}\n                                            </div>\n                                            <div class="alert alert-danger" ng-hide="vm.error==null">\n                                                {{vm.error}}\n                                            </div>\n                                        </div>\n                                    </div>\n                                    <br>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n');
$templateCache.put('app/notification/diesel-history/diesel-history.html','<div ng-cloak>\n    <form class="form-inline" ng-submit="vm.search($event)" ng-hide="1">\n        <div class="form-group">\n            <label for="from">Dato start</label>\n            <input id="from" type="text" class="form-control input-sm" autocomplete="off" ng-model="vm.dateCreatedtInput" style="width: 7em" uib-datepicker-popup="dd.MM.yyyy" datepicker-options="vm.dateOptions" is-open="vm.popupDatePicker.opened" ng-click="vm.openDatePicker()" ng-model-options="{timezone:\'+100\'}" clear-text="Nullstill" close-text="Lukk" current-text="I dag">\n        </div>\n        <button type="submit" class="btn btn-default btn-sm">\n            <span class="glyphicon glyphicon-search" aria-hidden="true"></span> S\xF8k\n        </button>\n        <button type="button" class="btn btn-default btn-sm" ng-click="vm.clearSearch()">\n            <span class="glyphicon glyphicon-remove" aria-hidden="true"></span> Nullstill\n        </button>\n    </form>\n    <div class="table-responsive">\n        <table class="table table-striped table-hover">\n            <thead>\n            <tr>\n                <th class="col-xs-2">Type</th>\n                <th class="col-xs-2">Sendt av</th>\n                <th class="col-xs-3">Sendt</th>\n                <th class="col-xs-3">Gyldig fra</th>\n            </tr>\n            </thead>\n            <tbody>\n            <tr ng-repeat="notification in vm.notifications" ng-click="vm.showHistoryDetails(notification)">  <!--ng-click="vm.showParking(parking)"-->\n                <td ng-if="notification.type==\'START\'">Start</td>\n                <td ng-if="notification.type==\'STOP\'">Stopp</td>\n                <td>{{::notification.createdBy}}</td>\n                <td>{{::notification.sentAt}}</td>\n                <td>{{::notification.validFrom}}</td>\n            </tr>\n            </tbody>\n        </table>\n    </div>\n    <div ng-hide="vm.notifications.length != 0">\n        <p>Ingen pushvarsler er registrert ang. dieselforbud</p>\n    </div>\n    <div class="text-center" ng-hide="1">\n        <button type="button" class="btn btn-default" ng-click="vm.prevPage()" ng-disabled="vm.isFirstPage">\n            <span class="glyphicon glyphicon-menu-left" aria-hidden="true"></span> Forrige\n        </button>\n        <button type="button" class="btn btn-default" ng-click="vm.nextPage()" ng-disabled="vm.isLastPage">\n            Neste <span class="glyphicon glyphicon-menu-right" aria-hidden="true"></span>\n        </button>\n    </div>\n\n</div>\n');
$templateCache.put('app/notification/diesel-send/diesel-send.html','<div ng-cloak>\n    <div class="row dieselBan boldh4">\n        <h1>Send mobilvarsel om dieselforbud</h1>\n        <p>\n            <strong>\n                <span>Status: </span>\n                <span style="color:#008000" ng-if="!vm.activeDieselBan.isActive">Dieselforbud er ikke aktivt.</span>\n                <span style="color:#CC0000" ng-if="vm.activeDieselBan.isActive">Et dieselforbud er aktivt.</span>\n            </strong>\n            <span style="font-size:small">\n                <span ng-if="vm.activeDieselBan.isStarted && ! vm.activeDieselBan.isActive">\n                    Dieselforbud starter {{vm.activeDieselBan.validFrom}}.\n                </span>\n                <span ng-if="vm.activeDieselBan.isStarted && vm.activeDieselBan.isActive">\n                    Dieselforbudet startet {{vm.activeDieselBan.validFrom}}.\n                </span>\n                <span ng-if="vm.activeDieselBan.isEnded && vm.activeDieselBan.isActive">\n                    Dieselforbudet slutter {{vm.activeDieselBan.validFrom}}.\n                </span>\n                <span ng-if="vm.activeDieselBan.isEnded && ! vm.activeDieselBan.isActive">\n                    Dieselforbudet sluttet {{vm.activeDieselBan.validFrom}}.\n                </span>\n            </span>\n        </p>\n\n\n        <div class="editDieselMessage" ng-repeat="message in vm.dieselMessages">\n            <hr>\n            <div class="row">\n                <div class="col-md-3">\n                    <h3 ng-if="message.type==\'START\'">Start dieselforbud</h3>\n                    <h3 ng-if="message.type==\'STOP\'">Stopp dieselforbud</h3>\n                </div>\n            </div>\n            <div class="container">\n                <div class="row">\n                    <div class="col-md-8">\n                        <div class="row">\n                            <div class="col-md-6">\n                                <p><strong>Pushvarsel - norsk:</strong></p>\n                                <div class="lightGreyBoxes">\n                                    {{message.messageNo.pushMessage}} {{vm.endOfMessageNo[message.type]}}\n                                </div>\n                            </div>\n                            <div class="col-md-6">\n                                <p><strong>Pushvarsel - engelsk:</strong></p>\n                                <div class="lightGreyBoxes">\n                                    {{message.messageEn.pushMessage}} {{vm.endOfMessageEn[message.type]}}\n                                </div>\n                            </div>\n                        </div>\n                        <br>\n                        <div class="row">\n                            <div class="col-md-6">\n                                <p><strong>Varslingsenter - norsk:</strong></p>\n                                <div class="lightGreyBoxes">\n                                    <strong>{{message.messageNo.boardTitle}}</strong>\n                                    <br>\n                                    <br>\n                                    <div ng-if="message.type==\'START\'">\n                                        <div class="textWithNewline">{{vm.endOfBoardFirstMessageNo[message.type]}}{{message.messageNo.boardFirstMessage}}</div>\n                                    </div>\n                                    <div ng-if="message.type==\'STOP\'">\n                                        <div class="textWithNewline">{{message.messageNo.boardFirstMessage}} {{vm.endOfBoardFirstMessageNo[message.type]}}</div>\n                                    </div>\n                                    <br>\n                                    <div class="textWithNewline">{{message.messageNo.boardSecondMessage}}</div>\n                                </div>\n                            </div>\n                            <div class="col-md-6">\n                                <p><strong>Varslingsenter - engelsk:</strong></p>\n                                <div class="lightGreyBoxes">\n                                    <strong>{{message.messageEn.boardTitle}}</strong>\n                                    <br>\n                                    <br>\n                                    <div ng-if="message.type==\'START\'">\n                                        <div class="textWithNewline">{{vm.endOfBoardFirstMessageEn[message.type]}}{{message.messageEn.boardFirstMessage}}</div>\n                                    </div>\n                                    <div ng-if="message.type==\'STOP\'">\n                                        <div class="textWithNewline">{{message.messageEn.boardFirstMessage}} {{vm.endOfBoardFirstMessageEn[message.type]}}</div>\n                                    </div>\n                                    <div ng-if="message.messageEn.boardSecondMessage!=null">\n                                        <br>\n                                        <div class="textWithNewline">{{message.messageEn.boardSecondMessage}}</div>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                    <form>\n                        <div class="col-md-4">\n                            <p><strong>Gyldig fra:</strong></p>\n                            <div class="row">\n                                <div class="col-md-2">\n                                    <label for="dieselFromDate">Dato:</label>\n                                </div>\n                                <div class="col-md-9">\n                                    <input id="dieselFromDate" type="text" class="inputDate input-sm" autocomplete="off" ng-change="vm.changeDate(message)" uib-datepicker-popup="dd.MM.yyyy" datepicker-options="vm.dateOptions" ng-model="message.fromDate" ng-click="vm.openDatePickerFrom(message)" is-open="message.isFromPickerOpen" clear-text="Nullstill" close-text="Lukk" current-text="I dag">\n                                </div>\n                            </div>\n                            <div class="row">\n                                <div class="col-md-2">\n                                    <label for="dieselFromHour">Tid:</label>\n                                </div>\n                                <div class="col-md-9">\n                                    <input id="dieselFromHour" type="text" step="1" class="inputClock input-sm" ng-model="message.fromHour" ng-change="vm.changeDate(message)">\n                                    : <input id="dieselFromMin" type="text" step="1" class="inputClock input-sm" ng-model="message.fromMin" ng-change="vm.changeDate(message)">\n                                </div>\n                            </div>\n                            <br>\n                            <div class="row">\n                                <div class="col-md-12">\n                                    <button type="submit" ng-click="vm.submit(message, $index)" class="submitDiesel btn btn-primary">\n                                        <span ng-if="message.type==\'START\'">Start dieselforbud</span>\n                                        <span ng-if="message.type==\'EXTEND\'">Forleng dieselforbud</span>\n                                        <span ng-if="message.type==\'STOP\'">Stopp dieselforbud</span>\n                                        <span class="glyphicon glyphicon-send" aria-hidden="true"></span>\n                                    </button>\n                                </div>\n                            </div>\n                            <div class="row">\n                                <div class="col-md-12">\n                                    <h4 class="errormessage">{{ message.error }}</h4>\n                                </div>\n                            </div>\n                        </div>\n                    </form>\n                </div>\n            </div>\n        </div>\n        <br>\n    </div>\n</div>\n');
$templateCache.put('app/notification/history-details/notification.history.details.html','<div ng-cloak>\n    <div class="row">\n        <div class="col-md-8 col-md-offset-2">\n            <div class="well well-sm">\n                <h4>Varslingsdetaljer</h4>\n                <dl class="dl-horizontal">\n                    <dt>Id</dt>\n                    <dd>{{::vm.notification.id}}</dd>\n                    <dt>Topic</dt>\n                    <dd ng-show="vm.notification.topic == \'DIESEL\'">Dieselforbud</dd>\n                    <dd ng-show="vm.notification.topic == \'ROAD_MAINTENANCE\'">Vedlikehold av vei</dd>\n                    <dt ng-show="vm.notification.type">Type</dt>\n                    <dd ng-show="vm.notification.type == \'START\'">Start</dd>\n                    <dd ng-show="vm.notification.type == \'STOP\'">Stopp</dd>\n                    <dt>Sendt av</dt>\n                    <dd>{{::vm.notification.createdBy}}</dd>\n                    <dt>Opprettet</dt>\n                    <dd>{{::vm.notification.createdAt}}</dd>\n                    <dt>Gyldig fra</dt>\n                    <dd ng-show="vm.notification.validFrom">{{::vm.notification.validFrom}}</dd>\n                    <dd ng-show="!vm.notification.validFrom">{{::vm.notification.sentAt}}</dd>\n                    <dt>Gyldig til</dt>\n                    <dd ng-show="vm.notification.validTo">{{::vm.notification.validTo}}</dd>\n                    <dd ng-show="!vm.notification.validTo">Inntil videre</dd>\n                </dl>\n            </div>\n\n            <div class="well well-sm">\n                <h4>Pushvarsel</h4>\n                <dl class="dl-horizontal" style="margin: 0 15% 0 0">\n                    <dt>Sendt tid</dt>\n                    <dd>{{::vm.notification.sentAt}}</dd>\n                    <dt>Norsk</dt>\n                    <dd>{{::vm.notification.messageNo.pushMessage}}</dd>\n                    <dt>Engelsk</dt>\n                    <dd>{{::vm.notification.messageEn.pushMessage}}</dd>\n                </dl>\n            </div>\n\n            <div class="well well-sm">\n                <h4>Varslingsenter</h4>\n                <hr>\n                <dl class="dl-horizontal" style="margin: 0 15% 0 0">\n                    <h5 style="font-weight: bold">Norsk</h5>\n                    <dt style="font-weight: normal">Id</dt>\n                    <dd>{{::vm.notification.messageNoId}}</dd>\n                    <br>\n                    <dt style="font-weight: normal">Varsel</dt>\n                    <dd><strong>{{::vm.notification.messageNo.boardTitle}}</strong></dd>\n                    <br>\n                    <dd><span class="textWithNewline">{{::vm.notification.messageNo.boardFirstMessage}}</span></dd>\n                    <br>\n                    <dd><span class="textWithNewline">{{::vm.notification.messageNo.boardSecondMessage}}</span></dd>\n                    <br>\n                    <dt style="font-weight: normal">Url</dt>\n                    <dd>{{::vm.notification.messageNo.boardUrl}}</dd>\n                </dl>\n                <hr>\n                <dl class="dl-horizontal" style="margin: 0 15% 0 0; padding-bottom: 20px">\n                    <h5 style="font-weight: bold">Engelsk</h5>\n                    <dt style="font-weight: normal">Id</dt>\n                    <dd>{{::vm.notification.messageEnId}}</dd>\n                    <br>\n                    <dt style="font-weight: normal">Varsel</dt>\n                    <dd><strong>{{::vm.notification.messageEn.boardTitle}}</strong></dd>\n                    <br>\n                    <dd><span class="textWithNewline">{{::vm.notification.messageEn.boardFirstMessage}}</span></dd>\n                    <br>\n                    <dd><span class="textWithNewline">{{vm.notification.messageEn.boardSecondMessage}}</span></dd>\n                    <br>\n                    <dt style="font-weight: normal">Url</dt>\n                    <dd>{{::vm.notification.messageEn.boardUrl}}</dd>\n                </dl>\n            </div>\n        </div>\n    </div>\n</div>\n');
$templateCache.put('app/notification/road-maintenance/road-maintenance.html','<div ng-cloak>\n    <div class="row roadMaintenance boldh4">\n        <h2>Send pushvarsel for vedlikehold av vei</h2>\n\n        <div class="createAndSendRoadMaintenance">\n            <hr>\n            <div class="container">\n                <form>\n                    <div class="row">\n                        <div class="col-md-6">\n                            <div class="row">\n                                <div class="col-md-6">\n                                    <p><strong>Pushvarsel - norsk:</strong></p>\n                                    <textarea class="form-control" type="text" cols="30" ng-model="vm.messageNo.pushMessage"></textarea>\n                                </div>\n                                <div class="col-md-6">\n                                    <p><strong>Pushvarsel - engelsk:</strong></p>\n                                    <textarea class="form-control" type="text" cols="30" ng-model="vm.messageEn.pushMessage"></textarea>\n                                </div>\n                            </div>\n                            <br>\n                            <div class="row">\n                                <div class="col-md-6">\n                                    <p><strong>Varslingsenter - norsk:</strong></p>\n                                    <input class="form-control" type="text" cols="30" placeholder="Url til nettside (http://...)" style="margin-bottom: 4px" ng-model="vm.messageNo.boardUrl">\n                                    <input class="form-control" type="text" cols="30" placeholder="Tittel" style="margin-bottom: 4px" ng-model="vm.messageNo.boardTitle">\n                                    <textarea class="form-control" type="text" rows="5" cols="30" placeholder="F\xF8rste avsnitt" style="margin-bottom: 4px" ng-model="vm.messageNo.boardFirstMessage"></textarea>\n                                    <textarea class="form-control" type="text" rows="5" cols="30" placeholder="Andre avsnitt (kreves ikke)" style="margin-bottom: 4px" ng-model="vm.messageNo.boardSecondMessage"></textarea>\n                                </div>\n                                <div class="col-md-6">\n                                    <p><strong>Varslingsenter - engelsk:</strong></p>\n                                    <input class="form-control" type="text" cols="30" style="margin-bottom: 4px" placeholder="Url to homepage (http://...)" ng-model="vm.messageEn.boardUrl">\n                                    <input class="form-control" type="text" cols="30" style="margin-bottom: 4px" placeholder="Title" ng-model="vm.messageEn.boardTitle">\n                                    <textarea class="form-control" type="text" rows="5" cols="30" placeholder="First paragraph" style="margin-bottom: 4px" ng-model="vm.messageEn.boardFirstMessage"></textarea>\n                                    <textarea class="form-control" type="text" rows="5" cols="30" placeholder="Second paragraph (not required)" style="margin-bottom: 4px" ng-model="vm.messageEn.boardSecondMessage"></textarea>\n                                </div>\n                            </div>\n                        </div>\n                        <div class="col-md-6">\n                            <div class="row">\n                                <div class="col-md-4">\n                                    <p><strong>Gyldig til:</strong></p>\n                                    <div class="row">\n                                        <div class="col-md-3">\n                                            <label for="toDate">Dato:</label>\n                                        </div>\n                                        <div class="col-md-2">\n                                            <input id="toDate" type="text" class="inputDate input-sm" autocomplete="off" ng-change="vm.changeDate(vm.toDate)" uib-datepicker-popup="dd.MM.yyyy" datepicker-options="vm.dateOptions" ng-model="vm.toDate" ng-click="vm.openDatePickerTo()" is-open="vm.isToPickerOpen" clear-text="Nullstill" close-text="Lukk" current-text="I dag">\n                                        </div>\n                                    </div>\n                                    <div class="row">\n                                        <div class="col-md-3">\n                                            <label for="toHour">Tid:</label>\n                                        </div>\n                                        <div class="col-md-9">\n                                            <input id="toHour" type="text" step="1" class="inputClock input-sm" ng-model="vm.toHour" ng-change="vm.changeDate()">\n                                            : <input id="toMin" type="text" step="1" class="inputClock input-sm" ng-model="vm.toMin" ng-change="vm.changeDate()">\n                                        </div>\n                                    </div>\n                                </div>\n                                <div class="col-md-8">\n                                    <br>\n                                    <div class="row">\n                                        <div class="col-md-2">\n                                            <button type="submit" ng-click="vm.submit()" class="submitDiesel btn btn-primary">\n                                                <span>Send varsel</span>\n                                                <span class="glyphicon glyphicon-send" aria-hidden="true"></span>\n                                            </button>\n                                        </div>\n                                    </div>\n                                    <div class="row">\n                                        <div class="col-md-12">\n                                            <h4 class="errormessage">{{ vm.errorMessage }}</h4>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </form>\n            </div>\n        </div>\n        <br>\n    </div>\n    <br>\n    <div class="row roadMaintenance boldh4">\n        <h2>Historikk</h2>\n        <hr>\n        <div class="table-responsive">\n            <table class="table table-striped table-hover">\n                <thead>\n                <tr>\n                    <th class="col-xs-3">Sendt av</th>\n                    <th class="col-xs-3">Sendt</th>\n                    <th class="col-xs-3">Gyldig til</th>\n                </tr>\n                </thead>\n                <tbody>\n                <tr ng-repeat="notification in vm.notifications" ng-click="vm.showHistoryDetails(notification)">\n                    <td>{{::notification.createdBy}}</td>\n                    <td>{{::notification.sentAt}}</td>\n                    <td>{{::notification.validTo}}</td>\n                </tr>\n                </tbody>\n            </table>\n        </div>\n        <div ng-hide="vm.notifications.length != 0">\n            <p>Ingen pushvarsler er registrert om vedlikehold av vei</p>\n        </div>\n        <div class="text-center" ng-hide="1">\n            <button type="button" class="btn btn-default" ng-click="vm.prevPage()" ng-disabled="vm.isFirstPage">\n                <span class="glyphicon glyphicon-menu-left" aria-hidden="true"></span> Forrige\n            </button>\n            <button type="button" class="btn btn-default" ng-click="vm.nextPage()" ng-disabled="vm.isLastPage">\n                Neste <span class="glyphicon glyphicon-menu-right" aria-hidden="true"></span>\n            </button>\n        </div>\n    </div>\n</div>\n');
$templateCache.put('app/parking/details/parking.details.html','<div ng-cloak>\n\n    <div class="row">\n        <div class="col-md-6 col-md-offset-3">\n            <div class="well well-sm">\n                <h4>Parkingsdetaljer</h4>\n                <dl class="dl-horizontal">\n                    <dt>Id</dt>\n                    <dd>{{vm.parkingDetail.parking.id}}</dd>\n                    <dt>Registreringsnummer</dt>\n                    <dd>{{::vm.parkingDetail.parking.plateNumber}}</dd>\n                    <dt>Fra</dt>\n                    <dd>{{::vm.parkingDetail.parking.startTime}}</dd>\n                    <dt>Til</dt>\n                    <dd>{{::vm.parkingDetail.parking.endTime}}</dd>\n                    <dt>Takstgruppe</dt>\n                    <dd>{{::vm.parkingDetail.parking.zone}}</dd>\n                    <dt>Ladeplass</dt>\n                    <dd>{{vm.parkingDetail.parking.isElectric | boolToNor}}</dd>                    \n                    <dt>Kj\xF8ret\xF8yets prisgruppe</dt>\n                    <dd>{{vm.parkingDetail.parking.vehiclePriceGroup | vehicleGroup}}</dd>\n                    <dt>Bel\xF8p inkl. mva</dt>\n                    <dd>{{::vm.parkingDetail.parking.parkingFee}}</dd>\n                </dl>\n            </div>\n\n            <div class="well well-sm" ng-show="vm.parkingDetail.parkingChargingSession">\n                <h4>Ladesesjonsdetaljer</h4>\n                <dl class="dl-horizontal">\n                    <dt>Id</dt>\n                    <dd>{{vm.parkingDetail.parkingChargingSession.id}}</dd>\n                    <dt>SesjonsId</dt>\n                    <dd>{{vm.parkingDetail.parkingChargingSession.sessionId}}</dd>\n                    <dt>Sesjonstatus</dt>\n                    <dd>{{vm.parkingDetail.parkingChargingSession.sessionStatus}}</dd>\n                    <dt>EvseUid</dt>\n                    <dd>{{::vm.parkingDetail.parkingChargingSession.evseUid}}</dd>\n                    <dt>Lokasjon</dt>\n                    <dd>{{::vm.parkingDetail.parkingChargingSession.locationName}}</dd>\n                    <dt>Stolpe</dt>\n                    <dd>{{::vm.parkingDetail.parkingChargingSession.connectorName}}</dd>\n                    <dt>Forbruk</dt>\n                    <dd>{{::vm.parkingDetail.parkingChargingSession.kwh}}</dd>\n\n                </dl>\n            </div>\n\n            <div class="well well-sm">\n                <h4>Kunde</h4>\n                <dl class="dl-horizontal">\n                    <dt>Id</dt>\n                    <dd><a ui-sref="customerDetails({ id: vm.parkingDetail.customer.id })">{{vm.parkingDetail.customer.id}}</a></dd>\n                    <dt>Opprettet</dt>\n                    <dd>{{vm.parkingDetail.customer.createdAt}}</dd>\n                    <dt>E-postadresse</dt>\n                    <dd>{{::vm.parkingDetail.customer.email}}</dd>\n                </dl>\n            </div>\n\n            <div class="well well-sm">\n                <h4>Kort</h4>\n                <dl class="dl-horizontal" ng-if="vm.parkingDetail.paymentCard">\n                    <dt>Id</dt>\n                    <dd>{{vm.parkingDetail.paymentCard.id}}</dd>\n                    <dt>Type</dt>\n                    <dd>{{::vm.parkingDetail.paymentCard.issuer}}</dd>\n                    <dt>Nummer</dt>\n                    <dd>{{::vm.parkingDetail.paymentCard.maskedPan}}</dd>\n                    <dt>Utl\xF8psdato</dt>\n                    <dd>{{::vm.parkingDetail.paymentCard.expiryDate | cardExpiryDate}}</dd>\n                    <dt>Lagt til</dt>\n                    <dd>{{::vm.parkingDetail.paymentCard.createdAt}}</dd>\n                    <dt ng-show="vm.parkingDetail.paymentCard.deletedAt">Slettet</dt>\n                    <dd ng-show="vm.parkingDetail.paymentCard.deletedAt">{{::vm.parkingDetail.paymentCard.deletedAt}}</dd>\n                </dl>\n            </div>\n\n            <div class="well well-sm" ng-show="vm.parkingDetail.pspJob">\n                <h4>Betaling</h4>\n                <dl class="dl-horizontal">\n                    <dt>Id</dt>\n                    <dd><a ui-sref="transactionDetails({ id: vm.parkingDetail.pspJob.id })">{{::vm.parkingDetail.pspJob.id}}</a></dd>\n                    <dt>Status</dt>\n                    <dd>{{vm.parkingDetail.pspJob.statusDescriptive}}</dd>\n                </dl>\n            </div>\n\n            <div class="well well-sm" ng-if="vm.showLogSection">\n                <h4>Logger <img src="/content/images/betaMerke.png" style="position:absolute;right:20px"></h4>            \n                <div ng-if="vm.showLogButton">\n                    <select name="logFromDate" ng-model="logFromDate" ng-options="time.date as time.text for time in vm.preTimes"></select>\n                    <button type="button" ng-click="vm.searchLog()" class="btn-primary">\n                        <span>Vis loggen</span>\n                        <span class="glyphicon glyphicon-search" aria-hidden="true"></span>\n                    </button>\n                    <button type="button" ng-click="vm.searchLog(true)" class="btn-primary">\n                        <span>Vis loggen (ubehandlet)</span>\n                        <span class="glyphicon glyphicon-search" aria-hidden="true"></span>\n                    </button>\n                    <select name="logToDate" ng-model="logToDate" ng-options="time.date as time.text for time in vm.postTimes"></select>\n                </div>\n                <dl class="dl-horizontal">\n                    <ng-container ng-repeat="log in vm.logs track by $index">\n                        <dt>{{log.time}}</dt>\n                        <dd><nobr>{{log.message}}</nobr></dd>                    \n                </ng-container></dl>\n            </div>\n        </div>\n    </div>\n</div>\n');
$templateCache.put('app/price/import-parking/import-parking.html','<div class="row">\n    <h3>Importer parkeringsbetingelser</h3>\n    <br>\n\n    <p>\n        <input type="file" fileread="uploadFile"> Velg en excel fil \xE5 importere\n    </p>\n    <div ng-show="vm.parkingTariffs">\n        <h3>Nye betingelser for parkering</h3>\n        <div class="table-responsive">            \n            <table class="table table-hover" style="border: 1px solid black">\n                <thead>\n                <tr>\n                    <th colspan="2" class="info text-center">Takstgruppe</th>\n                    <th colspan="2" class="text-center">Maks</th>\n                    <th class="info text-center">Plass</th>\n                    <th colspan="2" class="text-center">Avgiftstid hverdag</th>\n                    <th colspan="2" class="info text-center">Avgiftstid l\xF8rdag</th>\n                    <th colspan="2" class="text-center">Avgiftstid s\xF8ndag</th>\n                    <th colspan="11" class="text-center info">Takst</th>\n                </tr>\n                <tr>\n                    <th class="info">Sone</th>\n                    <th class="info">Type</th>            \n                    <th><nobr>p-tid</nobr></th>\n                    <th>takst</th>\n                    <th class="info">Lading</th>\n                    <th>start</th>\n                    <th>stopp</th>\n                    <th class="info">start</th>\n                    <th class="info">stopp</th>\n                    <th>start</th>\n                    <th>stopp</th>\n                    <th class="info">30m</th>\n                    <th class="info">1t</th>\n                    <th class="info">sekund\xE6r</th>\n                    <th class="info">1,5t</th>\n                    <th class="info">2t</th>\n                    <th class="info">3t</th>\n                    <th class="info">4t</th>\n                    <th class="info">+30m</th>\n                    <th class="info">d\xF8gn</th>\n                    <th class="info">uke</th>\n                    <th class="info"><nobr>4 uker</nobr></th>\n                </tr>\n                </thead>\n                <tbody>\n                <tr ng-repeat="priceGroup in vm.parkingTariffs">\n                    <td class="info">{{priceGroup.priceGroup}}</td>\n                    <td class="info">{{priceGroup.vehiclePriceGroup | vehicleGroup}}</td>\n                    <td>{{priceGroup.maxParkingTime | parkingMaksPTid}}</td>\n                    <td>{{priceGroup.maxPrice}}</td>\n                    <td class="info">{{priceGroup.isElectric | boolToNor}}</td>\n                    <td>{{priceGroup.mondayStart | hourToTime:false}}</td>\n                    <td>{{priceGroup.mondayStop | hourToTime:false}}</td>\n                    <td class="info">{{priceGroup.saturdayStart | hourToTime:false}}</td>\n                    <td class="info">{{priceGroup.saturdayStop | hourToTime:false}}</td>\n                    <td>{{priceGroup.sundayStart | hourToTime:false}}</td>\n                    <td>{{priceGroup.sundayStop | hourToTime:false}}</td>\n                    <td class="info">{{priceGroup.priceThirtyMinutes}}</td>\n                    <td class="info">{{priceGroup.priceHour}}</td>\n                    <td class="info">{{priceGroup.priceHourSecondary}}</td>\n                    <td class="info">{{priceGroup.priceNinetyMinutes}}</td>\n                    <td class="info">{{priceGroup.priceTwoHours}}</td>\n                    <td class="info">{{priceGroup.priceThreeHours}}</td>\n                    <td class="info">{{priceGroup.priceFourHours}}</td>\n                    <td class="info">{{priceGroup.priceAdditionalThirtyMinutes}}</td>\n                    <td class="info">{{priceGroup.priceDay}}</td>\n                    <td class="info">{{priceGroup.priceWeek}}</td>\n                    <td class="info">{{priceGroup.priceFourWeeks}}</td>\n                </tr>\n                </tbody>\n            </table>\n        </div>\n        <form class="form-inline" ng-submit="vm.save()">\n            <div class="form-group">\n                <label for="from">Dato fra og med</label>\n                <input id="from" type="text" class="form-control" autocomplete="off" ng-model="vm.dateFrom" uib-datepicker-popup="dd.MM.yyyy" datepicker-options="vm.dateOptions" is-open="vm.popupDatePicker.opened" ng-click="vm.openDatePicker()" ng-model-options="{timezone:\'+100\'}" clear-text="Nullstill" close-text="Lukk" current-text="I dag">\n            </div>\n            <div class="form-group">\n                <label for="to">Dato til (ikke med)</label>\n                <input id="to" type="text" class="form-control" autocomplete="off" ng-model="vm.dateTo" uib-datepicker-popup="dd.MM.yyyy" datepicker-options="vm.dateOptions" is-open="vm.popupDatePicker.opened" ng-click="vm.openDatePicker()" ng-model-options="{timezone:\'+100\'}" clear-text="Nullstill" close-text="Lukk" current-text="I dag">\n            </div>\n            <button type="submit" class="btn btn-default">\n                <span class="glyphicon glyphicon-save" aria-hidden="true"></span> Lagre\n            </button>\n            <span class="errormessageImport" style="font-weight:bold; font-size:16px">{{ vm.result }}</span>\n        </form>\n    </div>\n    <br>\n</div>\n');
$templateCache.put('app/price/import-studded-tire/import-studded-tire.html','<!DOCTYPE html>\n<div ng-cloak>\n    <div class="studdedTireImport boldh4" data-ng-controller="ImportStuddedTireController">\n        <div class="row">\n            <h3>Oppdater betingelser for piggdekkoblat</h3>\n        </div>\n        <form ng-submit="vm.updatePrices()">\n            <div ng-repeat="price in vm.studdedTirePrices">\n                    <h4>{{price.type | studdedTireType}}</h4>\n                    <div class="row">\n                        <div class="col-md-1">\n                            <label for="notHeavyImport">Pris lett:</label>\n                        </div>\n                        <div class="col-md-1">\n                            <input type="number" step="any" id="notHeavyImport" ng-model="price.price" class="form-control importInput">\n                        </div>\n                        <div class="col-md-1">\n                            <label for="heavyImport">Pris tung:</label>\n                        </div>\n                        <div class="col-md-1">\n                            <input type="number" step="any" id="heavyImport" ng-model="price.heavyPrice" class="form-control importInput">\n                        </div>\n                        <div class="col-md-1 form-group">\n                            <label for="buyFromImport">Salgstart:</label>\n                        </div>\n                        <div class="col-md-2">\n                            <input id="buyFromImport" type="text" class="form-control importDate" autocomplete="off" uib-datepicker-popup="dd.MM.yyyy" ng-model="price.buyFrom" ng-click="vm.openDatePickerNotHeavy(price.id)" is-open="price.isNotHeavyOpen" clear-text="Nullstill" close-text="Lukk" current-text="I dag">\n                        </div>\n                        <div class="col-md-1">\n                            <label for="buyToImport">Salgslutt:</label>\n                        </div>\n                        <div class="col-md-2">\n                            <input id="buyToImport" type="text" class="form-control importDate" autocomplete="off" uib-datepicker-popup="dd.MM.yyyy" datepicker-options="vm.dateOptions" ng-model="price.buyTo" ng-click="vm.openDatePickerHeavy(price.id)" is-open="price.isHeavyOpen" clear-text="Nullstill" close-text="Lukk" current-text="I dag">\n                        </div>\n                    </div>\n                    <hr>\n            </div>\n            <div class="row">\n                <div class="col-md-2 col-md-offset-0">\n                    <input type="submit" value="Oppdater priser" class="btn btn-primary">\n                </div>\n                <div class="col-md-4 col-md-offset-0">\n                    <h4 class="errormessageImport">{{ vm.studdedTireResult }}</h4>\n                </div>\n            </div>\n        </form>\n    </div>\n</div>\n\n');
$templateCache.put('app/price/parking/parking-price.html','<div ng-cloak>\n    <div class="row">\n        <h3>Alle parkeringsbetingelser</h3>\n        <p>Parkeringer gjelder fra og med startdato, og til (men ikke med!) sluttdato.</p>\n        <div class="list-group">\n            <a ui-sref="parkingPriceDetails({ prices: price })" class="list-group-item" ng-class="{\'list-group-item-success\': price.isActive}" ng-repeat="price in vm.prices">\n                <span class="badge" ng-show="price.isActive">aktiv</span>\n                    Gyldig periode {{price.validFrom}} - {{price.validTo}}\n            </a>\n        </div>\n    </div>\n</div>\n');
$templateCache.put('app/price/studded-tire/studded-tire-price.html','<div ng-cloak>\n    <div class="row">\n        <h3>Aktuelle betingelser for piggdekkoblat</h3>\n        <div class="table-responsive">\n            <table class="table table-hover" style="border: 1px solid black">\n                <thead>\n                <tr>\n                    <th>Oblattype</th>\n                    <th>Lett bil</th>\n                    <th>Tung bil</th>\n                    <th>Salgsstart</th>\n                    <th>Salgsslutt</th>\n                </tr>\n                </thead>\n                <tbody>\n                <tr ng-repeat="price in vm.studdedTirePrices">\n                    <td>{{price.type | studdedTireType}}</td>\n                    <td>{{price.price}}</td>\n                    <td>{{price.heavyPrice}}</td>\n                    <td>{{price.buyFrom | date:\'d. MMM yyyy\'}}</td>\n                    <td>{{price.buyTo | date:\'d. MMM yyyy\'}}</td>\n                </tr>\n                </tbody>\n            </table>\n        </div>\n        <div class="row">\n            <div class="col-md-4 col-md-offset-0">\n                    <span>\n                        <strong>Sesong:</strong>\n                        {{vm.season.seasonStart | date:\'d. MMM yyyy\'}} - {{vm.season.seasonEnd | date:\'d. MMM yyyy\'}}\n                    </span>\n            </div>\n        </div>\n    </div>\n</div>\n');
$templateCache.put('app/refund/details/refund.details.html','<div ng-cloak>\n\n    <div class="row">\n        <div class="col-md-8 col-md-offset-2">\n            <div class="well well-sm">\n                <h4>Detaljer</h4>\n                <dl class="dl-horizontal">\n                    <dt>F\xF8rste fors\xF8k</dt>\n                    <dd>{{::vm.job.firstAttempt}}</dd>\n                    <dt>Sist fors\xF8kt</dt>\n                    <dd>{{::vm.job.lastAttempt}}</dd>\n                    <dt>Antall fors\xF8k</dt>\n                    <dd>{{::vm.job.numberOfAttempts}}</dd>\n                    <dt>Status</dt>\n                    <dd>{{vm.job.statusDescriptive}}</dd>\n                    <dt ng-show="vm.job.parkingId">Parking</dt>\n                    <dd ng-show="vm.job.parkingId"><a ui-sref="parkingDetails({ id: vm.job.parkingId })">{{::vm.job.parkingId}}</a></dd>\n                    <dt ng-show="vm.job.studdedTireId">Piggdekkoblat</dt>\n                    <dd ng-show="vm.job.studdedTireId"><a ui-sref="studdedTireDetails({ id: vm.job.studdedTireId })">{{::vm.job.studdedTireId}}</a></dd>\n                </dl>\n            </div>\n        </div>\n    </div>\n\n    <div class="row">\n        <div class="table-responsive">\n            <table class="table table-striped">\n                <thead>\n                <tr>\n                    <th>Tidspunkt</th>\n                    <th>Responskode</th>\n                    <th>Responskilde</th>\n                    <th>Responsetekst</th>\n                </tr>\n                </thead>\n                <tbody>\n                <tr ng-repeat="transaction in vm.transactions">\n                    <td>{{::transaction.createdAt}}</td>\n                    <td>{{::transaction.code}}</td>\n                    <td>{{::transaction.source}}</td>\n                    <td>{{::transaction.text}}</td>\n                </tr>\n                </tbody>\n            </table>\n        </div>\n    </div>\n    <div class="row">\n        <div class="col-md-12 text-center">\n            <button type="button" class="btn btn-default" ng-click="vm.prevTransactionPage()" ng-disabled="vm.isFirstTransactionPage">\n                <span class="glyphicon glyphicon-menu-left" aria-hidden="true"></span> Forrige\n            </button>\n            <button type="button" class="btn btn-default" ng-click="vm.nextTransactionPage()" ng-disabled="vm.isLastTransactionPage">\n                Neste <span class="glyphicon glyphicon-menu-right" aria-hidden="true"></span>\n            </button>\n        </div>\n    </div>\n</div>\n');
$templateCache.put('app/studded-tire/details/studded-tire.details.html','<div ng-cloak>\n\n    <div class="row">\n        <div class="col-md-6 col-md-offset-3">\n            <div class="well well-sm">\n                <h4>Piggdekkoblatdetaljer</h4>\n                <dl class="dl-horizontal">\n                    <dt>Id</dt>\n                    <dd>{{vm.studdedTireDetail.studdedTire.id}}</dd>\n                    <dt>Registreringsnummer</dt>\n                    <dd>{{::vm.studdedTireDetail.studdedTire.plateNumber}}</dd>\n                    <dt>Opprettet</dt>\n                    <dd>{{::vm.studdedTireDetail.studdedTire.createdAt}}</dd>\n                    <dt>Fra</dt>\n                    <dd>{{::vm.studdedTireDetail.studdedTire.startTime}}</dd>\n                    <dt>Til</dt>\n                    <dd>{{::vm.studdedTireDetail.studdedTire.endTime}}</dd>\n                    <dt>Serienummer</dt>\n                    <dd>{{::vm.studdedTireDetail.studdedTire.serialNumber}}</dd>\n                    <dt>Type</dt>\n                    <dd>{{vm.studdedTireDetail.studdedTire.type | studdedTireType}}, {{vm.studdedTireDetail.studdedTire.isHeavy ? \'tungt\' : \'lett\'}}</dd>\n                    <dt>Bel\xF8p inkl. mva</dt>\n                    <dd>{{::vm.studdedTireDetail.studdedTire.studdedTireFee}}</dd>\n                    <dt ng-show="vm.studdedTireDetail.studdedTire.cancelledAt">Kansellert</dt>\n                    <dd ng-show="vm.studdedTireDetail.studdedTire.cancelledAt">{{::vm.studdedTireDetail.studdedTire.cancelledAt}}</dd>\n                    <dt ng-show="vm.studdedTireDetail.studdedTire.cancelledAt">Refundert bel\xF8p</dt>\n                    <dd ng-show="vm.studdedTireDetail.studdedTire.cancelledAt">{{::vm.studdedTireDetail.studdedTire.refundedAmount}}</dd>\n                    <dt ng-show="vm.studdedTireDetail.studdedTire.vehicleChangedAt">Byttet reg.nr.</dt>\n                    <dd ng-show="vm.studdedTireDetail.studdedTire.vehicleChangedAt">{{::vm.studdedTireDetail.studdedTire.vehicleChangedAt}}</dd>\n                    <dt ng-show="vm.studdedTireDetail.studdedTire.vehicleChangedAt">Tidligere reg.nr.</dt>\n                    <dd ng-show="vm.studdedTireDetail.studdedTire.vehicleChangedAt">{{::vm.studdedTireDetail.studdedTire.oldPlateNumber}}</dd>\n                </dl>\n            </div>\n\n            <div class="well well-sm">\n                <h4>Kunde</h4>\n                <dl class="dl-horizontal">\n                    <dt>Id</dt>\n                    <dd><a ui-sref="customerDetails({ id: vm.studdedTireDetail.customer.id })">{{vm.studdedTireDetail.customer.id}}</a></dd>\n                    <dt>Opprettet</dt>\n                    <dd>{{vm.studdedTireDetail.customer.createdAt}}</dd>\n                    <dt>E-postadresse</dt>\n                    <dd>{{::vm.studdedTireDetail.customer.email}}</dd>\n                </dl>\n            </div>\n\n            <div class="well well-sm">\n                <h4>Kort</h4>\n                <dl class="dl-horizontal" ng-if="vm.studdedTireDetail.paymentCard">\n                    <dt>Id</dt>\n                    <dd>{{vm.studdedTireDetail.paymentCard.id}}</dd>\n                    <dt>Type</dt>\n                    <dd>{{::vm.studdedTireDetail.paymentCard.issuer}}</dd>\n                    <dt>Nummer</dt>\n                    <dd>{{::vm.studdedTireDetail.paymentCard.maskedPan}}</dd>\n                    <dt>Utl\xF8psdato</dt>\n                    <dd>{{::vm.studdedTireDetail.paymentCard.expiryDate | cardExpiryDate}}</dd>\n                    <dt>Lagt til</dt>\n                    <dd>{{::vm.studdedTireDetail.paymentCard.createdAt}}</dd>\n                    <dt ng-show="vm.parking.paymentCard.deletedAt">Slettet</dt>\n                    <dd ng-show="vm.parking.paymentCard.deletedAt">{{::vm.studdedTireDetail.paymentCard.deletedAt}}</dd>\n                </dl>\n            </div>\n\n            <div class="well well-sm" ng-show="vm.studdedTireDetail.pspJob">\n                <h4>Betaling</h4>\n                <dl class="dl-horizontal">\n                    <dt>Id</dt>\n                    <dd><a ui-sref="transactionDetails({ id: vm.studdedTireDetail.pspJob.id })">{{::vm.studdedTireDetail.pspJob.id}}</a></dd>\n                    <dt>Status</dt>\n                    <dd>{{vm.studdedTireDetail.pspJob.status}}</dd>\n                </dl>\n            </div>\n\n            <div class="well well-sm" ng-show="vm.studdedTireDetail.refundPspJob">\n                <h4>Refundering</h4>\n                <dl class="dl-horizontal">\n                    <dt>Id</dt>\n                    <dd><a ui-sref="refundDetails({ id: vm.studdedTireDetail.refundPspJob.id })">{{::vm.studdedTireDetail.refundPspJob.id}}</a></dd>\n                    <dt>Status</dt>\n                    <dd>{{vm.studdedTireDetail.refundPspJob.statusDescriptive}}</dd>\n                </dl>\n            </div>\n        </div>\n    </div>\n</div>\n');
$templateCache.put('app/transaction/details/transaction.details.html','<div ng-cloak>\n\n    <div class="row">\n        <div class="col-md-8 col-md-offset-2">\n            <div class="well well-sm">\n                <h4>Detaljer</h4>\n                <dl class="dl-horizontal">\n                    <dt>F\xF8rste fors\xF8k</dt>\n                    <dd>{{::vm.job.firstAttempt}}</dd>\n                    <dt>Sist fors\xF8kt</dt>\n                    <dd>{{::vm.job.lastAttempt}}</dd>\n                    <dt>Antall fors\xF8k</dt>\n                    <dd>{{::vm.job.numberOfAttempts}}</dd>\n                    <dt>Status</dt>\n                    <dd>{{vm.job.statusDescriptive}}</dd>\n                    <dt ng-show="vm.job.parkingId">Parking</dt>\n                    <dd ng-show="vm.job.parkingId"><a ui-sref="parkingDetails({ id: vm.job.parkingId })">{{::vm.job.parkingId}}</a></dd>\n                    <dt ng-show="vm.job.studdedTireId">Piggdekkoblat</dt>\n                    <dd ng-show="vm.job.studdedTireId"><a ui-sref="studdedTireDetails({ id: vm.job.studdedTireId })">{{::vm.job.studdedTireId}}</a></dd>\n                </dl>\n            </div>\n        </div>\n    </div>\n\n    <div class="row">\n        <div class="table-responsive">\n            <table class="table table-striped">\n                <thead>\n                <tr>\n                    <th>Tidspunkt</th>\n                    <th>Responskode</th>\n                    <th>Responskilde</th>\n                    <th>Responsetekst</th>\n                </tr>\n                </thead>\n                <tbody>\n                <tr ng-repeat="transaction in vm.transactions">\n                    <td>{{::transaction.createdAt}}</td>\n                    <td>{{::transaction.code}}</td>\n                    <td>{{::transaction.source}}</td>\n                    <td>{{::transaction.text}}</td>\n                </tr>\n                </tbody>\n            </table>\n        </div>\n    </div>\n    <div class="row">\n        <div class="col-md-12 text-center">\n            <button type="button" class="btn btn-default" ng-click="vm.prevTransactionPage()" ng-disabled="vm.isFirstTransactionPage">\n                <span class="glyphicon glyphicon-menu-left" aria-hidden="true"></span> Forrige\n            </button>\n            <button type="button" class="btn btn-default" ng-click="vm.nextTransactionPage()" ng-disabled="vm.isLastTransactionPage">\n                Neste <span class="glyphicon glyphicon-menu-right" aria-hidden="true"></span>\n            </button>\n        </div>\n    </div>\n</div>\n');
$templateCache.put('app/notification/diesel-send/modal/diesel-send-modal.html','<div>\n    <div class="modal-content">\n        <div class="modal-header">\n            <h3 class="modal-title" id="modal-title-start" ng-if="vm.message.type==\'START\'">Starte dieselforbud</h3>\n            <h3 class="modal-title" id="modal-title-stop" ng-if="vm.message.type==\'STOP\'">Stoppe dieselforbud</h3>\n        </div>\n            <div class="modal-body" id="modal-body">\n                <p>\n                    Varsel om\n                    <strong>\n                    <span ng-if="vm.message.type==\'START\'">start</span>\n                    <span ng-if="vm.message.type==\'STOP\'">stopp</span>\n                    </strong>\n                    av dieselforbud gyldig fra\n                    <strong>{{vm.message.fromDateTime | date:"EEEE dd.MM \'kl\' HH.mm" }}</strong>\n                    vil bli sendt direkte som pushvarsel til alle kunder som \xF8nsker varsling om\n                    dieselforbud i Bil i Oslo-appen.\n                    <br>\n                    Er du sikker p\xE5 at du vil sende varsling?\n                </p>\n                <br>\n                <div class="row">\n                    <div class="col-md-6">\n                        <h4>Varsel som sendes:</h4>\n                    </div>\n                </div>\n                <div class="row">\n                    <div class="col-md-6">\n                        <p>\n                            <strong>Norsk:</strong>\n                            <br>\n                            {{vm.message.messageNo.pushMessageModal}}\n                        </p>\n                    </div>\n                    <div class="col-md-6">\n                        <p>\n                            <strong>Engelsk:</strong>\n                            <br>\n                            {{vm.message.messageEn.pushMessageModal}}\n                        </p>\n                    </div>\n                </div>\n                <br>\n                <p ng-if="vm.lastNotification.type != vm.message.type && vm.lastNotification.type==\'STOP\'" style="font-size:small">\n                    Forrige dieselforbud-varsling om\n                    <span ng-if="vm.lastNotification.type==\'START\'">start</span>\n                    <span ng-if="vm.lastNotification.type==\'STOP\'">stopp</span>\n                    ble sendt {{vm.lastNotification.validFrom}}.\n                </p>\n                <p class="alert alert-warning" ng-if="vm.lastNotification.type != vm.message.type && vm.lastNotification.type==\'START\'" style="font-size:small">\n                    Forrige dieselforbud\n                    <span ng-if="vm.lastNotification.type==\'START\'">startet</span>\n                    <span ng-if="vm.lastNotification.type==\'STOP\'">stoppet</span>\n                    {{vm.lastNotification.validFrom}}.\n                </p>\n                <p class="alert alert-danger" ng-if="vm.lastNotification.type == vm.message.type" style="font-size:small">\n                    Forrige dieselforbud\n                    <span ng-if="vm.lastNotification.type==\'START\'">startet</span>\n                    <span ng-if="vm.lastNotification.type==\'STOP\'">stoppet</span>\n                    {{vm.lastNotification.validFrom}}.\n                </p>\n            </div>\n            <div class="modal-footer ng-scope">\n                <button class="btn btn-primary" type="button" ng-click="vm.ok()">OK</button>\n                <button class="btn btn-warning" type="button" ng-click="vm.cancel()">Cancel</button>\n            </div>\n        </div>\n    </div>\n\n');
$templateCache.put('app/notification/road-maintenance/modal/road-maintenance-modal.html','<div>\n    <div class="modal-content">\n        <div class="modal-header">\n            <h3 class="modal-title" id="modal-title-start" ng-if="vm.message.type==\'START\'">Starte dieselforbud</h3>\n            <h3 class="modal-title" id="modal-title-stop" ng-if="vm.message.type==\'STOP\'">Stoppe dieselforbud</h3>\n        </div>\n            <div class="modal-body" id="modal-body">\n                <p>\n                    Varsel om vedlikehold av veg med gyldighet til\n                    <strong>{{vm.message.validTo | date:"EEEE dd.MM \'kl\' HH.mm" }}</strong>\n                    blir sendt direkte som pushvarsel til alle kunder som \xF8nsker slike varsler\n                    i Bil i Oslo-appen.\n                    <br>\n                    Er du sikker p\xE5 at du vil sende varsling?\n                </p>\n                <br>\n                <div class="row">\n                    <div class="col-md-6">\n                        <h4>Varsel som sendes:</h4>\n                    </div>\n                </div>\n                <div class="row">\n                    <div class="col-md-6">\n                        <p>\n                            <strong>Norsk:</strong>\n                            <br>\n                            {{vm.message.messageNo.pushMessage}}\n                        </p>\n                    </div>\n                    <div class="col-md-6">\n                        <p>\n                            <strong>Engelsk:</strong>\n                            <br>\n                            {{vm.message.messageEn.pushMessage}}\n                        </p>\n                    </div>\n                </div>\n                <br>\n            </div>\n            <div class="modal-footer ng-scope">\n                <button class="btn btn-primary" type="button" ng-click="vm.ok()">OK</button>\n                <button class="btn btn-warning" type="button" ng-click="vm.cancel()">Cancel</button>\n            </div>\n        </div>\n    </div>\n\n');
$templateCache.put('app/price/parking/details/parking-price.details.html','<div ng-cloak>\n    <div class="row">\n        <h3>Parkeringsbetingelser</h3>\n        <h4>Gyldig periode {{vm.prices.validFrom}} - {{vm.prices.validTo}} </h4>\n        <div ng-if="vm.prices.isActive">\n            <h4 style="color:#008000">Aktiv</h4>\n        </div>\n        <div ng-if="!vm.prices.isActive">\n            <h4 style="color:#CC0000">Inaktiv</h4>\n        </div>\n        <div class="table-responsive">\n            <table class="table table-hover" style="border: 1px solid black">\n                <thead>\n                <tr>\n                    <th colspan="2" class="info text-center">Takstgruppe</th>\n                    <th colspan="2" class="text-center">Maks</th>\n                    <th class="info text-center">Plass</th>\n                    <th colspan="2" class="text-center">Avgiftstid hverdag</th>\n                    <th colspan="2" class="info text-center">Avgiftstid l\xF8rdag</th>\n                    <th colspan="2" class="text-center">Avgiftstid s\xF8ndag</th>\n                    <th colspan="11" class="text-center info">Takst</th>\n                </tr>\n                <tr>\n                    <th class="info">Sone</th>\n                    <th class="info">Type</th>            \n                    <th><nobr>p-tid</nobr></th>\n                    <th>takst</th>\n                    <th class="info">Lading</th>\n                    <th>start</th>\n                    <th>stopp</th>\n                    <th class="info">start</th>\n                    <th class="info">stopp</th>\n                    <th>start</th>\n                    <th>stopp</th>\n                    <th class="info">30m</th>\n                    <th class="info">1t</th>\n                    <th class="info">sekund\xE6r</th>\n                    <th class="info">1,5t</th>\n                    <th class="info">2t</th>\n                    <th class="info">3t</th>\n                    <th class="info">4t</th>\n                    <th class="info">+30m</th>\n                    <th class="info">d\xF8gn</th>\n                    <th class="info">uke</th>\n                    <th class="info"><nobr>4 uker</nobr></th>\n                </tr>\n                </thead>\n                <tbody>\n                <tr ng-repeat="priceGroup in vm.prices.groups">\n                    <td class="info">{{priceGroup.priceGroup}}</td>\n                    <td class="info">{{priceGroup.vehiclePriceGroup | vehicleGroup}}</td>\n                    <td>{{priceGroup.maxParkingTime | maxPTime}}</td>\n                    <td>{{priceGroup.maxPrice}}</td>\n                    <td class="info">{{priceGroup.isElectric | boolToNor}}</td>\n                    <td>{{priceGroup.mondayStart}}</td>\n                    <td>{{priceGroup.mondayStop}}</td>\n                    <td class="info">{{priceGroup.saturdayStart}}</td>\n                    <td class="info">{{priceGroup.saturdayStop}}</td>\n                    <td>{{priceGroup.sundayStart}}</td>\n                    <td>{{priceGroup.sundayStop}}</td>\n                    <td class="info">{{priceGroup.priceThirtyMinutes}}</td>\n                    <td class="info">{{priceGroup.priceHour}}</td>\n                    <td class="info">{{priceGroup.priceHourSecondary}}</td>\n                    <td class="info">{{priceGroup.priceNinetyMinutes}}</td>\n                    <td class="info">{{priceGroup.priceTwoHours}}</td>\n                    <td class="info">{{priceGroup.priceThreeHours}}</td>\n                    <td class="info">{{priceGroup.priceFourHours}}</td>\n                    <td class="info">{{priceGroup.priceAdditionalThirtyMinutes}}</td>\n                    <td class="info">{{priceGroup.priceDay}}</td>\n                    <td class="info">{{priceGroup.priceWeek}}</td>\n                    <td class="info">{{priceGroup.priceFourWeeks}}</td>\n                </tr>\n                </tbody>\n            </table>\n        </div>\n    </div>\n</div>\n');}]);})();